"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Spinner API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompatibilityApiFetchParamCreator = exports.CobrowsingApi = exports.CobrowsingApiFactory = exports.CobrowsingApiFp = exports.CobrowsingApiFetchParamCreator = exports.CallsApi = exports.CallsApiFactory = exports.CallsApiFp = exports.CallsApiFetchParamCreator = exports.CalendarsApi = exports.CalendarsApiFactory = exports.CalendarsApiFp = exports.CalendarsApiFetchParamCreator = exports.BotsApi = exports.BotsApiFactory = exports.BotsApiFp = exports.BotsApiFetchParamCreator = exports.BillingsApi = exports.BillingsApiFactory = exports.BillingsApiFp = exports.BillingsApiFetchParamCreator = exports.AgentStatusesApi = exports.AgentStatusesApiFactory = exports.AgentStatusesApiFp = exports.AgentStatusesApiFetchParamCreator = exports.AgentGroupsApi = exports.AgentGroupsApiFactory = exports.AgentGroupsApiFp = exports.AgentGroupsApiFetchParamCreator = exports.WidgetButtonsInput = exports.UserRole = exports.UrlParameter = exports.SnoozedStatus = exports.RegisterInPushService = exports.ModelTrainingStatus = exports.MessageWidgetConfigContextType = exports.MatchingStrategy = exports.InboxSorting = exports.InboxEntryType = exports.EventActionEvent = exports.ConversationStatus = exports.ChangeBotTypeForm = exports.BotInfo = exports.ArtichokePresence = exports.AppicationErrorReason = exports.AppPresence = exports.AppPermission = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
exports.OplAddressApiFactory = exports.OplAddressApiFp = exports.OplAddressApiFetchParamCreator = exports.OIDCApi = exports.OIDCApiFactory = exports.OIDCApiFp = exports.OIDCApiFetchParamCreator = exports.OAuthApi = exports.OAuthApiFactory = exports.OAuthApiFp = exports.OAuthApiFetchParamCreator = exports.NLUApi = exports.NLUApiFactory = exports.NLUApiFp = exports.NLUApiFetchParamCreator = exports.MessageWidgetsApi = exports.MessageWidgetsApiFactory = exports.MessageWidgetsApiFp = exports.MessageWidgetsApiFetchParamCreator = exports.MeetingsApi = exports.MeetingsApiFactory = exports.MeetingsApiFp = exports.MeetingsApiFetchParamCreator = exports.MainNotificationsApi = exports.MainNotificationsApiFactory = exports.MainNotificationsApiFp = exports.MainNotificationsApiFetchParamCreator = exports.KnowledgeBasesApi = exports.KnowledgeBasesApiFactory = exports.KnowledgeBasesApiFp = exports.KnowledgeBasesApiFetchParamCreator = exports.InviteesApi = exports.InviteesApiFactory = exports.InviteesApiFp = exports.InviteesApiFetchParamCreator = exports.FilesApi = exports.FilesApiFactory = exports.FilesApiFp = exports.FilesApiFetchParamCreator = exports.EventActionsApi = exports.EventActionsApiFactory = exports.EventActionsApiFp = exports.EventActionsApiFetchParamCreator = exports.ConversationsApi = exports.ConversationsApiFactory = exports.ConversationsApiFp = exports.ConversationsApiFetchParamCreator = exports.CompatibilityApi = exports.CompatibilityApiFactory = exports.CompatibilityApiFp = void 0;
exports.TagsApiFetchParamCreator = exports.TagMappingsApi = exports.TagMappingsApiFactory = exports.TagMappingsApiFp = exports.TagMappingsApiFetchParamCreator = exports.TagGroupsApi = exports.TagGroupsApiFactory = exports.TagGroupsApiFp = exports.TagGroupsApiFetchParamCreator = exports.TagGroupTransfersParametersApi = exports.TagGroupTransfersParametersApiFactory = exports.TagGroupTransfersParametersApiFp = exports.TagGroupTransfersParametersApiFetchParamCreator = exports.TagGroupTransfersApi = exports.TagGroupTransfersApiFactory = exports.TagGroupTransfersApiFp = exports.TagGroupTransfersApiFetchParamCreator = exports.StatusApi = exports.StatusApiFactory = exports.StatusApiFp = exports.StatusApiFetchParamCreator = exports.SessionApi = exports.SessionApiFactory = exports.SessionApiFp = exports.SessionApiFetchParamCreator = exports.RoomsApi = exports.RoomsApiFactory = exports.RoomsApiFp = exports.RoomsApiFetchParamCreator = exports.RolesApi = exports.RolesApiFactory = exports.RolesApiFp = exports.RolesApiFetchParamCreator = exports.PushApi = exports.PushApiFactory = exports.PushApiFp = exports.PushApiFetchParamCreator = exports.ProfanitiesApi = exports.ProfanitiesApiFactory = exports.ProfanitiesApiFp = exports.ProfanitiesApiFetchParamCreator = exports.ProactiveMsgApi = exports.ProactiveMsgApiFactory = exports.ProactiveMsgApiFp = exports.ProactiveMsgApiFetchParamCreator = exports.OrgsApi = exports.OrgsApiFactory = exports.OrgsApiFp = exports.OrgsApiFetchParamCreator = exports.OplAddressApi = void 0;
exports.WidgetsFormsSubmissionsApi = exports.WidgetsFormsSubmissionsApiFactory = exports.WidgetsFormsSubmissionsApiFp = exports.WidgetsFormsSubmissionsApiFetchParamCreator = exports.WebhooksApi = exports.WebhooksApiFactory = exports.WebhooksApiFp = exports.WebhooksApiFetchParamCreator = exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiFetchParamCreator = exports.UrlTagMappingsApi = exports.UrlTagMappingsApiFactory = exports.UrlTagMappingsApiFp = exports.UrlTagMappingsApiFetchParamCreator = exports.UnreadApi = exports.UnreadApiFactory = exports.UnreadApiFp = exports.UnreadApiFetchParamCreator = exports.TopicsApi = exports.TopicsApiFactory = exports.TopicsApiFp = exports.TopicsApiFetchParamCreator = exports.TagsApi = exports.TagsApiFactory = exports.TagsApiFp = void 0;
const url = require("url");
const isomorphicFetch = require("isomorphic-fetch");
const BASE_PATH = "/api".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = isomorphicFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
exports.RequiredError = RequiredError;
/**
 *
 * @export
 * @enum {string}
 */
var AppPermission;
(function (AppPermission) {
    AppPermission["AdminPermission"] = "admin_permission";
    AppPermission["DisplayClosedConversations"] = "display_closed_conversations";
    AppPermission["DisplayWaitingConversations"] = "display_waiting_conversations";
    AppPermission["DisplayFollowedConversations"] = "display_followed_conversations";
    AppPermission["DisplayInProgressConversations"] = "display_in_progress_conversations";
    AppPermission["DisplayYoursConversations"] = "display_yours_conversations";
    AppPermission["SettingsProactiveMessages"] = "settings_proactive_messages";
    AppPermission["SettingsTags"] = "settings_tags";
    AppPermission["SettingsAiSuggestions"] = "settings_ai_suggestions";
    AppPermission["SettingsWebhooks"] = "settings_webhooks";
    AppPermission["SettingsAdvisersConfiguration"] = "settings_advisers_configuration";
    AppPermission["SettingsAgentGroupsConfiguration"] = "settings_agent_groups_configuration";
    AppPermission["SettingsAdvisersAssignments"] = "settings_advisers_assignments";
    AppPermission["SettingsAdvisersAutoAssignedLimit"] = "settings_advisers_auto_assigned_limit";
    AppPermission["SettingsAdvisersAvatar"] = "settings_advisers_avatar";
    AppPermission["SettingsActionForms"] = "settings_action_forms";
    AppPermission["SettingsStatuses"] = "settings_statuses";
    AppPermission["SettingsRoles"] = "settings_roles";
    AppPermission["SettingsGeneral"] = "settings_general";
    AppPermission["ReportsYours"] = "reports_yours";
    AppPermission["ReportsGroups"] = "reports_groups";
    AppPermission["ReportsOrg"] = "reports_org";
    AppPermission["ReportsYoursEfficiency"] = "reports_yours_efficiency";
    AppPermission["ReportsGroupsEfficiency"] = "reports_groups_efficiency";
    AppPermission["ReportsConversationsServiceLevelTagGroups"] = "reports_conversations_service_level_tag_groups";
    AppPermission["ReportsConversationsServiceLevelTags"] = "reports_conversations_service_level_tags";
    AppPermission["ReportsConversationsBackLineTags"] = "reports_conversations_back_line_tags";
    AppPermission["ReportsAdvisersAdviserGroups"] = "reports_advisers_adviser_groups";
    AppPermission["ReportsAdvisersTagGroups"] = "reports_advisers_tag_groups";
    AppPermission["ReportsOrgOther"] = "reports_org_other";
    AppPermission["ReportsOrgEfficiency"] = "reports_org_efficiency";
    AppPermission["LeadDeleteProfile"] = "lead_delete_profile";
    AppPermission["LeadUpdateProfile"] = "lead_update_profile";
    AppPermission["UpdatePersonalData"] = "update_personal_data";
    AppPermission["RoomAssignSelf"] = "room_assign_self";
    AppPermission["RoomAssignAgent"] = "room_assign_agent";
    AppPermission["RoomAssignByTag"] = "room_assign_by_tag";
    AppPermission["RoomAssignByTagGroup"] = "room_assign_by_tag_group";
    AppPermission["RoomCloseNotOwn"] = "room_close_not_own";
    AppPermission["AiIntentsClassify"] = "ai_intents_classify";
    AppPermission["DisplayOwnTagGroupsConversations"] = "display_own_tag_groups_conversations";
    AppPermission["DisplayHistoricallyAssignedConversations"] = "display_historically_assigned_conversations";
    AppPermission["SettingsPasswordChange"] = "settings_password_change";
    AppPermission["SettingsPersonal"] = "settings_personal";
    AppPermission["MeetingsPageVisibility"] = "meetings_page_visibility";
    AppPermission["HelpPageVisibility"] = "help_page_visibility";
})(AppPermission = exports.AppPermission || (exports.AppPermission = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AppPresence;
(function (AppPresence) {
    AppPresence["Available"] = "available";
    AppPresence["Away"] = "away";
    AppPresence["Unavailable"] = "unavailable";
    AppPresence["Unready"] = "unready";
})(AppPresence = exports.AppPresence || (exports.AppPresence = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AppicationErrorReason;
(function (AppicationErrorReason) {
    AppicationErrorReason["WidgetNotAvailable"] = "widget_not_available";
    AppicationErrorReason["WidgetNotAllowed"] = "widget_not_allowed";
    AppicationErrorReason["WidgetPreviousUnsubmitted"] = "widget_previous_unsubmitted";
    AppicationErrorReason["WidgetIntervalNotPassed"] = "widget_interval_not_passed";
    AppicationErrorReason["WidgetInvalidTagGroups"] = "widget_invalid_tag_groups";
    AppicationErrorReason["SubmissionAlreadySubmitted"] = "submission_already_submitted";
    AppicationErrorReason["SubmissionInputsNotFilled"] = "submission_inputs_not_filled";
    AppicationErrorReason["SubmissionTextLimitsExceeded"] = "submission_text_limits_exceeded";
    AppicationErrorReason["SubmissionFormExpired"] = "submission_form_expired";
    AppicationErrorReason["SubmissionIncorrectTagGroupId"] = "submission_incorrect_tag_group_id";
    AppicationErrorReason["SubmissionIncorrectAutoAssignFormInputs"] = "submission_incorrect_auto_assign_form_inputs";
    AppicationErrorReason["SubmissionNoContactInput"] = "submission_no_contact_input";
    AppicationErrorReason["SubmissionNoAgreementInput"] = "submission_no_agreement_input";
    AppicationErrorReason["SubmissionInvalidPhoneNumber"] = "submission_invalid_phone_number";
    AppicationErrorReason["AgentEmailAlreadyUsed"] = "agent_email_already_used";
    AppicationErrorReason["SessionExpired"] = "session_expired";
    AppicationErrorReason["SessionInvalidCredentials"] = "session_invalid_credentials";
})(AppicationErrorReason = exports.AppicationErrorReason || (exports.AppicationErrorReason = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ArtichokePresence;
(function (ArtichokePresence) {
    ArtichokePresence["Available"] = "available";
    ArtichokePresence["Unavailable"] = "unavailable";
})(ArtichokePresence = exports.ArtichokePresence || (exports.ArtichokePresence = {}));
/**
 * @export
 * @namespace BotInfo
 */
var BotInfo;
(function (BotInfo) {
    /**
     * @export
     * @enum {string}
     */
    let BotTypeEnum;
    (function (BotTypeEnum) {
        BotTypeEnum["CloserBotType"] = "CloserBotType";
        BotTypeEnum["LektaBotType"] = "LektaBotType";
    })(BotTypeEnum = BotInfo.BotTypeEnum || (BotInfo.BotTypeEnum = {}));
})(BotInfo = exports.BotInfo || (exports.BotInfo = {}));
/**
 * @export
 * @namespace ChangeBotTypeForm
 */
var ChangeBotTypeForm;
(function (ChangeBotTypeForm) {
    /**
     * @export
     * @enum {string}
     */
    let BotTypeEnum;
    (function (BotTypeEnum) {
        BotTypeEnum["CloserBotType"] = "CloserBotType";
        BotTypeEnum["LektaBotType"] = "LektaBotType";
    })(BotTypeEnum = ChangeBotTypeForm.BotTypeEnum || (ChangeBotTypeForm.BotTypeEnum = {}));
})(ChangeBotTypeForm = exports.ChangeBotTypeForm || (exports.ChangeBotTypeForm = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["Waiting"] = "waiting";
    ConversationStatus["InProgress"] = "inProgress";
    ConversationStatus["Solved"] = "solved";
    ConversationStatus["Unsolved"] = "unsolved";
})(ConversationStatus = exports.ConversationStatus || (exports.ConversationStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EventActionEvent;
(function (EventActionEvent) {
    EventActionEvent["ThreadOpenedOutsideWorkingHours"] = "thread_opened_outside_working_hours";
    EventActionEvent["ClosedSolvedThreadAction"] = "closed_solved_thread_action";
    EventActionEvent["ClosedUnsolvedThreadAction"] = "closed_unsolved_thread_action";
    EventActionEvent["ThreadOpened"] = "thread_opened";
    EventActionEvent["AssignedConversationAction"] = "assigned_conversation_action";
    EventActionEvent["ThreadOpenedAgentsUnavailable"] = "thread_opened_agents_unavailable";
    EventActionEvent["WidgetOpenedNoOpenThread"] = "widget_opened_no_open_thread";
})(EventActionEvent = exports.EventActionEvent || (exports.EventActionEvent = {}));
/**
 *
 * @export
 * @enum {string}
 */
var InboxEntryType;
(function (InboxEntryType) {
    InboxEntryType["MESSAGE"] = "MESSAGE";
    InboxEntryType["NOTE"] = "NOTE";
    InboxEntryType["FILES"] = "FILES";
    InboxEntryType["MEETINGSCHEDULED"] = "MEETING_SCHEDULED";
    InboxEntryType["MEETINGRESCHEDULED"] = "MEETING_RESCHEDULED";
    InboxEntryType["MEETINGCANCELLED"] = "MEETING_CANCELLED";
    InboxEntryType["CALLSTARTED"] = "CALL_STARTED";
    InboxEntryType["CALLENDED"] = "CALL_ENDED";
    InboxEntryType["FORM"] = "FORM";
})(InboxEntryType = exports.InboxEntryType || (exports.InboxEntryType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var InboxSorting;
(function (InboxSorting) {
    InboxSorting["Newest"] = "newest";
    InboxSorting["Oldest"] = "oldest";
})(InboxSorting = exports.InboxSorting || (exports.InboxSorting = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MatchingStrategy;
(function (MatchingStrategy) {
    MatchingStrategy["WholeDomain"] = "whole_domain";
    MatchingStrategy["PathRecursively"] = "path_recursively";
    MatchingStrategy["ExactUrl"] = "exact_url";
    MatchingStrategy["PathArgs"] = "path_args";
})(MatchingStrategy = exports.MatchingStrategy || (exports.MatchingStrategy = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MessageWidgetConfigContextType;
(function (MessageWidgetConfigContextType) {
    MessageWidgetConfigContextType["AutoAssignForm"] = "auto_assign_form";
    MessageWidgetConfigContextType["ContactEnquiry"] = "contact_enquiry";
    MessageWidgetConfigContextType["OplShowAddressForm"] = "opl_show_address_form";
    MessageWidgetConfigContextType["PredefinedMessageForm"] = "predefined_message_form";
})(MessageWidgetConfigContextType = exports.MessageWidgetConfigContextType || (exports.MessageWidgetConfigContextType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ModelTrainingStatus;
(function (ModelTrainingStatus) {
    ModelTrainingStatus["TrainingInProgress"] = "TrainingInProgress";
    ModelTrainingStatus["TrainingDone"] = "TrainingDone";
    ModelTrainingStatus["TrainingNeverDone"] = "TrainingNeverDone";
})(ModelTrainingStatus = exports.ModelTrainingStatus || (exports.ModelTrainingStatus = {}));
/**
 * @export
 * @namespace RegisterInPushService
 */
var RegisterInPushService;
(function (RegisterInPushService) {
    /**
     * @export
     * @enum {string}
     */
    let DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum["Android"] = "android";
        DeviceTypeEnum["Ios"] = "ios";
    })(DeviceTypeEnum = RegisterInPushService.DeviceTypeEnum || (RegisterInPushService.DeviceTypeEnum = {}));
})(RegisterInPushService = exports.RegisterInPushService || (exports.RegisterInPushService = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SnoozedStatus;
(function (SnoozedStatus) {
    SnoozedStatus["Snoozed"] = "snoozed";
    SnoozedStatus["Unsnoozed"] = "unsnoozed";
})(SnoozedStatus = exports.SnoozedStatus || (exports.SnoozedStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var UrlParameter;
(function (UrlParameter) {
    UrlParameter["RoomId"] = "roomId";
    UrlParameter["Token"] = "token";
})(UrlParameter = exports.UrlParameter || (exports.UrlParameter = {}));
/**
 *
 * @export
 * @enum {string}
 */
var UserRole;
(function (UserRole) {
    UserRole["ADVISER"] = "ADVISER";
    UserRole["BOT"] = "BOT";
    UserRole["LEAD"] = "LEAD";
    UserRole["ORGANIZATION"] = "ORGANIZATION";
    UserRole["MASTER"] = "MASTER";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
/**
 * @export
 * @namespace WidgetButtonsInput
 */
var WidgetButtonsInput;
(function (WidgetButtonsInput) {
    /**
     * @export
     * @enum {string}
     */
    let StyleEnum;
    (function (StyleEnum) {
        StyleEnum["VerticallyAligned"] = "vertically_aligned";
    })(StyleEnum = WidgetButtonsInput.StyleEnum || (WidgetButtonsInput.StyleEnum = {}));
})(WidgetButtonsInput = exports.WidgetButtonsInput || (exports.WidgetButtonsInput = {}));
/**
 * AgentGroupsApi - fetch parameter creator
 * @export
 */
const AgentGroupsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary create agent group
         * @param {CreateAgentGroupForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentGroup(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createAgentGroup.');
            }
            const localVarPath = `/agent-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateAgentGroupForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete agent group
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentGroup(agentGroupId, options = {}) {
            // verify required parameter 'agentGroupId' is not null or undefined
            if (agentGroupId === null || agentGroupId === undefined) {
                throw new RequiredError('agentGroupId', 'Required parameter agentGroupId was null or undefined when calling deleteAgentGroup.');
            }
            const localVarPath = `/agent-groups/{agentGroupId}`
                .replace(`{${"agentGroupId"}}`, encodeURIComponent(String(agentGroupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get agent group
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentGroup(agentGroupId, options = {}) {
            // verify required parameter 'agentGroupId' is not null or undefined
            if (agentGroupId === null || agentGroupId === undefined) {
                throw new RequiredError('agentGroupId', 'Required parameter agentGroupId was null or undefined when calling getAgentGroup.');
            }
            const localVarPath = `/agent-groups/{agentGroupId}`
                .replace(`{${"agentGroupId"}}`, encodeURIComponent(String(agentGroupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get agent groups for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentGroups(options = {}) {
            const localVarPath = `/agent-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary patch agent group
         * @param {AgentGroupPatchDto} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentGroup(body, agentGroupId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAgentGroup.');
            }
            // verify required parameter 'agentGroupId' is not null or undefined
            if (agentGroupId === null || agentGroupId === undefined) {
                throw new RequiredError('agentGroupId', 'Required parameter agentGroupId was null or undefined when calling patchAgentGroup.');
            }
            const localVarPath = `/agent-groups/{agentGroupId}`
                .replace(`{${"agentGroupId"}}`, encodeURIComponent(String(agentGroupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgentGroupPatchDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary patch agent groups
         * @param {Array<AgentGroupBatchPatchDto>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentGroups(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAgentGroups.');
            }
            const localVarPath = `/agent-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Array&lt;AgentGroupBatchPatchDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update agent group assignments
         * @param {UpdateAgentGroupAssignmentsForm} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupAssignments(body, agentGroupId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateAgentGroupAssignments.');
            }
            // verify required parameter 'agentGroupId' is not null or undefined
            if (agentGroupId === null || agentGroupId === undefined) {
                throw new RequiredError('agentGroupId', 'Required parameter agentGroupId was null or undefined when calling updateAgentGroupAssignments.');
            }
            const localVarPath = `/agent-groups/{agentGroupId}/assignments`
                .replace(`{${"agentGroupId"}}`, encodeURIComponent(String(agentGroupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateAgentGroupAssignmentsForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update agent group configuration
         * @param {UpdateAgentGroupConfigurationForm} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupConfiguration(body, agentGroupId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateAgentGroupConfiguration.');
            }
            // verify required parameter 'agentGroupId' is not null or undefined
            if (agentGroupId === null || agentGroupId === undefined) {
                throw new RequiredError('agentGroupId', 'Required parameter agentGroupId was null or undefined when calling updateAgentGroupConfiguration.');
            }
            const localVarPath = `/agent-groups/{agentGroupId}/configuration`
                .replace(`{${"agentGroupId"}}`, encodeURIComponent(String(agentGroupId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateAgentGroupConfigurationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update agent groups assignments
         * @param {Array<UpdateAgentGroupAssignmentsForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupsAssignments(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateAgentGroupsAssignments.');
            }
            const localVarPath = `/agent-groups/assignments`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Array&lt;UpdateAgentGroupAssignmentsForm&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update agent groups configuration
         * @param {Array<UpdateAgentGroupConfigurationForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupsConfiguration(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateAgentGroupsConfiguration.');
            }
            const localVarPath = `/agent-groups/configuration`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Array&lt;UpdateAgentGroupConfigurationForm&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AgentGroupsApiFetchParamCreator = AgentGroupsApiFetchParamCreator;
/**
 * AgentGroupsApi - functional programming interface
 * @export
 */
const AgentGroupsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary create agent group
         * @param {CreateAgentGroupForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentGroup(body, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).createAgentGroup(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete agent group
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentGroup(agentGroupId, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).deleteAgentGroup(agentGroupId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get agent group
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentGroup(agentGroupId, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).getAgentGroup(agentGroupId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get agent groups for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentGroups(options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).getAgentGroups(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary patch agent group
         * @param {AgentGroupPatchDto} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentGroup(body, agentGroupId, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).patchAgentGroup(body, agentGroupId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary patch agent groups
         * @param {Array<AgentGroupBatchPatchDto>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentGroups(body, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).patchAgentGroups(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update agent group assignments
         * @param {UpdateAgentGroupAssignmentsForm} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupAssignments(body, agentGroupId, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).updateAgentGroupAssignments(body, agentGroupId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update agent group configuration
         * @param {UpdateAgentGroupConfigurationForm} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupConfiguration(body, agentGroupId, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).updateAgentGroupConfiguration(body, agentGroupId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update agent groups assignments
         * @param {Array<UpdateAgentGroupAssignmentsForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupsAssignments(body, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).updateAgentGroupsAssignments(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update agent groups configuration
         * @param {Array<UpdateAgentGroupConfigurationForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupsConfiguration(body, options) {
            const localVarFetchArgs = (0, exports.AgentGroupsApiFetchParamCreator)(configuration).updateAgentGroupsConfiguration(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AgentGroupsApiFp = AgentGroupsApiFp;
/**
 * AgentGroupsApi - factory interface
 * @export
 */
const AgentGroupsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary create agent group
         * @param {CreateAgentGroupForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentGroup(body, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).createAgentGroup(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete agent group
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentGroup(agentGroupId, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).deleteAgentGroup(agentGroupId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get agent group
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentGroup(agentGroupId, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).getAgentGroup(agentGroupId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get agent groups for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentGroups(options) {
            return (0, exports.AgentGroupsApiFp)(configuration).getAgentGroups(options)(fetch, basePath);
        },
        /**
         *
         * @summary patch agent group
         * @param {AgentGroupPatchDto} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentGroup(body, agentGroupId, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).patchAgentGroup(body, agentGroupId, options)(fetch, basePath);
        },
        /**
         *
         * @summary patch agent groups
         * @param {Array<AgentGroupBatchPatchDto>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentGroups(body, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).patchAgentGroups(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary update agent group assignments
         * @param {UpdateAgentGroupAssignmentsForm} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupAssignments(body, agentGroupId, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).updateAgentGroupAssignments(body, agentGroupId, options)(fetch, basePath);
        },
        /**
         *
         * @summary update agent group configuration
         * @param {UpdateAgentGroupConfigurationForm} body
         * @param {string} agentGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupConfiguration(body, agentGroupId, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).updateAgentGroupConfiguration(body, agentGroupId, options)(fetch, basePath);
        },
        /**
         *
         * @summary update agent groups assignments
         * @param {Array<UpdateAgentGroupAssignmentsForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupsAssignments(body, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).updateAgentGroupsAssignments(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary update agent groups configuration
         * @param {Array<UpdateAgentGroupConfigurationForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentGroupsConfiguration(body, options) {
            return (0, exports.AgentGroupsApiFp)(configuration).updateAgentGroupsConfiguration(body, options)(fetch, basePath);
        },
    };
};
exports.AgentGroupsApiFactory = AgentGroupsApiFactory;
/**
 * AgentGroupsApi - object-oriented interface
 * @export
 * @class AgentGroupsApi
 * @extends {BaseAPI}
 */
class AgentGroupsApi extends BaseAPI {
    /**
     *
     * @summary create agent group
     * @param {CreateAgentGroupForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    createAgentGroup(body, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).createAgentGroup(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete agent group
     * @param {string} agentGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    deleteAgentGroup(agentGroupId, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).deleteAgentGroup(agentGroupId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get agent group
     * @param {string} agentGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    getAgentGroup(agentGroupId, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).getAgentGroup(agentGroupId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get agent groups for org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    getAgentGroups(options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).getAgentGroups(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary patch agent group
     * @param {AgentGroupPatchDto} body
     * @param {string} agentGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    patchAgentGroup(body, agentGroupId, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).patchAgentGroup(body, agentGroupId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary patch agent groups
     * @param {Array<AgentGroupBatchPatchDto>} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    patchAgentGroups(body, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).patchAgentGroups(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update agent group assignments
     * @param {UpdateAgentGroupAssignmentsForm} body
     * @param {string} agentGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    updateAgentGroupAssignments(body, agentGroupId, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).updateAgentGroupAssignments(body, agentGroupId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update agent group configuration
     * @param {UpdateAgentGroupConfigurationForm} body
     * @param {string} agentGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    updateAgentGroupConfiguration(body, agentGroupId, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).updateAgentGroupConfiguration(body, agentGroupId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update agent groups assignments
     * @param {Array<UpdateAgentGroupAssignmentsForm>} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    updateAgentGroupsAssignments(body, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).updateAgentGroupsAssignments(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update agent groups configuration
     * @param {Array<UpdateAgentGroupConfigurationForm>} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGroupsApi
     */
    updateAgentGroupsConfiguration(body, options) {
        return (0, exports.AgentGroupsApiFp)(this.configuration).updateAgentGroupsConfiguration(body, options)(this.fetch, this.basePath);
    }
}
exports.AgentGroupsApi = AgentGroupsApi;
/**
 * AgentStatusesApi - fetch parameter creator
 * @export
 */
const AgentStatusesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary create unavailability reason
         * @param {UnavailabilityReasonCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnavailabilityReason(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createUnavailabilityReason.');
            }
            const localVarPath = `/agentStatuses/unavailabilityReasons`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UnavailabilityReasonCreateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete unavailability reason
         * @param {string} reasonSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnavailabilityReason(reasonSlug, options = {}) {
            // verify required parameter 'reasonSlug' is not null or undefined
            if (reasonSlug === null || reasonSlug === undefined) {
                throw new RequiredError('reasonSlug', 'Required parameter reasonSlug was null or undefined when calling deleteUnavailabilityReason.');
            }
            const localVarPath = `/agentStatuses/unavailabilityReasons/{reasonSlug}`
                .replace(`{${"reasonSlug"}}`, encodeURIComponent(String(reasonSlug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get unavailability reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnavailabilityReasons(options = {}) {
            const localVarPath = `/agentStatuses/unavailabilityReasons`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update unavailability reason
         * @param {UnavailabilityReasonUpdateForm} body
         * @param {string} reasonSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnavailabilityReasons(body, reasonSlug, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateUnavailabilityReasons.');
            }
            // verify required parameter 'reasonSlug' is not null or undefined
            if (reasonSlug === null || reasonSlug === undefined) {
                throw new RequiredError('reasonSlug', 'Required parameter reasonSlug was null or undefined when calling updateUnavailabilityReasons.');
            }
            const localVarPath = `/agentStatuses/unavailabilityReasons/{reasonSlug}`
                .replace(`{${"reasonSlug"}}`, encodeURIComponent(String(reasonSlug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UnavailabilityReasonUpdateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AgentStatusesApiFetchParamCreator = AgentStatusesApiFetchParamCreator;
/**
 * AgentStatusesApi - functional programming interface
 * @export
 */
const AgentStatusesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary create unavailability reason
         * @param {UnavailabilityReasonCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnavailabilityReason(body, options) {
            const localVarFetchArgs = (0, exports.AgentStatusesApiFetchParamCreator)(configuration).createUnavailabilityReason(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete unavailability reason
         * @param {string} reasonSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnavailabilityReason(reasonSlug, options) {
            const localVarFetchArgs = (0, exports.AgentStatusesApiFetchParamCreator)(configuration).deleteUnavailabilityReason(reasonSlug, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get unavailability reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnavailabilityReasons(options) {
            const localVarFetchArgs = (0, exports.AgentStatusesApiFetchParamCreator)(configuration).getUnavailabilityReasons(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update unavailability reason
         * @param {UnavailabilityReasonUpdateForm} body
         * @param {string} reasonSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnavailabilityReasons(body, reasonSlug, options) {
            const localVarFetchArgs = (0, exports.AgentStatusesApiFetchParamCreator)(configuration).updateUnavailabilityReasons(body, reasonSlug, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AgentStatusesApiFp = AgentStatusesApiFp;
/**
 * AgentStatusesApi - factory interface
 * @export
 */
const AgentStatusesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary create unavailability reason
         * @param {UnavailabilityReasonCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnavailabilityReason(body, options) {
            return (0, exports.AgentStatusesApiFp)(configuration).createUnavailabilityReason(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete unavailability reason
         * @param {string} reasonSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnavailabilityReason(reasonSlug, options) {
            return (0, exports.AgentStatusesApiFp)(configuration).deleteUnavailabilityReason(reasonSlug, options)(fetch, basePath);
        },
        /**
         *
         * @summary get unavailability reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnavailabilityReasons(options) {
            return (0, exports.AgentStatusesApiFp)(configuration).getUnavailabilityReasons(options)(fetch, basePath);
        },
        /**
         *
         * @summary update unavailability reason
         * @param {UnavailabilityReasonUpdateForm} body
         * @param {string} reasonSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnavailabilityReasons(body, reasonSlug, options) {
            return (0, exports.AgentStatusesApiFp)(configuration).updateUnavailabilityReasons(body, reasonSlug, options)(fetch, basePath);
        },
    };
};
exports.AgentStatusesApiFactory = AgentStatusesApiFactory;
/**
 * AgentStatusesApi - object-oriented interface
 * @export
 * @class AgentStatusesApi
 * @extends {BaseAPI}
 */
class AgentStatusesApi extends BaseAPI {
    /**
     *
     * @summary create unavailability reason
     * @param {UnavailabilityReasonCreateForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentStatusesApi
     */
    createUnavailabilityReason(body, options) {
        return (0, exports.AgentStatusesApiFp)(this.configuration).createUnavailabilityReason(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete unavailability reason
     * @param {string} reasonSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentStatusesApi
     */
    deleteUnavailabilityReason(reasonSlug, options) {
        return (0, exports.AgentStatusesApiFp)(this.configuration).deleteUnavailabilityReason(reasonSlug, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get unavailability reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentStatusesApi
     */
    getUnavailabilityReasons(options) {
        return (0, exports.AgentStatusesApiFp)(this.configuration).getUnavailabilityReasons(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update unavailability reason
     * @param {UnavailabilityReasonUpdateForm} body
     * @param {string} reasonSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentStatusesApi
     */
    updateUnavailabilityReasons(body, reasonSlug, options) {
        return (0, exports.AgentStatusesApiFp)(this.configuration).updateUnavailabilityReasons(body, reasonSlug, options)(this.fetch, this.basePath);
    }
}
exports.AgentStatusesApi = AgentStatusesApi;
/**
 * BillingsApi - fetch parameter creator
 * @export
 */
const BillingsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Check VAT ID and get its tax rates
         * @param {VatRequestForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVat(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling checkVat.');
            }
            const localVarPath = `/billings/vat`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("VatRequestForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Dissmiss a toast
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissToast(options = {}) {
            const localVarPath = `/billings/toast/dismiss`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary redirect to stripe customer portal for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalSession(options = {}) {
            const localVarPath = `/billings/portal`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get billing plan for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPlan(options = {}) {
            const localVarPath = `/billings/plan`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get billing plan by name
         * @param {string} planName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan(planName, options = {}) {
            // verify required parameter 'planName' is not null or undefined
            if (planName === null || planName === undefined) {
                throw new RequiredError('planName', 'Required parameter planName was null or undefined when calling getPlan.');
            }
            const localVarPath = `/billings/plan/{planName}`
                .replace(`{${"planName"}}`, encodeURIComponent(String(planName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get toast for adviser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToast(options = {}) {
            const localVarPath = `/billings/toast`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Insert new billing
         * @param {BillingPlan} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertPlan(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling insertPlan.');
            }
            const localVarPath = `/billings/plan`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("BillingPlan" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BillingsApiFetchParamCreator = BillingsApiFetchParamCreator;
/**
 * BillingsApi - functional programming interface
 * @export
 */
const BillingsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Check VAT ID and get its tax rates
         * @param {VatRequestForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVat(body, options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).checkVat(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Dissmiss a toast
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissToast(options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).dismissToast(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary redirect to stripe customer portal for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalSession(options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).getCustomerPortalSession(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get billing plan for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPlan(options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).getOwnPlan(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get billing plan by name
         * @param {string} planName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan(planName, options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).getPlan(planName, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get toast for adviser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToast(options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).getToast(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Insert new billing
         * @param {BillingPlan} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertPlan(body, options) {
            const localVarFetchArgs = (0, exports.BillingsApiFetchParamCreator)(configuration).insertPlan(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.BillingsApiFp = BillingsApiFp;
/**
 * BillingsApi - factory interface
 * @export
 */
const BillingsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Check VAT ID and get its tax rates
         * @param {VatRequestForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkVat(body, options) {
            return (0, exports.BillingsApiFp)(configuration).checkVat(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Dissmiss a toast
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissToast(options) {
            return (0, exports.BillingsApiFp)(configuration).dismissToast(options)(fetch, basePath);
        },
        /**
         *
         * @summary redirect to stripe customer portal for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalSession(options) {
            return (0, exports.BillingsApiFp)(configuration).getCustomerPortalSession(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get billing plan for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPlan(options) {
            return (0, exports.BillingsApiFp)(configuration).getOwnPlan(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get billing plan by name
         * @param {string} planName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan(planName, options) {
            return (0, exports.BillingsApiFp)(configuration).getPlan(planName, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get toast for adviser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToast(options) {
            return (0, exports.BillingsApiFp)(configuration).getToast(options)(fetch, basePath);
        },
        /**
         *
         * @summary Insert new billing
         * @param {BillingPlan} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertPlan(body, options) {
            return (0, exports.BillingsApiFp)(configuration).insertPlan(body, options)(fetch, basePath);
        },
    };
};
exports.BillingsApiFactory = BillingsApiFactory;
/**
 * BillingsApi - object-oriented interface
 * @export
 * @class BillingsApi
 * @extends {BaseAPI}
 */
class BillingsApi extends BaseAPI {
    /**
     *
     * @summary Check VAT ID and get its tax rates
     * @param {VatRequestForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    checkVat(body, options) {
        return (0, exports.BillingsApiFp)(this.configuration).checkVat(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Dissmiss a toast
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    dismissToast(options) {
        return (0, exports.BillingsApiFp)(this.configuration).dismissToast(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary redirect to stripe customer portal for current org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    getCustomerPortalSession(options) {
        return (0, exports.BillingsApiFp)(this.configuration).getCustomerPortalSession(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get billing plan for current org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    getOwnPlan(options) {
        return (0, exports.BillingsApiFp)(this.configuration).getOwnPlan(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get billing plan by name
     * @param {string} planName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    getPlan(planName, options) {
        return (0, exports.BillingsApiFp)(this.configuration).getPlan(planName, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get toast for adviser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    getToast(options) {
        return (0, exports.BillingsApiFp)(this.configuration).getToast(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Insert new billing
     * @param {BillingPlan} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingsApi
     */
    insertPlan(body, options) {
        return (0, exports.BillingsApiFp)(this.configuration).insertPlan(body, options)(this.fetch, this.basePath);
    }
}
exports.BillingsApi = BillingsApi;
/**
 * BotsApi - fetch parameter creator
 * @export
 */
const BotsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary change bot type
         * @param {ChangeBotTypeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeBotType(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling changeBotType.');
            }
            const localVarPath = `/bots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ChangeBotTypeForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary create bot avatar handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBotAvatarHandle(options = {}) {
            const localVarPath = `/bots/avatar`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary create lekta config
         * @param {LektaConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLektaConfig(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createLektaConfig.');
            }
            const localVarPath = `/bots/lekta`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LektaConfigForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete bot avatar
         * @param {ChangeBotTypeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBotAvatar(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling deleteBotAvatar.');
            }
            const localVarPath = `/bots/avatar`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ChangeBotTypeForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get bot info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotInfo(options = {}) {
            const localVarPath = `/bots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get bot limited agent profile
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotLimitedAgentProfile(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getBotLimitedAgentProfile.');
            }
            const localVarPath = `/bots/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get lekta config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLektaConfig(options = {}) {
            const localVarPath = `/bots/lekta`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update bot personal data
         * @param {BotPersonalDataForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBotPersonalData(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateBotPersonalData.');
            }
            const localVarPath = `/bots/personalData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("BotPersonalDataForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update bot's knowledge base
         * @param {UpdateBotKnowledgeBaseForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeBase(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateKnowledgeBase.');
            }
            const localVarPath = `/bots/knowledge-base`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateBotKnowledgeBaseForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update lekta config
         * @param {LektaConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLektaConfig(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateLektaConfig.');
            }
            const localVarPath = `/bots/lekta`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LektaConfigForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BotsApiFetchParamCreator = BotsApiFetchParamCreator;
/**
 * BotsApi - functional programming interface
 * @export
 */
const BotsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary change bot type
         * @param {ChangeBotTypeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeBotType(body, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).changeBotType(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary create bot avatar handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBotAvatarHandle(options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).createBotAvatarHandle(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary create lekta config
         * @param {LektaConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLektaConfig(body, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).createLektaConfig(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete bot avatar
         * @param {ChangeBotTypeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBotAvatar(body, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).deleteBotAvatar(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get bot info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotInfo(options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).getBotInfo(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get bot limited agent profile
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotLimitedAgentProfile(orgId, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).getBotLimitedAgentProfile(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get lekta config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLektaConfig(options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).getLektaConfig(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update bot personal data
         * @param {BotPersonalDataForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBotPersonalData(body, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).updateBotPersonalData(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update bot's knowledge base
         * @param {UpdateBotKnowledgeBaseForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeBase(body, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).updateKnowledgeBase(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update lekta config
         * @param {LektaConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLektaConfig(body, options) {
            const localVarFetchArgs = (0, exports.BotsApiFetchParamCreator)(configuration).updateLektaConfig(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.BotsApiFp = BotsApiFp;
/**
 * BotsApi - factory interface
 * @export
 */
const BotsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary change bot type
         * @param {ChangeBotTypeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeBotType(body, options) {
            return (0, exports.BotsApiFp)(configuration).changeBotType(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary create bot avatar handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBotAvatarHandle(options) {
            return (0, exports.BotsApiFp)(configuration).createBotAvatarHandle(options)(fetch, basePath);
        },
        /**
         *
         * @summary create lekta config
         * @param {LektaConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLektaConfig(body, options) {
            return (0, exports.BotsApiFp)(configuration).createLektaConfig(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete bot avatar
         * @param {ChangeBotTypeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBotAvatar(body, options) {
            return (0, exports.BotsApiFp)(configuration).deleteBotAvatar(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary get bot info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotInfo(options) {
            return (0, exports.BotsApiFp)(configuration).getBotInfo(options)(fetch, basePath);
        },
        /**
         *
         * @summary get bot limited agent profile
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotLimitedAgentProfile(orgId, options) {
            return (0, exports.BotsApiFp)(configuration).getBotLimitedAgentProfile(orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get lekta config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLektaConfig(options) {
            return (0, exports.BotsApiFp)(configuration).getLektaConfig(options)(fetch, basePath);
        },
        /**
         *
         * @summary update bot personal data
         * @param {BotPersonalDataForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBotPersonalData(body, options) {
            return (0, exports.BotsApiFp)(configuration).updateBotPersonalData(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update bot's knowledge base
         * @param {UpdateBotKnowledgeBaseForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeBase(body, options) {
            return (0, exports.BotsApiFp)(configuration).updateKnowledgeBase(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary update lekta config
         * @param {LektaConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLektaConfig(body, options) {
            return (0, exports.BotsApiFp)(configuration).updateLektaConfig(body, options)(fetch, basePath);
        },
    };
};
exports.BotsApiFactory = BotsApiFactory;
/**
 * BotsApi - object-oriented interface
 * @export
 * @class BotsApi
 * @extends {BaseAPI}
 */
class BotsApi extends BaseAPI {
    /**
     *
     * @summary change bot type
     * @param {ChangeBotTypeForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    changeBotType(body, options) {
        return (0, exports.BotsApiFp)(this.configuration).changeBotType(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary create bot avatar handle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    createBotAvatarHandle(options) {
        return (0, exports.BotsApiFp)(this.configuration).createBotAvatarHandle(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary create lekta config
     * @param {LektaConfigForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    createLektaConfig(body, options) {
        return (0, exports.BotsApiFp)(this.configuration).createLektaConfig(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete bot avatar
     * @param {ChangeBotTypeForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    deleteBotAvatar(body, options) {
        return (0, exports.BotsApiFp)(this.configuration).deleteBotAvatar(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get bot info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    getBotInfo(options) {
        return (0, exports.BotsApiFp)(this.configuration).getBotInfo(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get bot limited agent profile
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    getBotLimitedAgentProfile(orgId, options) {
        return (0, exports.BotsApiFp)(this.configuration).getBotLimitedAgentProfile(orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get lekta config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    getLektaConfig(options) {
        return (0, exports.BotsApiFp)(this.configuration).getLektaConfig(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update bot personal data
     * @param {BotPersonalDataForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    updateBotPersonalData(body, options) {
        return (0, exports.BotsApiFp)(this.configuration).updateBotPersonalData(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update bot's knowledge base
     * @param {UpdateBotKnowledgeBaseForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    updateKnowledgeBase(body, options) {
        return (0, exports.BotsApiFp)(this.configuration).updateKnowledgeBase(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update lekta config
     * @param {LektaConfigForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotsApi
     */
    updateLektaConfig(body, options) {
        return (0, exports.BotsApiFp)(this.configuration).updateLektaConfig(body, options)(this.fetch, this.basePath);
    }
}
exports.BotsApi = BotsApi;
/**
 * CalendarsApi - fetch parameter creator
 * @export
 */
const CalendarsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Exchange auth code for refresh and access tokens
         * @param {AuthCode} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeCode(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authorizeCode.');
            }
            const localVarPath = `/calendars/code`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AuthCode" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlots(options = {}) {
            const localVarPath = `/calendars/slots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get list of calendars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendars(options = {}) {
            const localVarPath = `/calendars`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlots(options = {}) {
            const localVarPath = `/calendars/slots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Import events from the calendar
         * @param {CalendarForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEvents(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling importEvents.');
            }
            const localVarPath = `/calendars/import`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CalendarForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sync slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSlots(options = {}) {
            const localVarPath = `/calendars/slots/sync`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CalendarsApiFetchParamCreator = CalendarsApiFetchParamCreator;
/**
 * CalendarsApi - functional programming interface
 * @export
 */
const CalendarsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Exchange auth code for refresh and access tokens
         * @param {AuthCode} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeCode(body, options) {
            const localVarFetchArgs = (0, exports.CalendarsApiFetchParamCreator)(configuration).authorizeCode(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlots(options) {
            const localVarFetchArgs = (0, exports.CalendarsApiFetchParamCreator)(configuration).deleteSlots(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get list of calendars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendars(options) {
            const localVarFetchArgs = (0, exports.CalendarsApiFetchParamCreator)(configuration).getCalendars(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlots(options) {
            const localVarFetchArgs = (0, exports.CalendarsApiFetchParamCreator)(configuration).getSlots(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Import events from the calendar
         * @param {CalendarForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEvents(body, options) {
            const localVarFetchArgs = (0, exports.CalendarsApiFetchParamCreator)(configuration).importEvents(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Sync slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSlots(options) {
            const localVarFetchArgs = (0, exports.CalendarsApiFetchParamCreator)(configuration).syncSlots(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CalendarsApiFp = CalendarsApiFp;
/**
 * CalendarsApi - factory interface
 * @export
 */
const CalendarsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Exchange auth code for refresh and access tokens
         * @param {AuthCode} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeCode(body, options) {
            return (0, exports.CalendarsApiFp)(configuration).authorizeCode(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlots(options) {
            return (0, exports.CalendarsApiFp)(configuration).deleteSlots(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get list of calendars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendars(options) {
            return (0, exports.CalendarsApiFp)(configuration).getCalendars(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlots(options) {
            return (0, exports.CalendarsApiFp)(configuration).getSlots(options)(fetch, basePath);
        },
        /**
         *
         * @summary Import events from the calendar
         * @param {CalendarForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importEvents(body, options) {
            return (0, exports.CalendarsApiFp)(configuration).importEvents(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Sync slots
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSlots(options) {
            return (0, exports.CalendarsApiFp)(configuration).syncSlots(options)(fetch, basePath);
        },
    };
};
exports.CalendarsApiFactory = CalendarsApiFactory;
/**
 * CalendarsApi - object-oriented interface
 * @export
 * @class CalendarsApi
 * @extends {BaseAPI}
 */
class CalendarsApi extends BaseAPI {
    /**
     *
     * @summary Exchange auth code for refresh and access tokens
     * @param {AuthCode} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    authorizeCode(body, options) {
        return (0, exports.CalendarsApiFp)(this.configuration).authorizeCode(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete slots
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    deleteSlots(options) {
        return (0, exports.CalendarsApiFp)(this.configuration).deleteSlots(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get list of calendars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    getCalendars(options) {
        return (0, exports.CalendarsApiFp)(this.configuration).getCalendars(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get slots
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    getSlots(options) {
        return (0, exports.CalendarsApiFp)(this.configuration).getSlots(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Import events from the calendar
     * @param {CalendarForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    importEvents(body, options) {
        return (0, exports.CalendarsApiFp)(this.configuration).importEvents(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Sync slots
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    syncSlots(options) {
        return (0, exports.CalendarsApiFp)(this.configuration).syncSlots(options)(this.fetch, this.basePath);
    }
}
exports.CalendarsApi = CalendarsApi;
/**
 * CallsApi - fetch parameter creator
 * @export
 */
const CallsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Creates new call
         * @param {CreateCall} body
         * @param {string} X_Device_Id Device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCall(body, X_Device_Id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createCall.');
            }
            // verify required parameter 'X_Device_Id' is not null or undefined
            if (X_Device_Id === null || X_Device_Id === undefined) {
                throw new RequiredError('X_Device_Id', 'Required parameter X_Device_Id was null or undefined when calling createCall.');
            }
            const localVarPath = `/calls/create`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            if (X_Device_Id !== undefined && X_Device_Id !== null) {
                localVarHeaderParameter['X-Device-Id'] = String(X_Device_Id);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateCall" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CallsApiFetchParamCreator = CallsApiFetchParamCreator;
/**
 * CallsApi - functional programming interface
 * @export
 */
const CallsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Creates new call
         * @param {CreateCall} body
         * @param {string} X_Device_Id Device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCall(body, X_Device_Id, options) {
            const localVarFetchArgs = (0, exports.CallsApiFetchParamCreator)(configuration).createCall(body, X_Device_Id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CallsApiFp = CallsApiFp;
/**
 * CallsApi - factory interface
 * @export
 */
const CallsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Creates new call
         * @param {CreateCall} body
         * @param {string} X_Device_Id Device ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCall(body, X_Device_Id, options) {
            return (0, exports.CallsApiFp)(configuration).createCall(body, X_Device_Id, options)(fetch, basePath);
        },
    };
};
exports.CallsApiFactory = CallsApiFactory;
/**
 * CallsApi - object-oriented interface
 * @export
 * @class CallsApi
 * @extends {BaseAPI}
 */
class CallsApi extends BaseAPI {
    /**
     *
     * @summary Creates new call
     * @param {CreateCall} body
     * @param {string} X_Device_Id Device ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallsApi
     */
    createCall(body, X_Device_Id, options) {
        return (0, exports.CallsApiFp)(this.configuration).createCall(body, X_Device_Id, options)(this.fetch, this.basePath);
    }
}
exports.CallsApi = CallsApi;
/**
 * CobrowsingApi - fetch parameter creator
 * @export
 */
const CobrowsingApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Indicates end of cobrowsing session
         * @param {CobrowsingEndForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cobrowsingIndicateEnd(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling cobrowsingIndicateEnd.');
            }
            const localVarPath = `/cobrowsing/end`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CobrowsingEndForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Indicates new cobrowsing session
         * @param {CobrowsingStartForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cobrowsingIndicateStart(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling cobrowsingIndicateStart.');
            }
            const localVarPath = `/cobrowsing/start`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CobrowsingStartForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CobrowsingApiFetchParamCreator = CobrowsingApiFetchParamCreator;
/**
 * CobrowsingApi - functional programming interface
 * @export
 */
const CobrowsingApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Indicates end of cobrowsing session
         * @param {CobrowsingEndForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cobrowsingIndicateEnd(body, options) {
            const localVarFetchArgs = (0, exports.CobrowsingApiFetchParamCreator)(configuration).cobrowsingIndicateEnd(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Indicates new cobrowsing session
         * @param {CobrowsingStartForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cobrowsingIndicateStart(body, options) {
            const localVarFetchArgs = (0, exports.CobrowsingApiFetchParamCreator)(configuration).cobrowsingIndicateStart(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CobrowsingApiFp = CobrowsingApiFp;
/**
 * CobrowsingApi - factory interface
 * @export
 */
const CobrowsingApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Indicates end of cobrowsing session
         * @param {CobrowsingEndForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cobrowsingIndicateEnd(body, options) {
            return (0, exports.CobrowsingApiFp)(configuration).cobrowsingIndicateEnd(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Indicates new cobrowsing session
         * @param {CobrowsingStartForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cobrowsingIndicateStart(body, options) {
            return (0, exports.CobrowsingApiFp)(configuration).cobrowsingIndicateStart(body, options)(fetch, basePath);
        },
    };
};
exports.CobrowsingApiFactory = CobrowsingApiFactory;
/**
 * CobrowsingApi - object-oriented interface
 * @export
 * @class CobrowsingApi
 * @extends {BaseAPI}
 */
class CobrowsingApi extends BaseAPI {
    /**
     *
     * @summary Indicates end of cobrowsing session
     * @param {CobrowsingEndForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CobrowsingApi
     */
    cobrowsingIndicateEnd(body, options) {
        return (0, exports.CobrowsingApiFp)(this.configuration).cobrowsingIndicateEnd(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Indicates new cobrowsing session
     * @param {CobrowsingStartForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CobrowsingApi
     */
    cobrowsingIndicateStart(body, options) {
        return (0, exports.CobrowsingApiFp)(this.configuration).cobrowsingIndicateStart(body, options)(this.fetch, this.basePath);
    }
}
exports.CobrowsingApi = CobrowsingApi;
/**
 * CompatibilityApi - fetch parameter creator
 * @export
 */
const CompatibilityApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get compatibility information
         * @param {string} X_App_Key uuid of app type
         * @param {string} X_App_Version version number of app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compatibilityGet(X_App_Key, X_App_Version, options = {}) {
            // verify required parameter 'X_App_Key' is not null or undefined
            if (X_App_Key === null || X_App_Key === undefined) {
                throw new RequiredError('X_App_Key', 'Required parameter X_App_Key was null or undefined when calling compatibilityGet.');
            }
            // verify required parameter 'X_App_Version' is not null or undefined
            if (X_App_Version === null || X_App_Version === undefined) {
                throw new RequiredError('X_App_Version', 'Required parameter X_App_Version was null or undefined when calling compatibilityGet.');
            }
            const localVarPath = `/compatibility`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_App_Key !== undefined && X_App_Key !== null) {
                localVarHeaderParameter['X-App-Key'] = String(X_App_Key);
            }
            if (X_App_Version !== undefined && X_App_Version !== null) {
                localVarHeaderParameter['X-App-Version'] = String(X_App_Version);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CompatibilityApiFetchParamCreator = CompatibilityApiFetchParamCreator;
/**
 * CompatibilityApi - functional programming interface
 * @export
 */
const CompatibilityApiFp = function (configuration) {
    return {
        /**
         *
         * @summary get compatibility information
         * @param {string} X_App_Key uuid of app type
         * @param {string} X_App_Version version number of app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compatibilityGet(X_App_Key, X_App_Version, options) {
            const localVarFetchArgs = (0, exports.CompatibilityApiFetchParamCreator)(configuration).compatibilityGet(X_App_Key, X_App_Version, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CompatibilityApiFp = CompatibilityApiFp;
/**
 * CompatibilityApi - factory interface
 * @export
 */
const CompatibilityApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary get compatibility information
         * @param {string} X_App_Key uuid of app type
         * @param {string} X_App_Version version number of app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compatibilityGet(X_App_Key, X_App_Version, options) {
            return (0, exports.CompatibilityApiFp)(configuration).compatibilityGet(X_App_Key, X_App_Version, options)(fetch, basePath);
        },
    };
};
exports.CompatibilityApiFactory = CompatibilityApiFactory;
/**
 * CompatibilityApi - object-oriented interface
 * @export
 * @class CompatibilityApi
 * @extends {BaseAPI}
 */
class CompatibilityApi extends BaseAPI {
    /**
     *
     * @summary get compatibility information
     * @param {string} X_App_Key uuid of app type
     * @param {string} X_App_Version version number of app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompatibilityApi
     */
    compatibilityGet(X_App_Key, X_App_Version, options) {
        return (0, exports.CompatibilityApiFp)(this.configuration).compatibilityGet(X_App_Key, X_App_Version, options)(this.fetch, this.basePath);
    }
}
exports.CompatibilityApi = CompatibilityApi;
/**
 * ConversationsApi - fetch parameter creator
 * @export
 */
const ConversationsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get conversations
         * @param {number} limit
         * @param {string} [tab]
         * @param {number} [offset]
         * @param {Array<string>} [tag]
         * @param {boolean} [onlySnoozed]
         * @param {string} [assigneeId]
         * @param {number} [anyThreadClosedAfter]
         * @param {number} [anyThreadClosedBefore]
         * @param {string} [sorting]
         * @param {Array<string>} [tagGroupId]
         * @param {boolean} [closed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options = {}) {
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new RequiredError('limit', 'Required parameter limit was null or undefined when calling getConversations.');
            }
            const localVarPath = `/conversations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (tag) {
                localVarQueryParameter['tag'] = tag;
            }
            if (onlySnoozed !== undefined) {
                localVarQueryParameter['onlySnoozed'] = onlySnoozed;
            }
            if (assigneeId !== undefined) {
                localVarQueryParameter['assigneeId'] = assigneeId;
            }
            if (anyThreadClosedAfter !== undefined) {
                localVarQueryParameter['anyThreadClosedAfter'] = anyThreadClosedAfter;
            }
            if (anyThreadClosedBefore !== undefined) {
                localVarQueryParameter['anyThreadClosedBefore'] = anyThreadClosedBefore;
            }
            if (sorting !== undefined) {
                localVarQueryParameter['sorting'] = sorting;
            }
            if (tagGroupId) {
                localVarQueryParameter['tagGroupId'] = tagGroupId;
            }
            if (closed !== undefined) {
                localVarQueryParameter['closed'] = closed;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ConversationsApiFetchParamCreator = ConversationsApiFetchParamCreator;
/**
 * ConversationsApi - functional programming interface
 * @export
 */
const ConversationsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get conversations
         * @param {number} limit
         * @param {string} [tab]
         * @param {number} [offset]
         * @param {Array<string>} [tag]
         * @param {boolean} [onlySnoozed]
         * @param {string} [assigneeId]
         * @param {number} [anyThreadClosedAfter]
         * @param {number} [anyThreadClosedBefore]
         * @param {string} [sorting]
         * @param {Array<string>} [tagGroupId]
         * @param {boolean} [closed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options) {
            const localVarFetchArgs = (0, exports.ConversationsApiFetchParamCreator)(configuration).getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ConversationsApiFp = ConversationsApiFp;
/**
 * ConversationsApi - factory interface
 * @export
 */
const ConversationsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Get conversations
         * @param {number} limit
         * @param {string} [tab]
         * @param {number} [offset]
         * @param {Array<string>} [tag]
         * @param {boolean} [onlySnoozed]
         * @param {string} [assigneeId]
         * @param {number} [anyThreadClosedAfter]
         * @param {number} [anyThreadClosedBefore]
         * @param {string} [sorting]
         * @param {Array<string>} [tagGroupId]
         * @param {boolean} [closed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options) {
            return (0, exports.ConversationsApiFp)(configuration).getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options)(fetch, basePath);
        },
    };
};
exports.ConversationsApiFactory = ConversationsApiFactory;
/**
 * ConversationsApi - object-oriented interface
 * @export
 * @class ConversationsApi
 * @extends {BaseAPI}
 */
class ConversationsApi extends BaseAPI {
    /**
     *
     * @summary Get conversations
     * @param {number} limit
     * @param {string} [tab]
     * @param {number} [offset]
     * @param {Array<string>} [tag]
     * @param {boolean} [onlySnoozed]
     * @param {string} [assigneeId]
     * @param {number} [anyThreadClosedAfter]
     * @param {number} [anyThreadClosedBefore]
     * @param {string} [sorting]
     * @param {Array<string>} [tagGroupId]
     * @param {boolean} [closed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options) {
        return (0, exports.ConversationsApiFp)(this.configuration).getConversations(limit, tab, offset, tag, onlySnoozed, assigneeId, anyThreadClosedAfter, anyThreadClosedBefore, sorting, tagGroupId, closed, options)(this.fetch, this.basePath);
    }
}
exports.ConversationsApi = ConversationsApi;
/**
 * EventActionsApi - fetch parameter creator
 * @export
 */
const EventActionsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary create event action config
         * @param {CreateEventActionConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventActionConfig(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createEventActionConfig.');
            }
            const localVarPath = `/bots/eventActions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateEventActionConfigForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete event action config
         * @param {string} eventActionConfigId The ID of the event action config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventActionConfig(eventActionConfigId, options = {}) {
            // verify required parameter 'eventActionConfigId' is not null or undefined
            if (eventActionConfigId === null || eventActionConfigId === undefined) {
                throw new RequiredError('eventActionConfigId', 'Required parameter eventActionConfigId was null or undefined when calling deleteEventActionConfig.');
            }
            const localVarPath = `/bots/eventActions/{eventActionConfigId}`
                .replace(`{${"eventActionConfigId"}}`, encodeURIComponent(String(eventActionConfigId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get event action configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventActionConfigs(options = {}) {
            const localVarPath = `/bots/eventActions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update event action config
         * @param {UpdateEventActionConfigForm} body
         * @param {string} eventActionConfigId The ID of the event action config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventActionConfig(body, eventActionConfigId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateEventActionConfig.');
            }
            // verify required parameter 'eventActionConfigId' is not null or undefined
            if (eventActionConfigId === null || eventActionConfigId === undefined) {
                throw new RequiredError('eventActionConfigId', 'Required parameter eventActionConfigId was null or undefined when calling updateEventActionConfig.');
            }
            const localVarPath = `/bots/eventActions/{eventActionConfigId}`
                .replace(`{${"eventActionConfigId"}}`, encodeURIComponent(String(eventActionConfigId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateEventActionConfigForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.EventActionsApiFetchParamCreator = EventActionsApiFetchParamCreator;
/**
 * EventActionsApi - functional programming interface
 * @export
 */
const EventActionsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary create event action config
         * @param {CreateEventActionConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventActionConfig(body, options) {
            const localVarFetchArgs = (0, exports.EventActionsApiFetchParamCreator)(configuration).createEventActionConfig(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete event action config
         * @param {string} eventActionConfigId The ID of the event action config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventActionConfig(eventActionConfigId, options) {
            const localVarFetchArgs = (0, exports.EventActionsApiFetchParamCreator)(configuration).deleteEventActionConfig(eventActionConfigId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get event action configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventActionConfigs(options) {
            const localVarFetchArgs = (0, exports.EventActionsApiFetchParamCreator)(configuration).getEventActionConfigs(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update event action config
         * @param {UpdateEventActionConfigForm} body
         * @param {string} eventActionConfigId The ID of the event action config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventActionConfig(body, eventActionConfigId, options) {
            const localVarFetchArgs = (0, exports.EventActionsApiFetchParamCreator)(configuration).updateEventActionConfig(body, eventActionConfigId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.EventActionsApiFp = EventActionsApiFp;
/**
 * EventActionsApi - factory interface
 * @export
 */
const EventActionsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary create event action config
         * @param {CreateEventActionConfigForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventActionConfig(body, options) {
            return (0, exports.EventActionsApiFp)(configuration).createEventActionConfig(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete event action config
         * @param {string} eventActionConfigId The ID of the event action config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventActionConfig(eventActionConfigId, options) {
            return (0, exports.EventActionsApiFp)(configuration).deleteEventActionConfig(eventActionConfigId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get event action configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventActionConfigs(options) {
            return (0, exports.EventActionsApiFp)(configuration).getEventActionConfigs(options)(fetch, basePath);
        },
        /**
         *
         * @summary update event action config
         * @param {UpdateEventActionConfigForm} body
         * @param {string} eventActionConfigId The ID of the event action config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventActionConfig(body, eventActionConfigId, options) {
            return (0, exports.EventActionsApiFp)(configuration).updateEventActionConfig(body, eventActionConfigId, options)(fetch, basePath);
        },
    };
};
exports.EventActionsApiFactory = EventActionsApiFactory;
/**
 * EventActionsApi - object-oriented interface
 * @export
 * @class EventActionsApi
 * @extends {BaseAPI}
 */
class EventActionsApi extends BaseAPI {
    /**
     *
     * @summary create event action config
     * @param {CreateEventActionConfigForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventActionsApi
     */
    createEventActionConfig(body, options) {
        return (0, exports.EventActionsApiFp)(this.configuration).createEventActionConfig(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete event action config
     * @param {string} eventActionConfigId The ID of the event action config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventActionsApi
     */
    deleteEventActionConfig(eventActionConfigId, options) {
        return (0, exports.EventActionsApiFp)(this.configuration).deleteEventActionConfig(eventActionConfigId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get event action configs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventActionsApi
     */
    getEventActionConfigs(options) {
        return (0, exports.EventActionsApiFp)(this.configuration).getEventActionConfigs(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update event action config
     * @param {UpdateEventActionConfigForm} body
     * @param {string} eventActionConfigId The ID of the event action config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventActionsApi
     */
    updateEventActionConfig(body, eventActionConfigId, options) {
        return (0, exports.EventActionsApiFp)(this.configuration).updateEventActionConfig(body, eventActionConfigId, options)(this.fetch, this.basePath);
    }
}
exports.EventActionsApi = EventActionsApi;
/**
 * FilesApi - fetch parameter creator
 * @export
 */
const FilesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get link for file. File should be uploaded via this link.
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileHandleForAttachmentUpload(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling getFileHandleForAttachmentUpload.');
            }
            const localVarPath = `/files/handle/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get temporary token for file.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryToken(token, options = {}) {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling getTemporaryToken.');
            }
            const localVarPath = `/files/token/{token}/temporary`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FilesApiFetchParamCreator = FilesApiFetchParamCreator;
/**
 * FilesApi - functional programming interface
 * @export
 */
const FilesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get link for file. File should be uploaded via this link.
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileHandleForAttachmentUpload(roomId, options) {
            const localVarFetchArgs = (0, exports.FilesApiFetchParamCreator)(configuration).getFileHandleForAttachmentUpload(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get temporary token for file.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryToken(token, options) {
            const localVarFetchArgs = (0, exports.FilesApiFetchParamCreator)(configuration).getTemporaryToken(token, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.FilesApiFp = FilesApiFp;
/**
 * FilesApi - factory interface
 * @export
 */
const FilesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Get link for file. File should be uploaded via this link.
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileHandleForAttachmentUpload(roomId, options) {
            return (0, exports.FilesApiFp)(configuration).getFileHandleForAttachmentUpload(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get temporary token for file.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryToken(token, options) {
            return (0, exports.FilesApiFp)(configuration).getTemporaryToken(token, options)(fetch, basePath);
        },
    };
};
exports.FilesApiFactory = FilesApiFactory;
/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
class FilesApi extends BaseAPI {
    /**
     *
     * @summary Get link for file. File should be uploaded via this link.
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    getFileHandleForAttachmentUpload(roomId, options) {
        return (0, exports.FilesApiFp)(this.configuration).getFileHandleForAttachmentUpload(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get temporary token for file.
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    getTemporaryToken(token, options) {
        return (0, exports.FilesApiFp)(this.configuration).getTemporaryToken(token, options)(this.fetch, this.basePath);
    }
}
exports.FilesApi = FilesApi;
/**
 * InviteesApi - fetch parameter creator
 * @export
 */
const InviteesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create adviser account from invitation
         * @param {AcceptInvitationForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(body, token, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling acceptInvitation.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling acceptInvitation.');
            }
            const localVarPath = `/invitees/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AcceptInvitationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get pending invited advisers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteesByOrg(options = {}) {
            const localVarPath = `/invitees`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check if token is valid and get names set by admin
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenValidity(token, options = {}) {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling getTokenValidity.');
            }
            const localVarPath = `/invitees/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Invite adviser to Closer
         * @param {InviteeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAdviser(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling inviteAdviser.');
            }
            const localVarPath = `/invitees`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("InviteeForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Invite advisers to Closer
         * @param {InviteManyAdvisersForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteManyAdvisers(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling inviteManyAdvisers.');
            }
            const localVarPath = `/invitees/many`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("InviteManyAdvisersForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Resend adviser invitation to Closer
         * @param {ResendInvitationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling resendInvitation.');
            }
            const localVarPath = `/invitees/resend`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ResendInvitationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke adviser invitation
         * @param {RevokeInvitationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling revokeInvitation.');
            }
            const localVarPath = `/invitees/revoke`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RevokeInvitationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.InviteesApiFetchParamCreator = InviteesApiFetchParamCreator;
/**
 * InviteesApi - functional programming interface
 * @export
 */
const InviteesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Create adviser account from invitation
         * @param {AcceptInvitationForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(body, token, options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).acceptInvitation(body, token, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get pending invited advisers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteesByOrg(options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).getInviteesByOrg(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Check if token is valid and get names set by admin
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenValidity(token, options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).getTokenValidity(token, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Invite adviser to Closer
         * @param {InviteeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAdviser(body, options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).inviteAdviser(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Invite advisers to Closer
         * @param {InviteManyAdvisersForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteManyAdvisers(body, options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).inviteManyAdvisers(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Resend adviser invitation to Closer
         * @param {ResendInvitationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation(body, options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).resendInvitation(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Revoke adviser invitation
         * @param {RevokeInvitationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(body, options) {
            const localVarFetchArgs = (0, exports.InviteesApiFetchParamCreator)(configuration).revokeInvitation(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.InviteesApiFp = InviteesApiFp;
/**
 * InviteesApi - factory interface
 * @export
 */
const InviteesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Create adviser account from invitation
         * @param {AcceptInvitationForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(body, token, options) {
            return (0, exports.InviteesApiFp)(configuration).acceptInvitation(body, token, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get pending invited advisers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteesByOrg(options) {
            return (0, exports.InviteesApiFp)(configuration).getInviteesByOrg(options)(fetch, basePath);
        },
        /**
         *
         * @summary Check if token is valid and get names set by admin
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenValidity(token, options) {
            return (0, exports.InviteesApiFp)(configuration).getTokenValidity(token, options)(fetch, basePath);
        },
        /**
         *
         * @summary Invite adviser to Closer
         * @param {InviteeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAdviser(body, options) {
            return (0, exports.InviteesApiFp)(configuration).inviteAdviser(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Invite advisers to Closer
         * @param {InviteManyAdvisersForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteManyAdvisers(body, options) {
            return (0, exports.InviteesApiFp)(configuration).inviteManyAdvisers(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Resend adviser invitation to Closer
         * @param {ResendInvitationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation(body, options) {
            return (0, exports.InviteesApiFp)(configuration).resendInvitation(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Revoke adviser invitation
         * @param {RevokeInvitationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(body, options) {
            return (0, exports.InviteesApiFp)(configuration).revokeInvitation(body, options)(fetch, basePath);
        },
    };
};
exports.InviteesApiFactory = InviteesApiFactory;
/**
 * InviteesApi - object-oriented interface
 * @export
 * @class InviteesApi
 * @extends {BaseAPI}
 */
class InviteesApi extends BaseAPI {
    /**
     *
     * @summary Create adviser account from invitation
     * @param {AcceptInvitationForm} body
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    acceptInvitation(body, token, options) {
        return (0, exports.InviteesApiFp)(this.configuration).acceptInvitation(body, token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get pending invited advisers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    getInviteesByOrg(options) {
        return (0, exports.InviteesApiFp)(this.configuration).getInviteesByOrg(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Check if token is valid and get names set by admin
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    getTokenValidity(token, options) {
        return (0, exports.InviteesApiFp)(this.configuration).getTokenValidity(token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Invite adviser to Closer
     * @param {InviteeForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    inviteAdviser(body, options) {
        return (0, exports.InviteesApiFp)(this.configuration).inviteAdviser(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Invite advisers to Closer
     * @param {InviteManyAdvisersForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    inviteManyAdvisers(body, options) {
        return (0, exports.InviteesApiFp)(this.configuration).inviteManyAdvisers(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Resend adviser invitation to Closer
     * @param {ResendInvitationForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    resendInvitation(body, options) {
        return (0, exports.InviteesApiFp)(this.configuration).resendInvitation(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Revoke adviser invitation
     * @param {RevokeInvitationForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteesApi
     */
    revokeInvitation(body, options) {
        return (0, exports.InviteesApiFp)(this.configuration).revokeInvitation(body, options)(this.fetch, this.basePath);
    }
}
exports.InviteesApi = InviteesApi;
/**
 * KnowledgeBasesApi - fetch parameter creator
 * @export
 */
const KnowledgeBasesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete knowledge base with its files
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/knowledge-bases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create knowledge base
         * @param {KnowledgeBaseCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling create.');
            }
            const localVarPath = `/knowledge-bases`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("KnowledgeBaseCreateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create knowledge base's handle
         * @param {string} id
         * @param {KnowledgeBaseFileCreateForm} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeBaseHandle(id, body, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling createKnowledgeBaseHandle.');
            }
            const localVarPath = `/knowledge-bases/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("KnowledgeBaseFileCreateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete knowledge base's file
         * @param {string} knowledgeBaseId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(knowledgeBaseId, fileId, options = {}) {
            // verify required parameter 'knowledgeBaseId' is not null or undefined
            if (knowledgeBaseId === null || knowledgeBaseId === undefined) {
                throw new RequiredError('knowledgeBaseId', 'Required parameter knowledgeBaseId was null or undefined when calling deleteFile.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId', 'Required parameter fileId was null or undefined when calling deleteFile.');
            }
            const localVarPath = `/knowledge-bases/{knowledgeBaseId}/files/{fileId}`
                .replace(`{${"knowledgeBaseId"}}`, encodeURIComponent(String(knowledgeBaseId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get knowledge bases by orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrgId(options = {}) {
            const localVarPath = `/knowledge-bases`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get uploaded knowledge base's files
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadedFiles(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getUploadedFiles.');
            }
            const localVarPath = `/knowledge-bases/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update knowledge base
         * @param {string} id
         * @param {KnowledgeBaseUpdateForm} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, body, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling update.');
            }
            const localVarPath = `/knowledge-bases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("KnowledgeBaseUpdateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.KnowledgeBasesApiFetchParamCreator = KnowledgeBasesApiFetchParamCreator;
/**
 * KnowledgeBasesApi - functional programming interface
 * @export
 */
const KnowledgeBasesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Delete knowledge base with its files
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration)._delete(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create knowledge base
         * @param {KnowledgeBaseCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body, options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration).create(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create knowledge base's handle
         * @param {string} id
         * @param {KnowledgeBaseFileCreateForm} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeBaseHandle(id, body, options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration).createKnowledgeBaseHandle(id, body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete knowledge base's file
         * @param {string} knowledgeBaseId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(knowledgeBaseId, fileId, options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration).deleteFile(knowledgeBaseId, fileId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get knowledge bases by orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrgId(options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration).getByOrgId(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get uploaded knowledge base's files
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadedFiles(id, options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration).getUploadedFiles(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update knowledge base
         * @param {string} id
         * @param {KnowledgeBaseUpdateForm} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, body, options) {
            const localVarFetchArgs = (0, exports.KnowledgeBasesApiFetchParamCreator)(configuration).update(id, body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.KnowledgeBasesApiFp = KnowledgeBasesApiFp;
/**
 * KnowledgeBasesApi - factory interface
 * @export
 */
const KnowledgeBasesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Delete knowledge base with its files
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id, options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration)._delete(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create knowledge base
         * @param {KnowledgeBaseCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body, options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration).create(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create knowledge base's handle
         * @param {string} id
         * @param {KnowledgeBaseFileCreateForm} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnowledgeBaseHandle(id, body, options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration).createKnowledgeBaseHandle(id, body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete knowledge base's file
         * @param {string} knowledgeBaseId
         * @param {string} fileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(knowledgeBaseId, fileId, options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration).deleteFile(knowledgeBaseId, fileId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get knowledge bases by orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByOrgId(options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration).getByOrgId(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get uploaded knowledge base's files
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadedFiles(id, options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration).getUploadedFiles(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update knowledge base
         * @param {string} id
         * @param {KnowledgeBaseUpdateForm} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id, body, options) {
            return (0, exports.KnowledgeBasesApiFp)(configuration).update(id, body, options)(fetch, basePath);
        },
    };
};
exports.KnowledgeBasesApiFactory = KnowledgeBasesApiFactory;
/**
 * KnowledgeBasesApi - object-oriented interface
 * @export
 * @class KnowledgeBasesApi
 * @extends {BaseAPI}
 */
class KnowledgeBasesApi extends BaseAPI {
    /**
     *
     * @summary Delete knowledge base with its files
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    _delete(id, options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration)._delete(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create knowledge base
     * @param {KnowledgeBaseCreateForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    create(body, options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration).create(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create knowledge base's handle
     * @param {string} id
     * @param {KnowledgeBaseFileCreateForm} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    createKnowledgeBaseHandle(id, body, options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration).createKnowledgeBaseHandle(id, body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete knowledge base's file
     * @param {string} knowledgeBaseId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    deleteFile(knowledgeBaseId, fileId, options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration).deleteFile(knowledgeBaseId, fileId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get knowledge bases by orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    getByOrgId(options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration).getByOrgId(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get uploaded knowledge base's files
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    getUploadedFiles(id, options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration).getUploadedFiles(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update knowledge base
     * @param {string} id
     * @param {KnowledgeBaseUpdateForm} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBasesApi
     */
    update(id, body, options) {
        return (0, exports.KnowledgeBasesApiFp)(this.configuration).update(id, body, options)(this.fetch, this.basePath);
    }
}
exports.KnowledgeBasesApi = KnowledgeBasesApi;
/**
 * MainNotificationsApi - fetch parameter creator
 * @export
 */
const MainNotificationsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create main notification
         * @param {MainNotificationPostForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMainNotification(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createMainNotification.');
            }
            const localVarPath = `/notifications/main-notifications`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MainNotificationPostForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to get main notifications
         * @param {string} [locale] locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainNotifications(locale, options = {}) {
            const localVarPath = `/notifications/main-notifications`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to patch main notification
         * @param {MainNotificationPatchForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMainNotification(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchMainNotification.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchMainNotification.');
            }
            const localVarPath = `/notifications/main-notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MainNotificationPatchForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MainNotificationsApiFetchParamCreator = MainNotificationsApiFetchParamCreator;
/**
 * MainNotificationsApi - functional programming interface
 * @export
 */
const MainNotificationsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create main notification
         * @param {MainNotificationPostForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMainNotification(body, options) {
            const localVarFetchArgs = (0, exports.MainNotificationsApiFetchParamCreator)(configuration).createMainNotification(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to get main notifications
         * @param {string} [locale] locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainNotifications(locale, options) {
            const localVarFetchArgs = (0, exports.MainNotificationsApiFetchParamCreator)(configuration).getMainNotifications(locale, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to patch main notification
         * @param {MainNotificationPatchForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMainNotification(body, id, options) {
            const localVarFetchArgs = (0, exports.MainNotificationsApiFetchParamCreator)(configuration).patchMainNotification(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MainNotificationsApiFp = MainNotificationsApiFp;
/**
 * MainNotificationsApi - factory interface
 * @export
 */
const MainNotificationsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary endpoint to create main notification
         * @param {MainNotificationPostForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMainNotification(body, options) {
            return (0, exports.MainNotificationsApiFp)(configuration).createMainNotification(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to get main notifications
         * @param {string} [locale] locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainNotifications(locale, options) {
            return (0, exports.MainNotificationsApiFp)(configuration).getMainNotifications(locale, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to patch main notification
         * @param {MainNotificationPatchForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMainNotification(body, id, options) {
            return (0, exports.MainNotificationsApiFp)(configuration).patchMainNotification(body, id, options)(fetch, basePath);
        },
    };
};
exports.MainNotificationsApiFactory = MainNotificationsApiFactory;
/**
 * MainNotificationsApi - object-oriented interface
 * @export
 * @class MainNotificationsApi
 * @extends {BaseAPI}
 */
class MainNotificationsApi extends BaseAPI {
    /**
     *
     * @summary endpoint to create main notification
     * @param {MainNotificationPostForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainNotificationsApi
     */
    createMainNotification(body, options) {
        return (0, exports.MainNotificationsApiFp)(this.configuration).createMainNotification(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to get main notifications
     * @param {string} [locale] locale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainNotificationsApi
     */
    getMainNotifications(locale, options) {
        return (0, exports.MainNotificationsApiFp)(this.configuration).getMainNotifications(locale, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to patch main notification
     * @param {MainNotificationPatchForm} body
     * @param {string} id primary key of record which should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MainNotificationsApi
     */
    patchMainNotification(body, id, options) {
        return (0, exports.MainNotificationsApiFp)(this.configuration).patchMainNotification(body, id, options)(this.fetch, this.basePath);
    }
}
exports.MainNotificationsApi = MainNotificationsApi;
/**
 * MeetingsApi - fetch parameter creator
 * @export
 */
const MeetingsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Cancel a meeting
         * @param {CancelMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeeting(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling cancelMeeting.');
            }
            const localVarPath = `/meetings/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CancelMeeting" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LureCancel} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCancel(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling customerCancel.');
            }
            const localVarPath = `/meetings/bot/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LureCancel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LureSchedule} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSchedule(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling customerSchedule.');
            }
            const localVarPath = `/meetings/bot/schedule`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LureSchedule" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LureSlots} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotSlots(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling getBotSlots.');
            }
            const localVarPath = `/meetings/bot/slots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LureSlots" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get free meeting slots
         * @param {number} start The lowest timestamp to be taken into account (starting time).
         * @param {number} stop The highest timestamp to be taken into account (ending time).
         * @param {string} [agentId] If this field is present, it&#x27;ll only include slots of the specified agent.
         * @param {string} [meetingId] If this field is present, then slot for this meeting is not counted as occupied.
         * @param {number} [duration] Slots duration in miliseconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeSlots(start, stop, agentId, meetingId, duration, options = {}) {
            // verify required parameter 'start' is not null or undefined
            if (start === null || start === undefined) {
                throw new RequiredError('start', 'Required parameter start was null or undefined when calling getFreeSlots.');
            }
            // verify required parameter 'stop' is not null or undefined
            if (stop === null || stop === undefined) {
                throw new RequiredError('stop', 'Required parameter stop was null or undefined when calling getFreeSlots.');
            }
            const localVarPath = `/meetings/slots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (stop !== undefined) {
                localVarQueryParameter['stop'] = stop;
            }
            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }
            if (meetingId !== undefined) {
                localVarQueryParameter['meetingId'] = meetingId;
            }
            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get your meetings
         * @param {number} [from] If this field is present along with &#x60;to&#x60;, then only meetings in the period are returned
         * @param {number} [to] If this field is present along with &#x60;from&#x60;, then only meetings in the period are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetings(from, to, options = {}) {
            const localVarPath = `/meetings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get meetings in room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomMeetings(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling getRoomMeetings.');
            }
            const localVarPath = `/meetings/rooms/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Recall meeting bot rom room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recallMeetingLure(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling recallMeetingLure.');
            }
            const localVarPath = `/meetings/bot/lure/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reschedule a meeting
         * @param {RescheduleMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleMeeting(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling rescheduleMeeting.');
            }
            const localVarPath = `/meetings/reschedule`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RescheduleMeeting" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reserve a slot
         * @param {ReserveSlot} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveSlot(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling reserveSlot.');
            }
            const localVarPath = `/meetings/slots`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReserveSlot" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule a meeting
         * @param {ScheduleMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMeeting(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling scheduleMeeting.');
            }
            const localVarPath = `/meetings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ScheduleMeeting" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule a meeting with an external client
         * @param {ScheduleMeetingExternal} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMeetingExternal(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling scheduleMeetingExternal.');
            }
            const localVarPath = `/meetings/external`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ScheduleMeetingExternal" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send meeting bot to room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMeetingLure(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling sendMeetingLure.');
            }
            const localVarPath = `/meetings/bot/lure/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MeetingsApiFetchParamCreator = MeetingsApiFetchParamCreator;
/**
 * MeetingsApi - functional programming interface
 * @export
 */
const MeetingsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Cancel a meeting
         * @param {CancelMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeeting(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).cancelMeeting(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {LureCancel} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCancel(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).customerCancel(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {LureSchedule} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSchedule(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).customerSchedule(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {LureSlots} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotSlots(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).getBotSlots(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get free meeting slots
         * @param {number} start The lowest timestamp to be taken into account (starting time).
         * @param {number} stop The highest timestamp to be taken into account (ending time).
         * @param {string} [agentId] If this field is present, it&#x27;ll only include slots of the specified agent.
         * @param {string} [meetingId] If this field is present, then slot for this meeting is not counted as occupied.
         * @param {number} [duration] Slots duration in miliseconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeSlots(start, stop, agentId, meetingId, duration, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).getFreeSlots(start, stop, agentId, meetingId, duration, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get your meetings
         * @param {number} [from] If this field is present along with &#x60;to&#x60;, then only meetings in the period are returned
         * @param {number} [to] If this field is present along with &#x60;from&#x60;, then only meetings in the period are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetings(from, to, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).getMeetings(from, to, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get meetings in room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomMeetings(roomId, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).getRoomMeetings(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Recall meeting bot rom room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recallMeetingLure(roomId, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).recallMeetingLure(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Reschedule a meeting
         * @param {RescheduleMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleMeeting(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).rescheduleMeeting(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Reserve a slot
         * @param {ReserveSlot} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveSlot(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).reserveSlot(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Schedule a meeting
         * @param {ScheduleMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMeeting(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).scheduleMeeting(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Schedule a meeting with an external client
         * @param {ScheduleMeetingExternal} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMeetingExternal(body, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).scheduleMeetingExternal(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send meeting bot to room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMeetingLure(roomId, options) {
            const localVarFetchArgs = (0, exports.MeetingsApiFetchParamCreator)(configuration).sendMeetingLure(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MeetingsApiFp = MeetingsApiFp;
/**
 * MeetingsApi - factory interface
 * @export
 */
const MeetingsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Cancel a meeting
         * @param {CancelMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeeting(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).cancelMeeting(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {LureCancel} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerCancel(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).customerCancel(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {LureSchedule} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSchedule(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).customerSchedule(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {LureSlots} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotSlots(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).getBotSlots(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get free meeting slots
         * @param {number} start The lowest timestamp to be taken into account (starting time).
         * @param {number} stop The highest timestamp to be taken into account (ending time).
         * @param {string} [agentId] If this field is present, it&#x27;ll only include slots of the specified agent.
         * @param {string} [meetingId] If this field is present, then slot for this meeting is not counted as occupied.
         * @param {number} [duration] Slots duration in miliseconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeSlots(start, stop, agentId, meetingId, duration, options) {
            return (0, exports.MeetingsApiFp)(configuration).getFreeSlots(start, stop, agentId, meetingId, duration, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get your meetings
         * @param {number} [from] If this field is present along with &#x60;to&#x60;, then only meetings in the period are returned
         * @param {number} [to] If this field is present along with &#x60;from&#x60;, then only meetings in the period are returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetings(from, to, options) {
            return (0, exports.MeetingsApiFp)(configuration).getMeetings(from, to, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get meetings in room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomMeetings(roomId, options) {
            return (0, exports.MeetingsApiFp)(configuration).getRoomMeetings(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Recall meeting bot rom room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recallMeetingLure(roomId, options) {
            return (0, exports.MeetingsApiFp)(configuration).recallMeetingLure(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reschedule a meeting
         * @param {RescheduleMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleMeeting(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).rescheduleMeeting(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reserve a slot
         * @param {ReserveSlot} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveSlot(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).reserveSlot(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Schedule a meeting
         * @param {ScheduleMeeting} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMeeting(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).scheduleMeeting(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Schedule a meeting with an external client
         * @param {ScheduleMeetingExternal} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMeetingExternal(body, options) {
            return (0, exports.MeetingsApiFp)(configuration).scheduleMeetingExternal(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send meeting bot to room
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMeetingLure(roomId, options) {
            return (0, exports.MeetingsApiFp)(configuration).sendMeetingLure(roomId, options)(fetch, basePath);
        },
    };
};
exports.MeetingsApiFactory = MeetingsApiFactory;
/**
 * MeetingsApi - object-oriented interface
 * @export
 * @class MeetingsApi
 * @extends {BaseAPI}
 */
class MeetingsApi extends BaseAPI {
    /**
     *
     * @summary Cancel a meeting
     * @param {CancelMeeting} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    cancelMeeting(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).cancelMeeting(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {LureCancel} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    customerCancel(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).customerCancel(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {LureSchedule} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    customerSchedule(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).customerSchedule(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {LureSlots} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    getBotSlots(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).getBotSlots(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get free meeting slots
     * @param {number} start The lowest timestamp to be taken into account (starting time).
     * @param {number} stop The highest timestamp to be taken into account (ending time).
     * @param {string} [agentId] If this field is present, it&#x27;ll only include slots of the specified agent.
     * @param {string} [meetingId] If this field is present, then slot for this meeting is not counted as occupied.
     * @param {number} [duration] Slots duration in miliseconds.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    getFreeSlots(start, stop, agentId, meetingId, duration, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).getFreeSlots(start, stop, agentId, meetingId, duration, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get your meetings
     * @param {number} [from] If this field is present along with &#x60;to&#x60;, then only meetings in the period are returned
     * @param {number} [to] If this field is present along with &#x60;from&#x60;, then only meetings in the period are returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    getMeetings(from, to, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).getMeetings(from, to, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get meetings in room
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    getRoomMeetings(roomId, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).getRoomMeetings(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Recall meeting bot rom room
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    recallMeetingLure(roomId, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).recallMeetingLure(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Reschedule a meeting
     * @param {RescheduleMeeting} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    rescheduleMeeting(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).rescheduleMeeting(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Reserve a slot
     * @param {ReserveSlot} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    reserveSlot(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).reserveSlot(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Schedule a meeting
     * @param {ScheduleMeeting} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    scheduleMeeting(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).scheduleMeeting(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Schedule a meeting with an external client
     * @param {ScheduleMeetingExternal} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    scheduleMeetingExternal(body, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).scheduleMeetingExternal(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send meeting bot to room
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    sendMeetingLure(roomId, options) {
        return (0, exports.MeetingsApiFp)(this.configuration).sendMeetingLure(roomId, options)(this.fetch, this.basePath);
    }
}
exports.MeetingsApi = MeetingsApi;
/**
 * MessageWidgetsApi - fetch parameter creator
 * @export
 */
const MessageWidgetsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary post message widgets config by locale
         * @param {MessageWidgetForm} body
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageWidgetConfig(body, value, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createMessageWidgetConfig.');
            }
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError('value', 'Required parameter value was null or undefined when calling createMessageWidgetConfig.');
            }
            const localVarPath = `/message-widgets/{value}`
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MessageWidgetForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete message widget config by widget id
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessageWidgetConfig(value, options = {}) {
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError('value', 'Required parameter value was null or undefined when calling deleteMessageWidgetConfig.');
            }
            const localVarPath = `/message-widgets/{value}`
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get message widget config
         * @param {string} orgId
         * @param {string} widgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageWidgetConfig(orgId, widgetId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getMessageWidgetConfig.');
            }
            // verify required parameter 'widgetId' is not null or undefined
            if (widgetId === null || widgetId === undefined) {
                throw new RequiredError('widgetId', 'Required parameter widgetId was null or undefined when calling getMessageWidgetConfig.');
            }
            const localVarPath = `/message-widgets/{orgId}/{widgetId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"widgetId"}}`, encodeURIComponent(String(widgetId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get message widgets configs for org and locale
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageWidgetsConfigs(value, options = {}) {
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError('value', 'Required parameter value was null or undefined when calling getMessageWidgetsConfigs.');
            }
            const localVarPath = `/message-widgets/{value}`
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update message widget config by widget id
         * @param {MessageWidgetForm} body
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageWidgetConfig(body, value, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateMessageWidgetConfig.');
            }
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError('value', 'Required parameter value was null or undefined when calling updateMessageWidgetConfig.');
            }
            const localVarPath = `/message-widgets/{value}`
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MessageWidgetForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MessageWidgetsApiFetchParamCreator = MessageWidgetsApiFetchParamCreator;
/**
 * MessageWidgetsApi - functional programming interface
 * @export
 */
const MessageWidgetsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary post message widgets config by locale
         * @param {MessageWidgetForm} body
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageWidgetConfig(body, value, options) {
            const localVarFetchArgs = (0, exports.MessageWidgetsApiFetchParamCreator)(configuration).createMessageWidgetConfig(body, value, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete message widget config by widget id
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessageWidgetConfig(value, options) {
            const localVarFetchArgs = (0, exports.MessageWidgetsApiFetchParamCreator)(configuration).deleteMessageWidgetConfig(value, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get message widget config
         * @param {string} orgId
         * @param {string} widgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageWidgetConfig(orgId, widgetId, options) {
            const localVarFetchArgs = (0, exports.MessageWidgetsApiFetchParamCreator)(configuration).getMessageWidgetConfig(orgId, widgetId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get message widgets configs for org and locale
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageWidgetsConfigs(value, options) {
            const localVarFetchArgs = (0, exports.MessageWidgetsApiFetchParamCreator)(configuration).getMessageWidgetsConfigs(value, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update message widget config by widget id
         * @param {MessageWidgetForm} body
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageWidgetConfig(body, value, options) {
            const localVarFetchArgs = (0, exports.MessageWidgetsApiFetchParamCreator)(configuration).updateMessageWidgetConfig(body, value, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MessageWidgetsApiFp = MessageWidgetsApiFp;
/**
 * MessageWidgetsApi - factory interface
 * @export
 */
const MessageWidgetsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary post message widgets config by locale
         * @param {MessageWidgetForm} body
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageWidgetConfig(body, value, options) {
            return (0, exports.MessageWidgetsApiFp)(configuration).createMessageWidgetConfig(body, value, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete message widget config by widget id
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessageWidgetConfig(value, options) {
            return (0, exports.MessageWidgetsApiFp)(configuration).deleteMessageWidgetConfig(value, options)(fetch, basePath);
        },
        /**
         *
         * @summary get message widget config
         * @param {string} orgId
         * @param {string} widgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageWidgetConfig(orgId, widgetId, options) {
            return (0, exports.MessageWidgetsApiFp)(configuration).getMessageWidgetConfig(orgId, widgetId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get message widgets configs for org and locale
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageWidgetsConfigs(value, options) {
            return (0, exports.MessageWidgetsApiFp)(configuration).getMessageWidgetsConfigs(value, options)(fetch, basePath);
        },
        /**
         *
         * @summary update message widget config by widget id
         * @param {MessageWidgetForm} body
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageWidgetConfig(body, value, options) {
            return (0, exports.MessageWidgetsApiFp)(configuration).updateMessageWidgetConfig(body, value, options)(fetch, basePath);
        },
    };
};
exports.MessageWidgetsApiFactory = MessageWidgetsApiFactory;
/**
 * MessageWidgetsApi - object-oriented interface
 * @export
 * @class MessageWidgetsApi
 * @extends {BaseAPI}
 */
class MessageWidgetsApi extends BaseAPI {
    /**
     *
     * @summary post message widgets config by locale
     * @param {MessageWidgetForm} body
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageWidgetsApi
     */
    createMessageWidgetConfig(body, value, options) {
        return (0, exports.MessageWidgetsApiFp)(this.configuration).createMessageWidgetConfig(body, value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete message widget config by widget id
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageWidgetsApi
     */
    deleteMessageWidgetConfig(value, options) {
        return (0, exports.MessageWidgetsApiFp)(this.configuration).deleteMessageWidgetConfig(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get message widget config
     * @param {string} orgId
     * @param {string} widgetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageWidgetsApi
     */
    getMessageWidgetConfig(orgId, widgetId, options) {
        return (0, exports.MessageWidgetsApiFp)(this.configuration).getMessageWidgetConfig(orgId, widgetId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get message widgets configs for org and locale
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageWidgetsApi
     */
    getMessageWidgetsConfigs(value, options) {
        return (0, exports.MessageWidgetsApiFp)(this.configuration).getMessageWidgetsConfigs(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update message widget config by widget id
     * @param {MessageWidgetForm} body
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageWidgetsApi
     */
    updateMessageWidgetConfig(body, value, options) {
        return (0, exports.MessageWidgetsApiFp)(this.configuration).updateMessageWidgetConfig(body, value, options)(this.fetch, this.basePath);
    }
}
exports.MessageWidgetsApi = MessageWidgetsApi;
/**
 * NLUApi - fetch parameter creator
 * @export
 */
const NLUApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary information whether AI suggestions are enabled for this organization or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areAISuggestionsEnabled(options = {}) {
            const localVarPath = `/nlu`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary create entry in AI suggestions model training dataset
         * @param {DatasetEntryForm} body
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetEntry(body, intentId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createDatasetEntry.');
            }
            // verify required parameter 'intentId' is not null or undefined
            if (intentId === null || intentId === undefined) {
                throw new RequiredError('intentId', 'Required parameter intentId was null or undefined when calling createDatasetEntry.');
            }
            const localVarPath = `/nlu/intents/{intentId}/dataset`
                .replace(`{${"intentId"}}`, encodeURIComponent(String(intentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("DatasetEntryForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary create response for nlu intent
         * @param {IntentForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntent(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createIntent.');
            }
            const localVarPath = `/nlu/intents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("IntentForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete entry in training dataset
         * @param {string} intentId
         * @param {string} entryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasetEntry(intentId, entryId, options = {}) {
            // verify required parameter 'intentId' is not null or undefined
            if (intentId === null || intentId === undefined) {
                throw new RequiredError('intentId', 'Required parameter intentId was null or undefined when calling deleteDatasetEntry.');
            }
            // verify required parameter 'entryId' is not null or undefined
            if (entryId === null || entryId === undefined) {
                throw new RequiredError('entryId', 'Required parameter entryId was null or undefined when calling deleteDatasetEntry.');
            }
            const localVarPath = `/nlu/intents/{intentId}/dataset/{entryId}`
                .replace(`{${"intentId"}}`, encodeURIComponent(String(intentId)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete response for nlu intent
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntent(intentId, options = {}) {
            // verify required parameter 'intentId' is not null or undefined
            if (intentId === null || intentId === undefined) {
                throw new RequiredError('intentId', 'Required parameter intentId was null or undefined when calling deleteIntent.');
            }
            const localVarPath = `/nlu/intents/{intentId}`
                .replace(`{${"intentId"}}`, encodeURIComponent(String(intentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary retrieve entries from training dataset
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetEntries(intentId, options = {}) {
            // verify required parameter 'intentId' is not null or undefined
            if (intentId === null || intentId === undefined) {
                throw new RequiredError('intentId', 'Required parameter intentId was null or undefined when calling getDatasetEntries.');
            }
            const localVarPath = `/nlu/intents/{intentId}/dataset`
                .replace(`{${"intentId"}}`, encodeURIComponent(String(intentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to retrieve intents along with corresponding training dataset info
         * @param {string} [locale]
         * @param {string} [intentFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntents(locale, intentFilter, options = {}) {
            const localVarPath = `/nlu/intents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (intentFilter !== undefined) {
                localVarQueryParameter['intentFilter'] = intentFilter;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get timestamp and status of most recent model training for given language and org along with model stamp (ID)
         * @param {boolean} onlyLast
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingInfo(onlyLast, locale, options = {}) {
            // verify required parameter 'onlyLast' is not null or undefined
            if (onlyLast === null || onlyLast === undefined) {
                throw new RequiredError('onlyLast', 'Required parameter onlyLast was null or undefined when calling getTrainingInfo.');
            }
            const localVarPath = `/nlu/training`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (onlyLast !== undefined) {
                localVarQueryParameter['onlyLast'] = onlyLast;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary set AI suggestions enabled flag
         * @param {EnabledFlag} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAISuggestionsEnabled(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAISuggestionsEnabled.');
            }
            const localVarPath = `/nlu`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EnabledFlag" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary test AI suggestions
         * @param {TestSuggestionForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuggestion(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling testSuggestion.');
            }
            const localVarPath = `/nlu/prediction`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TestSuggestionForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary start AI suggestions model training
         * @param {TrainModelForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trainModel(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling trainModel.');
            }
            const localVarPath = `/nlu/training`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TrainModelForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update entry in training dataset
         * @param {DatasetEntryForm} body
         * @param {string} intentId
         * @param {string} entryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetEntry(body, intentId, entryId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateDatasetEntry.');
            }
            // verify required parameter 'intentId' is not null or undefined
            if (intentId === null || intentId === undefined) {
                throw new RequiredError('intentId', 'Required parameter intentId was null or undefined when calling updateDatasetEntry.');
            }
            // verify required parameter 'entryId' is not null or undefined
            if (entryId === null || entryId === undefined) {
                throw new RequiredError('entryId', 'Required parameter entryId was null or undefined when calling updateDatasetEntry.');
            }
            const localVarPath = `/nlu/intents/{intentId}/dataset/{entryId}`
                .replace(`{${"intentId"}}`, encodeURIComponent(String(intentId)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("DatasetEntryForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update nlu intent
         * @param {IntentForm} body
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntent(body, intentId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateIntent.');
            }
            // verify required parameter 'intentId' is not null or undefined
            if (intentId === null || intentId === undefined) {
                throw new RequiredError('intentId', 'Required parameter intentId was null or undefined when calling updateIntent.');
            }
            const localVarPath = `/nlu/intents/{intentId}`
                .replace(`{${"intentId"}}`, encodeURIComponent(String(intentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("IntentForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.NLUApiFetchParamCreator = NLUApiFetchParamCreator;
/**
 * NLUApi - functional programming interface
 * @export
 */
const NLUApiFp = function (configuration) {
    return {
        /**
         *
         * @summary information whether AI suggestions are enabled for this organization or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areAISuggestionsEnabled(options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).areAISuggestionsEnabled(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary create entry in AI suggestions model training dataset
         * @param {DatasetEntryForm} body
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetEntry(body, intentId, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).createDatasetEntry(body, intentId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary create response for nlu intent
         * @param {IntentForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntent(body, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).createIntent(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete entry in training dataset
         * @param {string} intentId
         * @param {string} entryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasetEntry(intentId, entryId, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).deleteDatasetEntry(intentId, entryId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete response for nlu intent
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntent(intentId, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).deleteIntent(intentId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary retrieve entries from training dataset
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetEntries(intentId, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).getDatasetEntries(intentId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to retrieve intents along with corresponding training dataset info
         * @param {string} [locale]
         * @param {string} [intentFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntents(locale, intentFilter, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).getIntents(locale, intentFilter, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get timestamp and status of most recent model training for given language and org along with model stamp (ID)
         * @param {boolean} onlyLast
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingInfo(onlyLast, locale, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).getTrainingInfo(onlyLast, locale, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary set AI suggestions enabled flag
         * @param {EnabledFlag} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAISuggestionsEnabled(body, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).setAISuggestionsEnabled(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary test AI suggestions
         * @param {TestSuggestionForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuggestion(body, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).testSuggestion(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary start AI suggestions model training
         * @param {TrainModelForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trainModel(body, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).trainModel(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update entry in training dataset
         * @param {DatasetEntryForm} body
         * @param {string} intentId
         * @param {string} entryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetEntry(body, intentId, entryId, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).updateDatasetEntry(body, intentId, entryId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update nlu intent
         * @param {IntentForm} body
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntent(body, intentId, options) {
            const localVarFetchArgs = (0, exports.NLUApiFetchParamCreator)(configuration).updateIntent(body, intentId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.NLUApiFp = NLUApiFp;
/**
 * NLUApi - factory interface
 * @export
 */
const NLUApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary information whether AI suggestions are enabled for this organization or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areAISuggestionsEnabled(options) {
            return (0, exports.NLUApiFp)(configuration).areAISuggestionsEnabled(options)(fetch, basePath);
        },
        /**
         *
         * @summary create entry in AI suggestions model training dataset
         * @param {DatasetEntryForm} body
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasetEntry(body, intentId, options) {
            return (0, exports.NLUApiFp)(configuration).createDatasetEntry(body, intentId, options)(fetch, basePath);
        },
        /**
         *
         * @summary create response for nlu intent
         * @param {IntentForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntent(body, options) {
            return (0, exports.NLUApiFp)(configuration).createIntent(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete entry in training dataset
         * @param {string} intentId
         * @param {string} entryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasetEntry(intentId, entryId, options) {
            return (0, exports.NLUApiFp)(configuration).deleteDatasetEntry(intentId, entryId, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete response for nlu intent
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntent(intentId, options) {
            return (0, exports.NLUApiFp)(configuration).deleteIntent(intentId, options)(fetch, basePath);
        },
        /**
         *
         * @summary retrieve entries from training dataset
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetEntries(intentId, options) {
            return (0, exports.NLUApiFp)(configuration).getDatasetEntries(intentId, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to retrieve intents along with corresponding training dataset info
         * @param {string} [locale]
         * @param {string} [intentFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntents(locale, intentFilter, options) {
            return (0, exports.NLUApiFp)(configuration).getIntents(locale, intentFilter, options)(fetch, basePath);
        },
        /**
         *
         * @summary get timestamp and status of most recent model training for given language and org along with model stamp (ID)
         * @param {boolean} onlyLast
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingInfo(onlyLast, locale, options) {
            return (0, exports.NLUApiFp)(configuration).getTrainingInfo(onlyLast, locale, options)(fetch, basePath);
        },
        /**
         *
         * @summary set AI suggestions enabled flag
         * @param {EnabledFlag} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAISuggestionsEnabled(body, options) {
            return (0, exports.NLUApiFp)(configuration).setAISuggestionsEnabled(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary test AI suggestions
         * @param {TestSuggestionForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuggestion(body, options) {
            return (0, exports.NLUApiFp)(configuration).testSuggestion(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary start AI suggestions model training
         * @param {TrainModelForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trainModel(body, options) {
            return (0, exports.NLUApiFp)(configuration).trainModel(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary update entry in training dataset
         * @param {DatasetEntryForm} body
         * @param {string} intentId
         * @param {string} entryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatasetEntry(body, intentId, entryId, options) {
            return (0, exports.NLUApiFp)(configuration).updateDatasetEntry(body, intentId, entryId, options)(fetch, basePath);
        },
        /**
         *
         * @summary update nlu intent
         * @param {IntentForm} body
         * @param {string} intentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntent(body, intentId, options) {
            return (0, exports.NLUApiFp)(configuration).updateIntent(body, intentId, options)(fetch, basePath);
        },
    };
};
exports.NLUApiFactory = NLUApiFactory;
/**
 * NLUApi - object-oriented interface
 * @export
 * @class NLUApi
 * @extends {BaseAPI}
 */
class NLUApi extends BaseAPI {
    /**
     *
     * @summary information whether AI suggestions are enabled for this organization or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    areAISuggestionsEnabled(options) {
        return (0, exports.NLUApiFp)(this.configuration).areAISuggestionsEnabled(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary create entry in AI suggestions model training dataset
     * @param {DatasetEntryForm} body
     * @param {string} intentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    createDatasetEntry(body, intentId, options) {
        return (0, exports.NLUApiFp)(this.configuration).createDatasetEntry(body, intentId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary create response for nlu intent
     * @param {IntentForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    createIntent(body, options) {
        return (0, exports.NLUApiFp)(this.configuration).createIntent(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete entry in training dataset
     * @param {string} intentId
     * @param {string} entryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    deleteDatasetEntry(intentId, entryId, options) {
        return (0, exports.NLUApiFp)(this.configuration).deleteDatasetEntry(intentId, entryId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete response for nlu intent
     * @param {string} intentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    deleteIntent(intentId, options) {
        return (0, exports.NLUApiFp)(this.configuration).deleteIntent(intentId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary retrieve entries from training dataset
     * @param {string} intentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    getDatasetEntries(intentId, options) {
        return (0, exports.NLUApiFp)(this.configuration).getDatasetEntries(intentId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to retrieve intents along with corresponding training dataset info
     * @param {string} [locale]
     * @param {string} [intentFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    getIntents(locale, intentFilter, options) {
        return (0, exports.NLUApiFp)(this.configuration).getIntents(locale, intentFilter, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get timestamp and status of most recent model training for given language and org along with model stamp (ID)
     * @param {boolean} onlyLast
     * @param {string} [locale]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    getTrainingInfo(onlyLast, locale, options) {
        return (0, exports.NLUApiFp)(this.configuration).getTrainingInfo(onlyLast, locale, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary set AI suggestions enabled flag
     * @param {EnabledFlag} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    setAISuggestionsEnabled(body, options) {
        return (0, exports.NLUApiFp)(this.configuration).setAISuggestionsEnabled(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary test AI suggestions
     * @param {TestSuggestionForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    testSuggestion(body, options) {
        return (0, exports.NLUApiFp)(this.configuration).testSuggestion(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary start AI suggestions model training
     * @param {TrainModelForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    trainModel(body, options) {
        return (0, exports.NLUApiFp)(this.configuration).trainModel(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update entry in training dataset
     * @param {DatasetEntryForm} body
     * @param {string} intentId
     * @param {string} entryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    updateDatasetEntry(body, intentId, entryId, options) {
        return (0, exports.NLUApiFp)(this.configuration).updateDatasetEntry(body, intentId, entryId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update nlu intent
     * @param {IntentForm} body
     * @param {string} intentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NLUApi
     */
    updateIntent(body, intentId, options) {
        return (0, exports.NLUApiFp)(this.configuration).updateIntent(body, intentId, options)(this.fetch, this.basePath);
    }
}
exports.NLUApi = NLUApi;
/**
 * OAuthApi - fetch parameter creator
 * @export
 */
const OAuthApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create oauth config
         * @param {OauthConfigCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOAuthConfig(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createOAuthConfig.');
            }
            const localVarPath = `/oauth-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OauthConfigCreateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete oauth config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOAuthConfig(options = {}) {
            const localVarPath = `/oauth-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get oauth config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthConfig(options = {}) {
            const localVarPath = `/oauth-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch oauth config
         * @param {OauthConfigPatchForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOAuthConfig(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchOAuthConfig.');
            }
            const localVarPath = `/oauth-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OauthConfigPatchForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OAuthApiFetchParamCreator = OAuthApiFetchParamCreator;
/**
 * OAuthApi - functional programming interface
 * @export
 */
const OAuthApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Create oauth config
         * @param {OauthConfigCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOAuthConfig(body, options) {
            const localVarFetchArgs = (0, exports.OAuthApiFetchParamCreator)(configuration).createOAuthConfig(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete oauth config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOAuthConfig(options) {
            const localVarFetchArgs = (0, exports.OAuthApiFetchParamCreator)(configuration).deleteOAuthConfig(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get oauth config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthConfig(options) {
            const localVarFetchArgs = (0, exports.OAuthApiFetchParamCreator)(configuration).getOAuthConfig(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Patch oauth config
         * @param {OauthConfigPatchForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOAuthConfig(body, options) {
            const localVarFetchArgs = (0, exports.OAuthApiFetchParamCreator)(configuration).patchOAuthConfig(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OAuthApiFp = OAuthApiFp;
/**
 * OAuthApi - factory interface
 * @export
 */
const OAuthApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Create oauth config
         * @param {OauthConfigCreateForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOAuthConfig(body, options) {
            return (0, exports.OAuthApiFp)(configuration).createOAuthConfig(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete oauth config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOAuthConfig(options) {
            return (0, exports.OAuthApiFp)(configuration).deleteOAuthConfig(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get oauth config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthConfig(options) {
            return (0, exports.OAuthApiFp)(configuration).getOAuthConfig(options)(fetch, basePath);
        },
        /**
         *
         * @summary Patch oauth config
         * @param {OauthConfigPatchForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOAuthConfig(body, options) {
            return (0, exports.OAuthApiFp)(configuration).patchOAuthConfig(body, options)(fetch, basePath);
        },
    };
};
exports.OAuthApiFactory = OAuthApiFactory;
/**
 * OAuthApi - object-oriented interface
 * @export
 * @class OAuthApi
 * @extends {BaseAPI}
 */
class OAuthApi extends BaseAPI {
    /**
     *
     * @summary Create oauth config
     * @param {OauthConfigCreateForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    createOAuthConfig(body, options) {
        return (0, exports.OAuthApiFp)(this.configuration).createOAuthConfig(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete oauth config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    deleteOAuthConfig(options) {
        return (0, exports.OAuthApiFp)(this.configuration).deleteOAuthConfig(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get oauth config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    getOAuthConfig(options) {
        return (0, exports.OAuthApiFp)(this.configuration).getOAuthConfig(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Patch oauth config
     * @param {OauthConfigPatchForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    patchOAuthConfig(body, options) {
        return (0, exports.OAuthApiFp)(this.configuration).patchOAuthConfig(body, options)(this.fetch, this.basePath);
    }
}
exports.OAuthApi = OAuthApi;
/**
 * OIDCApi - fetch parameter creator
 * @export
 */
const OIDCApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary authorize with code
         * @param {CodeAuthorizationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOpenIdConnect(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling authorizeOpenIdConnect.');
            }
            const localVarPath = `/oidc/code-authorization`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CodeAuthorizationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get nonce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonce(options = {}) {
            const localVarPath = `/oidc/nonce`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary unauthorized endpoint for org's oidc configuration
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenIDConnectConfigUnauthorized(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getOpenIDConnectConfigUnauthorized.');
            }
            const localVarPath = `/oidc-configs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OIDCApiFetchParamCreator = OIDCApiFetchParamCreator;
/**
 * OIDCApi - functional programming interface
 * @export
 */
const OIDCApiFp = function (configuration) {
    return {
        /**
         *
         * @summary authorize with code
         * @param {CodeAuthorizationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOpenIdConnect(body, options) {
            const localVarFetchArgs = (0, exports.OIDCApiFetchParamCreator)(configuration).authorizeOpenIdConnect(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get nonce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonce(options) {
            const localVarFetchArgs = (0, exports.OIDCApiFetchParamCreator)(configuration).getNonce(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary unauthorized endpoint for org's oidc configuration
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenIDConnectConfigUnauthorized(orgId, options) {
            const localVarFetchArgs = (0, exports.OIDCApiFetchParamCreator)(configuration).getOpenIDConnectConfigUnauthorized(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OIDCApiFp = OIDCApiFp;
/**
 * OIDCApi - factory interface
 * @export
 */
const OIDCApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary authorize with code
         * @param {CodeAuthorizationForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeOpenIdConnect(body, options) {
            return (0, exports.OIDCApiFp)(configuration).authorizeOpenIdConnect(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary get nonce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonce(options) {
            return (0, exports.OIDCApiFp)(configuration).getNonce(options)(fetch, basePath);
        },
        /**
         *
         * @summary unauthorized endpoint for org's oidc configuration
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenIDConnectConfigUnauthorized(orgId, options) {
            return (0, exports.OIDCApiFp)(configuration).getOpenIDConnectConfigUnauthorized(orgId, options)(fetch, basePath);
        },
    };
};
exports.OIDCApiFactory = OIDCApiFactory;
/**
 * OIDCApi - object-oriented interface
 * @export
 * @class OIDCApi
 * @extends {BaseAPI}
 */
class OIDCApi extends BaseAPI {
    /**
     *
     * @summary authorize with code
     * @param {CodeAuthorizationForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    authorizeOpenIdConnect(body, options) {
        return (0, exports.OIDCApiFp)(this.configuration).authorizeOpenIdConnect(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get nonce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    getNonce(options) {
        return (0, exports.OIDCApiFp)(this.configuration).getNonce(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary unauthorized endpoint for org's oidc configuration
     * @param {string} orgId orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OIDCApi
     */
    getOpenIDConnectConfigUnauthorized(orgId, options) {
        return (0, exports.OIDCApiFp)(this.configuration).getOpenIDConnectConfigUnauthorized(orgId, options)(this.fetch, this.basePath);
    }
}
exports.OIDCApi = OIDCApi;
/**
 * OplAddressApi - fetch parameter creator
 * @export
 */
const OplAddressApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to get cities
         * @param {OplAddressCityQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressCities(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling getOplAddressCities.');
            }
            const localVarPath = `/opl-address-form/cities`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OplAddressCityQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to get streets
         * @param {OplAddressStreetQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressStreets(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling getOplAddressStreets.');
            }
            const localVarPath = `/opl-address-form/streets`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OplAddressStreetQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to get zipcodes
         * @param {OplAddressZipCodeQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressZipCodes(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling getOplAddressZipCodes.');
            }
            const localVarPath = `/opl-address-form/zipCode`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OplAddressZipCodeQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OplAddressApiFetchParamCreator = OplAddressApiFetchParamCreator;
/**
 * OplAddressApi - functional programming interface
 * @export
 */
const OplAddressApiFp = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to get cities
         * @param {OplAddressCityQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressCities(body, options) {
            const localVarFetchArgs = (0, exports.OplAddressApiFetchParamCreator)(configuration).getOplAddressCities(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to get streets
         * @param {OplAddressStreetQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressStreets(body, options) {
            const localVarFetchArgs = (0, exports.OplAddressApiFetchParamCreator)(configuration).getOplAddressStreets(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to get zipcodes
         * @param {OplAddressZipCodeQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressZipCodes(body, options) {
            const localVarFetchArgs = (0, exports.OplAddressApiFetchParamCreator)(configuration).getOplAddressZipCodes(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OplAddressApiFp = OplAddressApiFp;
/**
 * OplAddressApi - factory interface
 * @export
 */
const OplAddressApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary endpoint to get cities
         * @param {OplAddressCityQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressCities(body, options) {
            return (0, exports.OplAddressApiFp)(configuration).getOplAddressCities(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to get streets
         * @param {OplAddressStreetQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressStreets(body, options) {
            return (0, exports.OplAddressApiFp)(configuration).getOplAddressStreets(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to get zipcodes
         * @param {OplAddressZipCodeQuery} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOplAddressZipCodes(body, options) {
            return (0, exports.OplAddressApiFp)(configuration).getOplAddressZipCodes(body, options)(fetch, basePath);
        },
    };
};
exports.OplAddressApiFactory = OplAddressApiFactory;
/**
 * OplAddressApi - object-oriented interface
 * @export
 * @class OplAddressApi
 * @extends {BaseAPI}
 */
class OplAddressApi extends BaseAPI {
    /**
     *
     * @summary endpoint to get cities
     * @param {OplAddressCityQuery} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OplAddressApi
     */
    getOplAddressCities(body, options) {
        return (0, exports.OplAddressApiFp)(this.configuration).getOplAddressCities(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to get streets
     * @param {OplAddressStreetQuery} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OplAddressApi
     */
    getOplAddressStreets(body, options) {
        return (0, exports.OplAddressApiFp)(this.configuration).getOplAddressStreets(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to get zipcodes
     * @param {OplAddressZipCodeQuery} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OplAddressApi
     */
    getOplAddressZipCodes(body, options) {
        return (0, exports.OplAddressApiFp)(this.configuration).getOplAddressZipCodes(body, options)(this.fetch, this.basePath);
    }
}
exports.OplAddressApi = OplAddressApi;
/**
 * OrgsApi - fetch parameter creator
 * @export
 */
const OrgsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Assign billing plan to organization
         * @param {OrgBillingPlan} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBillingPlan(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling assignBillingPlan.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling assignBillingPlan.');
            }
            const localVarPath = `/orgs/{id}/billing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OrgBillingPlan" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates new call
         * @param {string} X_Device_Id Device ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callOrg(X_Device_Id, id, options = {}) {
            // verify required parameter 'X_Device_Id' is not null or undefined
            if (X_Device_Id === null || X_Device_Id === undefined) {
                throw new RequiredError('X_Device_Id', 'Required parameter X_Device_Id was null or undefined when calling callOrg.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling callOrg.');
            }
            const localVarPath = `/orgs/{id}/call`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (X_Device_Id !== undefined && X_Device_Id !== null) {
                localVarHeaderParameter['X-Device-Id'] = String(X_Device_Id);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create free org and admin account
         * @param {FreeOrgAdminForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeOrgAdmin(body, token, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createFreeOrgAdmin.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling createFreeOrgAdmin.');
            }
            const localVarPath = `/orgs/token/{token}/free`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("FreeOrgAdminForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create organization cover handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgCoverHandle(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling createOrgCoverHandle.');
            }
            const localVarPath = `/orgs/{id}/cover`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create organization default agent avatar handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgDefaultAgentAvatarHandle(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling createOrgDefaultAgentAvatarHandle.');
            }
            const localVarPath = `/orgs/{id}/defaultAgentAvatar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create organization logo handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgLogoHandle(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling createOrgLogoHandle.');
            }
            const localVarPath = `/orgs/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create org and admin account with trial
         * @param {StripeOrgAdminForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeOrgAdmin(body, token, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createStripeOrgAdmin.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling createStripeOrgAdmin.');
            }
            const localVarPath = `/orgs/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("StripeOrgAdminForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete organization cover graphic
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgCover(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteOrgCover.');
            }
            const localVarPath = `/orgs/{id}/cover`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete organization agent default avatar
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgDefaultAgentAvatar(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteOrgDefaultAgentAvatar.');
            }
            const localVarPath = `/orgs/{id}/defaultAgentAvatar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete organization logo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgLogo(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteOrgLogo.');
            }
            const localVarPath = `/orgs/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get org data associated with billings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBillingData(options = {}) {
            const localVarPath = `/orgs/billing/data`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve total number of free slots of agents with given skill, in given organization
         * @param {SkillForm} body
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeSlotsInfo(body, orgId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling getFreeSlotsInfo.');
            }
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getFreeSlotsInfo.');
            }
            const localVarPath = `/orgs/{orgId}/freeSlots`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SkillForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve data of all orgs
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimits(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getLimits.');
            }
            const localVarPath = `/orgs/{orgId}/limits`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve org data.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getOrg.');
            }
            const localVarPath = `/orgs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get org information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgInfo(options = {}) {
            const localVarPath = `/orgs/info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve possible unavailability reasons for org.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgReasons(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getOrgReasons.');
            }
            const localVarPath = `/orgs/{id}/reasons`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve skills in org.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgSkills(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getOrgSkills.');
            }
            const localVarPath = `/orgs/{id}/skills`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Check if token is valid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgTokenValidity(token, options = {}) {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling getOrgTokenValidity.');
            }
            const localVarPath = `/orgs/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve org config.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationConfig(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getOrganizationConfig.');
            }
            const localVarPath = `/orgs/{id}/config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send email invitation to Closer
         * @param {OrgInvitationForm} body
         * @param {string} plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrg(body, plan, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling inviteOrg.');
            }
            // verify required parameter 'plan' is not null or undefined
            if (plan === null || plan === undefined) {
                throw new RequiredError('plan', 'Required parameter plan was null or undefined when calling inviteOrg.');
            }
            const localVarPath = `/orgs/invite`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (plan !== undefined) {
                localVarQueryParameter['plan'] = plan;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OrgInvitationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set organization config (admin only).
         * @param {OrgConfig} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putConfig(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling putConfig.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling putConfig.');
            }
            const localVarPath = `/orgs/{id}/config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OrgConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Upgrade org to a paid plan
         * @param {UpgradeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeOrg(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling upgradeOrg.');
            }
            const localVarPath = `/orgs/upgrade`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpgradeForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OrgsApiFetchParamCreator = OrgsApiFetchParamCreator;
/**
 * OrgsApi - functional programming interface
 * @export
 */
const OrgsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Assign billing plan to organization
         * @param {OrgBillingPlan} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBillingPlan(body, id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).assignBillingPlan(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Creates new call
         * @param {string} X_Device_Id Device ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callOrg(X_Device_Id, id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).callOrg(X_Device_Id, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create free org and admin account
         * @param {FreeOrgAdminForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeOrgAdmin(body, token, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).createFreeOrgAdmin(body, token, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create organization cover handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgCoverHandle(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).createOrgCoverHandle(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create organization default agent avatar handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgDefaultAgentAvatarHandle(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).createOrgDefaultAgentAvatarHandle(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create organization logo handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgLogoHandle(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).createOrgLogoHandle(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create org and admin account with trial
         * @param {StripeOrgAdminForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeOrgAdmin(body, token, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).createStripeOrgAdmin(body, token, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete organization cover graphic
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgCover(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).deleteOrgCover(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete organization agent default avatar
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgDefaultAgentAvatar(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).deleteOrgDefaultAgentAvatar(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete organization logo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgLogo(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).deleteOrgLogo(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get org data associated with billings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBillingData(options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getCompanyBillingData(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve total number of free slots of agents with given skill, in given organization
         * @param {SkillForm} body
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeSlotsInfo(body, orgId, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getFreeSlotsInfo(body, orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve data of all orgs
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimits(orgId, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getLimits(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve org data.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getOrg(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get org information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgInfo(options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getOrgInfo(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve possible unavailability reasons for org.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgReasons(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getOrgReasons(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve skills in org.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgSkills(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getOrgSkills(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Check if token is valid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgTokenValidity(token, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getOrgTokenValidity(token, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve org config.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationConfig(id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).getOrganizationConfig(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send email invitation to Closer
         * @param {OrgInvitationForm} body
         * @param {string} plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrg(body, plan, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).inviteOrg(body, plan, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set organization config (admin only).
         * @param {OrgConfig} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putConfig(body, id, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).putConfig(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Upgrade org to a paid plan
         * @param {UpgradeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeOrg(body, options) {
            const localVarFetchArgs = (0, exports.OrgsApiFetchParamCreator)(configuration).upgradeOrg(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OrgsApiFp = OrgsApiFp;
/**
 * OrgsApi - factory interface
 * @export
 */
const OrgsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Assign billing plan to organization
         * @param {OrgBillingPlan} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBillingPlan(body, id, options) {
            return (0, exports.OrgsApiFp)(configuration).assignBillingPlan(body, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Creates new call
         * @param {string} X_Device_Id Device ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callOrg(X_Device_Id, id, options) {
            return (0, exports.OrgsApiFp)(configuration).callOrg(X_Device_Id, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create free org and admin account
         * @param {FreeOrgAdminForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeOrgAdmin(body, token, options) {
            return (0, exports.OrgsApiFp)(configuration).createFreeOrgAdmin(body, token, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create organization cover handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgCoverHandle(id, options) {
            return (0, exports.OrgsApiFp)(configuration).createOrgCoverHandle(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create organization default agent avatar handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgDefaultAgentAvatarHandle(id, options) {
            return (0, exports.OrgsApiFp)(configuration).createOrgDefaultAgentAvatarHandle(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create organization logo handle
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgLogoHandle(id, options) {
            return (0, exports.OrgsApiFp)(configuration).createOrgLogoHandle(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create org and admin account with trial
         * @param {StripeOrgAdminForm} body
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeOrgAdmin(body, token, options) {
            return (0, exports.OrgsApiFp)(configuration).createStripeOrgAdmin(body, token, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete organization cover graphic
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgCover(id, options) {
            return (0, exports.OrgsApiFp)(configuration).deleteOrgCover(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete organization agent default avatar
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgDefaultAgentAvatar(id, options) {
            return (0, exports.OrgsApiFp)(configuration).deleteOrgDefaultAgentAvatar(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Delete organization logo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgLogo(id, options) {
            return (0, exports.OrgsApiFp)(configuration).deleteOrgLogo(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get org data associated with billings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBillingData(options) {
            return (0, exports.OrgsApiFp)(configuration).getCompanyBillingData(options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve total number of free slots of agents with given skill, in given organization
         * @param {SkillForm} body
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeSlotsInfo(body, orgId, options) {
            return (0, exports.OrgsApiFp)(configuration).getFreeSlotsInfo(body, orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve data of all orgs
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimits(orgId, options) {
            return (0, exports.OrgsApiFp)(configuration).getLimits(orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve org data.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg(id, options) {
            return (0, exports.OrgsApiFp)(configuration).getOrg(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get org information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgInfo(options) {
            return (0, exports.OrgsApiFp)(configuration).getOrgInfo(options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve possible unavailability reasons for org.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgReasons(id, options) {
            return (0, exports.OrgsApiFp)(configuration).getOrgReasons(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve skills in org.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgSkills(id, options) {
            return (0, exports.OrgsApiFp)(configuration).getOrgSkills(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Check if token is valid
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgTokenValidity(token, options) {
            return (0, exports.OrgsApiFp)(configuration).getOrgTokenValidity(token, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve org config.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationConfig(id, options) {
            return (0, exports.OrgsApiFp)(configuration).getOrganizationConfig(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send email invitation to Closer
         * @param {OrgInvitationForm} body
         * @param {string} plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteOrg(body, plan, options) {
            return (0, exports.OrgsApiFp)(configuration).inviteOrg(body, plan, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set organization config (admin only).
         * @param {OrgConfig} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putConfig(body, id, options) {
            return (0, exports.OrgsApiFp)(configuration).putConfig(body, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Upgrade org to a paid plan
         * @param {UpgradeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeOrg(body, options) {
            return (0, exports.OrgsApiFp)(configuration).upgradeOrg(body, options)(fetch, basePath);
        },
    };
};
exports.OrgsApiFactory = OrgsApiFactory;
/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
class OrgsApi extends BaseAPI {
    /**
     *
     * @summary Assign billing plan to organization
     * @param {OrgBillingPlan} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    assignBillingPlan(body, id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).assignBillingPlan(body, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Creates new call
     * @param {string} X_Device_Id Device ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    callOrg(X_Device_Id, id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).callOrg(X_Device_Id, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create free org and admin account
     * @param {FreeOrgAdminForm} body
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    createFreeOrgAdmin(body, token, options) {
        return (0, exports.OrgsApiFp)(this.configuration).createFreeOrgAdmin(body, token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create organization cover handle
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    createOrgCoverHandle(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).createOrgCoverHandle(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create organization default agent avatar handle
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    createOrgDefaultAgentAvatarHandle(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).createOrgDefaultAgentAvatarHandle(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create organization logo handle
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    createOrgLogoHandle(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).createOrgLogoHandle(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create org and admin account with trial
     * @param {StripeOrgAdminForm} body
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    createStripeOrgAdmin(body, token, options) {
        return (0, exports.OrgsApiFp)(this.configuration).createStripeOrgAdmin(body, token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete organization cover graphic
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    deleteOrgCover(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).deleteOrgCover(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete organization agent default avatar
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    deleteOrgDefaultAgentAvatar(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).deleteOrgDefaultAgentAvatar(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Delete organization logo
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    deleteOrgLogo(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).deleteOrgLogo(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get org data associated with billings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getCompanyBillingData(options) {
        return (0, exports.OrgsApiFp)(this.configuration).getCompanyBillingData(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve total number of free slots of agents with given skill, in given organization
     * @param {SkillForm} body
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getFreeSlotsInfo(body, orgId, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getFreeSlotsInfo(body, orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve data of all orgs
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getLimits(orgId, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getLimits(orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve org data.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getOrg(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getOrg(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get org information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getOrgInfo(options) {
        return (0, exports.OrgsApiFp)(this.configuration).getOrgInfo(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve possible unavailability reasons for org.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getOrgReasons(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getOrgReasons(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve skills in org.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getOrgSkills(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getOrgSkills(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Check if token is valid
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getOrgTokenValidity(token, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getOrgTokenValidity(token, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve org config.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    getOrganizationConfig(id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).getOrganizationConfig(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send email invitation to Closer
     * @param {OrgInvitationForm} body
     * @param {string} plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    inviteOrg(body, plan, options) {
        return (0, exports.OrgsApiFp)(this.configuration).inviteOrg(body, plan, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set organization config (admin only).
     * @param {OrgConfig} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    putConfig(body, id, options) {
        return (0, exports.OrgsApiFp)(this.configuration).putConfig(body, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Upgrade org to a paid plan
     * @param {UpgradeForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    upgradeOrg(body, options) {
        return (0, exports.OrgsApiFp)(this.configuration).upgradeOrg(body, options)(this.fetch, this.basePath);
    }
}
exports.OrgsApi = OrgsApi;
/**
 * ProactiveMsgApi - fetch parameter creator
 * @export
 */
const ProactiveMsgApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary secured endpoint for org admin to create proactive message record
         * @param {CreateProactiveMsgForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProactiveMessage(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createProactiveMessage.');
            }
            const localVarPath = `/proactive-msg`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateProactiveMsgForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary secured endpoint for org admin to delete proactive message record
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProactiveMessage(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteProactiveMessage.');
            }
            const localVarPath = `/proactive-msg/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary secured endpoint to retrieve data about proactive messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProactiveMessages(options = {}) {
            const localVarPath = `/proactive-msg`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary public endpoint for other components to retrieve data about proactive messages
         * @param {string} orgId organization&#x27;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProactiveMessagesUnauthorized(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getProactiveMessagesUnauthorized.');
            }
            const localVarPath = `/proactive-msg/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary secured endpoint for org admin to update proactive message record
         * @param {UpdateProactiveMsgForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProactiveMessage(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateProactiveMessage.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateProactiveMessage.');
            }
            const localVarPath = `/proactive-msg/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateProactiveMsgForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ProactiveMsgApiFetchParamCreator = ProactiveMsgApiFetchParamCreator;
/**
 * ProactiveMsgApi - functional programming interface
 * @export
 */
const ProactiveMsgApiFp = function (configuration) {
    return {
        /**
         *
         * @summary secured endpoint for org admin to create proactive message record
         * @param {CreateProactiveMsgForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProactiveMessage(body, options) {
            const localVarFetchArgs = (0, exports.ProactiveMsgApiFetchParamCreator)(configuration).createProactiveMessage(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary secured endpoint for org admin to delete proactive message record
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProactiveMessage(id, options) {
            const localVarFetchArgs = (0, exports.ProactiveMsgApiFetchParamCreator)(configuration).deleteProactiveMessage(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary secured endpoint to retrieve data about proactive messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProactiveMessages(options) {
            const localVarFetchArgs = (0, exports.ProactiveMsgApiFetchParamCreator)(configuration).getProactiveMessages(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary public endpoint for other components to retrieve data about proactive messages
         * @param {string} orgId organization&#x27;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProactiveMessagesUnauthorized(orgId, options) {
            const localVarFetchArgs = (0, exports.ProactiveMsgApiFetchParamCreator)(configuration).getProactiveMessagesUnauthorized(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary secured endpoint for org admin to update proactive message record
         * @param {UpdateProactiveMsgForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProactiveMessage(body, id, options) {
            const localVarFetchArgs = (0, exports.ProactiveMsgApiFetchParamCreator)(configuration).updateProactiveMessage(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ProactiveMsgApiFp = ProactiveMsgApiFp;
/**
 * ProactiveMsgApi - factory interface
 * @export
 */
const ProactiveMsgApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary secured endpoint for org admin to create proactive message record
         * @param {CreateProactiveMsgForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProactiveMessage(body, options) {
            return (0, exports.ProactiveMsgApiFp)(configuration).createProactiveMessage(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary secured endpoint for org admin to delete proactive message record
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProactiveMessage(id, options) {
            return (0, exports.ProactiveMsgApiFp)(configuration).deleteProactiveMessage(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary secured endpoint to retrieve data about proactive messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProactiveMessages(options) {
            return (0, exports.ProactiveMsgApiFp)(configuration).getProactiveMessages(options)(fetch, basePath);
        },
        /**
         *
         * @summary public endpoint for other components to retrieve data about proactive messages
         * @param {string} orgId organization&#x27;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProactiveMessagesUnauthorized(orgId, options) {
            return (0, exports.ProactiveMsgApiFp)(configuration).getProactiveMessagesUnauthorized(orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary secured endpoint for org admin to update proactive message record
         * @param {UpdateProactiveMsgForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProactiveMessage(body, id, options) {
            return (0, exports.ProactiveMsgApiFp)(configuration).updateProactiveMessage(body, id, options)(fetch, basePath);
        },
    };
};
exports.ProactiveMsgApiFactory = ProactiveMsgApiFactory;
/**
 * ProactiveMsgApi - object-oriented interface
 * @export
 * @class ProactiveMsgApi
 * @extends {BaseAPI}
 */
class ProactiveMsgApi extends BaseAPI {
    /**
     *
     * @summary secured endpoint for org admin to create proactive message record
     * @param {CreateProactiveMsgForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProactiveMsgApi
     */
    createProactiveMessage(body, options) {
        return (0, exports.ProactiveMsgApiFp)(this.configuration).createProactiveMessage(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary secured endpoint for org admin to delete proactive message record
     * @param {string} id primary key of record which should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProactiveMsgApi
     */
    deleteProactiveMessage(id, options) {
        return (0, exports.ProactiveMsgApiFp)(this.configuration).deleteProactiveMessage(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary secured endpoint to retrieve data about proactive messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProactiveMsgApi
     */
    getProactiveMessages(options) {
        return (0, exports.ProactiveMsgApiFp)(this.configuration).getProactiveMessages(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary public endpoint for other components to retrieve data about proactive messages
     * @param {string} orgId organization&#x27;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProactiveMsgApi
     */
    getProactiveMessagesUnauthorized(orgId, options) {
        return (0, exports.ProactiveMsgApiFp)(this.configuration).getProactiveMessagesUnauthorized(orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary secured endpoint for org admin to update proactive message record
     * @param {UpdateProactiveMsgForm} body
     * @param {string} id primary key of record which should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProactiveMsgApi
     */
    updateProactiveMessage(body, id, options) {
        return (0, exports.ProactiveMsgApiFp)(this.configuration).updateProactiveMessage(body, id, options)(this.fetch, this.basePath);
    }
}
exports.ProactiveMsgApi = ProactiveMsgApi;
/**
 * ProfanitiesApi - fetch parameter creator
 * @export
 */
const ProfanitiesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary create profanities blacklist
         * @param {ProfanityForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfanities(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createProfanities.');
            }
            const localVarPath = `/profanities`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ProfanityForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get org's profanities list
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfanities(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getProfanities.');
            }
            const localVarPath = `/profanities/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update profanities blacklist
         * @param {ProfanityForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfanities(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateProfanities.');
            }
            const localVarPath = `/profanities`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ProfanityForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ProfanitiesApiFetchParamCreator = ProfanitiesApiFetchParamCreator;
/**
 * ProfanitiesApi - functional programming interface
 * @export
 */
const ProfanitiesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary create profanities blacklist
         * @param {ProfanityForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfanities(body, options) {
            const localVarFetchArgs = (0, exports.ProfanitiesApiFetchParamCreator)(configuration).createProfanities(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get org's profanities list
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfanities(orgId, options) {
            const localVarFetchArgs = (0, exports.ProfanitiesApiFetchParamCreator)(configuration).getProfanities(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update profanities blacklist
         * @param {ProfanityForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfanities(body, options) {
            const localVarFetchArgs = (0, exports.ProfanitiesApiFetchParamCreator)(configuration).updateProfanities(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ProfanitiesApiFp = ProfanitiesApiFp;
/**
 * ProfanitiesApi - factory interface
 * @export
 */
const ProfanitiesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary create profanities blacklist
         * @param {ProfanityForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfanities(body, options) {
            return (0, exports.ProfanitiesApiFp)(configuration).createProfanities(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary get org's profanities list
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfanities(orgId, options) {
            return (0, exports.ProfanitiesApiFp)(configuration).getProfanities(orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary update profanities blacklist
         * @param {ProfanityForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfanities(body, options) {
            return (0, exports.ProfanitiesApiFp)(configuration).updateProfanities(body, options)(fetch, basePath);
        },
    };
};
exports.ProfanitiesApiFactory = ProfanitiesApiFactory;
/**
 * ProfanitiesApi - object-oriented interface
 * @export
 * @class ProfanitiesApi
 * @extends {BaseAPI}
 */
class ProfanitiesApi extends BaseAPI {
    /**
     *
     * @summary create profanities blacklist
     * @param {ProfanityForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfanitiesApi
     */
    createProfanities(body, options) {
        return (0, exports.ProfanitiesApiFp)(this.configuration).createProfanities(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get org's profanities list
     * @param {string} orgId orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfanitiesApi
     */
    getProfanities(orgId, options) {
        return (0, exports.ProfanitiesApiFp)(this.configuration).getProfanities(orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update profanities blacklist
     * @param {ProfanityForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfanitiesApi
     */
    updateProfanities(body, options) {
        return (0, exports.ProfanitiesApiFp)(this.configuration).updateProfanities(body, options)(this.fetch, this.basePath);
    }
}
exports.ProfanitiesApi = ProfanitiesApi;
/**
 * PushApi - fetch parameter creator
 * @export
 */
const PushApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Register user in push notification service
         * @param {RegisterInPushService} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPush(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling registerPush.');
            }
            const localVarPath = `/push/register`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RegisterInPushService" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unregister device in push notification service
         * @param {string} pushId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPush(pushId, options = {}) {
            // verify required parameter 'pushId' is not null or undefined
            if (pushId === null || pushId === undefined) {
                throw new RequiredError('pushId', 'Required parameter pushId was null or undefined when calling unregisterPush.');
            }
            const localVarPath = `/push/unregister/{pushId}`
                .replace(`{${"pushId"}}`, encodeURIComponent(String(pushId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PushApiFetchParamCreator = PushApiFetchParamCreator;
/**
 * PushApi - functional programming interface
 * @export
 */
const PushApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Register user in push notification service
         * @param {RegisterInPushService} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPush(body, options) {
            const localVarFetchArgs = (0, exports.PushApiFetchParamCreator)(configuration).registerPush(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Unregister device in push notification service
         * @param {string} pushId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPush(pushId, options) {
            const localVarFetchArgs = (0, exports.PushApiFetchParamCreator)(configuration).unregisterPush(pushId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.PushApiFp = PushApiFp;
/**
 * PushApi - factory interface
 * @export
 */
const PushApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Register user in push notification service
         * @param {RegisterInPushService} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPush(body, options) {
            return (0, exports.PushApiFp)(configuration).registerPush(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Unregister device in push notification service
         * @param {string} pushId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPush(pushId, options) {
            return (0, exports.PushApiFp)(configuration).unregisterPush(pushId, options)(fetch, basePath);
        },
    };
};
exports.PushApiFactory = PushApiFactory;
/**
 * PushApi - object-oriented interface
 * @export
 * @class PushApi
 * @extends {BaseAPI}
 */
class PushApi extends BaseAPI {
    /**
     *
     * @summary Register user in push notification service
     * @param {RegisterInPushService} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushApi
     */
    registerPush(body, options) {
        return (0, exports.PushApiFp)(this.configuration).registerPush(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Unregister device in push notification service
     * @param {string} pushId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushApi
     */
    unregisterPush(pushId, options) {
        return (0, exports.PushApiFp)(this.configuration).unregisterPush(pushId, options)(this.fetch, this.basePath);
    }
}
exports.PushApi = PushApi;
/**
 * RolesApi - fetch parameter creator
 * @export
 */
const RolesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary add permissions to role
         * @param {PermissionForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPermissionsToRole(body, roleId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling addPermissionsToRole.');
            }
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId', 'Required parameter roleId was null or undefined when calling addPermissionsToRole.');
            }
            const localVarPath = `/roles/{roleId}/permissions`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PermissionForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary create role
         * @param {CreateRoleForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createRole.');
            }
            const localVarPath = `/roles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateRoleForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete permissions from role
         * @param {PermissionForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsFromRole(body, roleId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling deletePermissionsFromRole.');
            }
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId', 'Required parameter roleId was null or undefined when calling deletePermissionsFromRole.');
            }
            const localVarPath = `/roles/{roleId}/permissions`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PermissionForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete role
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(roleId, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId', 'Required parameter roleId was null or undefined when calling deleteRole.');
            }
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get role
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(roleId, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId', 'Required parameter roleId was null or undefined when calling getRole.');
            }
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get roles for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForOrg(options = {}) {
            const localVarPath = `/roles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update role
         * @param {UpdateRoleForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(body, roleId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateRole.');
            }
            // verify required parameter 'roleId' is not null or undefined
            if (roleId === null || roleId === undefined) {
                throw new RequiredError('roleId', 'Required parameter roleId was null or undefined when calling updateRole.');
            }
            const localVarPath = `/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateRoleForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.RolesApiFetchParamCreator = RolesApiFetchParamCreator;
/**
 * RolesApi - functional programming interface
 * @export
 */
const RolesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary add permissions to role
         * @param {PermissionForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPermissionsToRole(body, roleId, options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).addPermissionsToRole(body, roleId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary create role
         * @param {CreateRoleForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(body, options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).createRole(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete permissions from role
         * @param {PermissionForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsFromRole(body, roleId, options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).deletePermissionsFromRole(body, roleId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete role
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(roleId, options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).deleteRole(roleId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get role
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(roleId, options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).getRole(roleId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get roles for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForOrg(options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).getRolesForOrg(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update role
         * @param {UpdateRoleForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(body, roleId, options) {
            const localVarFetchArgs = (0, exports.RolesApiFetchParamCreator)(configuration).updateRole(body, roleId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.RolesApiFp = RolesApiFp;
/**
 * RolesApi - factory interface
 * @export
 */
const RolesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary add permissions to role
         * @param {PermissionForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPermissionsToRole(body, roleId, options) {
            return (0, exports.RolesApiFp)(configuration).addPermissionsToRole(body, roleId, options)(fetch, basePath);
        },
        /**
         *
         * @summary create role
         * @param {CreateRoleForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(body, options) {
            return (0, exports.RolesApiFp)(configuration).createRole(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete permissions from role
         * @param {PermissionForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsFromRole(body, roleId, options) {
            return (0, exports.RolesApiFp)(configuration).deletePermissionsFromRole(body, roleId, options)(fetch, basePath);
        },
        /**
         *
         * @summary delete role
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(roleId, options) {
            return (0, exports.RolesApiFp)(configuration).deleteRole(roleId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get role
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(roleId, options) {
            return (0, exports.RolesApiFp)(configuration).getRole(roleId, options)(fetch, basePath);
        },
        /**
         *
         * @summary get roles for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesForOrg(options) {
            return (0, exports.RolesApiFp)(configuration).getRolesForOrg(options)(fetch, basePath);
        },
        /**
         *
         * @summary update role
         * @param {UpdateRoleForm} body
         * @param {string} roleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(body, roleId, options) {
            return (0, exports.RolesApiFp)(configuration).updateRole(body, roleId, options)(fetch, basePath);
        },
    };
};
exports.RolesApiFactory = RolesApiFactory;
/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
class RolesApi extends BaseAPI {
    /**
     *
     * @summary add permissions to role
     * @param {PermissionForm} body
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    addPermissionsToRole(body, roleId, options) {
        return (0, exports.RolesApiFp)(this.configuration).addPermissionsToRole(body, roleId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary create role
     * @param {CreateRoleForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    createRole(body, options) {
        return (0, exports.RolesApiFp)(this.configuration).createRole(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete permissions from role
     * @param {PermissionForm} body
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    deletePermissionsFromRole(body, roleId, options) {
        return (0, exports.RolesApiFp)(this.configuration).deletePermissionsFromRole(body, roleId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete role
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    deleteRole(roleId, options) {
        return (0, exports.RolesApiFp)(this.configuration).deleteRole(roleId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get role
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    getRole(roleId, options) {
        return (0, exports.RolesApiFp)(this.configuration).getRole(roleId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get roles for org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    getRolesForOrg(options) {
        return (0, exports.RolesApiFp)(this.configuration).getRolesForOrg(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update role
     * @param {UpdateRoleForm} body
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    updateRole(body, roleId, options) {
        return (0, exports.RolesApiFp)(this.configuration).updateRole(body, roleId, options)(this.fetch, this.basePath);
    }
}
exports.RolesApi = RolesApi;
/**
 * RoomsApi - fetch parameter creator
 * @export
 */
const RoomsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add follower to the room
         * @param {Follower} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFollower(body, roomId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling addFollower.');
            }
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling addFollower.');
            }
            const localVarPath = `/rooms/{roomId}/addFollower`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Follower" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Assign conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignConversation(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling assignConversation.');
            }
            const localVarPath = `/rooms/{roomId}/assign`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Auto assign conversation
         * @param {AutoAssign} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoAssignConversation(body, roomId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling autoAssignConversation.');
            }
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling autoAssignConversation.');
            }
            const localVarPath = `/rooms/{roomId}/autoAssign`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutoAssign" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send external message to the given room
         * @param {ExternalMessageForm} body
         * @param {string} roomId Id of room that message should be sent to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalMessage(body, roomId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createExternalMessage.');
            }
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling createExternalMessage.');
            }
            const localVarPath = `/rooms/{roomId}/external-messages`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ExternalMessageForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Follow room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        follow(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling follow.');
            }
            const localVarPath = `/rooms/{roomId}/follow`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get inbox info for a conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling getConversation.');
            }
            const localVarPath = `/rooms/{roomId}/inbox`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get ids of agents following the room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowers(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling getFollowers.');
            }
            const localVarPath = `/rooms/{roomId}/followers`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get guest profile for a conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfileByRoom(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling getGuestProfileByRoom.');
            }
            const localVarPath = `/rooms/{roomId}/profile`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search for a guest profiles by lead query.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfilesByQuery(query, options = {}) {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query', 'Required parameter query was null or undefined when calling getGuestProfilesByQuery.');
            }
            const localVarPath = `/rooms/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get ids of agents not following the room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotFollowers(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling getNotFollowers.');
            }
            const localVarPath = `/rooms/{roomId}/notFollowers`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set the assignee for room
         * @param {SetAssignee} body
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAssignee(body, roomId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAssignee.');
            }
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling setAssignee.');
            }
            const localVarPath = `/rooms/{roomId}/assignee`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SetAssignee" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set conversation status
         * @param {ConversationStatusForm} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConversationStatus(body, roomId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setConversationStatus.');
            }
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling setConversationStatus.');
            }
            const localVarPath = `/rooms/{roomId}/status`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ConversationStatusForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Snooze conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snooze(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling snooze.');
            }
            const localVarPath = `/rooms/{roomId}/snooze`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unfollow room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollow(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling unfollow.');
            }
            const localVarPath = `/rooms/{roomId}/unfollow`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unsnooze room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsnooze(roomId, options = {}) {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId', 'Required parameter roomId was null or undefined when calling unsnooze.');
            }
            const localVarPath = `/rooms/{roomId}/unsnooze`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.RoomsApiFetchParamCreator = RoomsApiFetchParamCreator;
/**
 * RoomsApi - functional programming interface
 * @export
 */
const RoomsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Add follower to the room
         * @param {Follower} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFollower(body, roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).addFollower(body, roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Assign conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignConversation(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).assignConversation(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Auto assign conversation
         * @param {AutoAssign} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoAssignConversation(body, roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).autoAssignConversation(body, roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send external message to the given room
         * @param {ExternalMessageForm} body
         * @param {string} roomId Id of room that message should be sent to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalMessage(body, roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).createExternalMessage(body, roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Follow room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        follow(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).follow(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get inbox info for a conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).getConversation(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get ids of agents following the room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowers(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).getFollowers(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get guest profile for a conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfileByRoom(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).getGuestProfileByRoom(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Search for a guest profiles by lead query.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfilesByQuery(query, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).getGuestProfilesByQuery(query, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get ids of agents not following the room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotFollowers(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).getNotFollowers(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set the assignee for room
         * @param {SetAssignee} body
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAssignee(body, roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).setAssignee(body, roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set conversation status
         * @param {ConversationStatusForm} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConversationStatus(body, roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).setConversationStatus(body, roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Snooze conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snooze(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).snooze(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Unfollow room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollow(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).unfollow(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Unsnooze room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsnooze(roomId, options) {
            const localVarFetchArgs = (0, exports.RoomsApiFetchParamCreator)(configuration).unsnooze(roomId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.RoomsApiFp = RoomsApiFp;
/**
 * RoomsApi - factory interface
 * @export
 */
const RoomsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Add follower to the room
         * @param {Follower} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFollower(body, roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).addFollower(body, roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Assign conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignConversation(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).assignConversation(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Auto assign conversation
         * @param {AutoAssign} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoAssignConversation(body, roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).autoAssignConversation(body, roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send external message to the given room
         * @param {ExternalMessageForm} body
         * @param {string} roomId Id of room that message should be sent to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalMessage(body, roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).createExternalMessage(body, roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Follow room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        follow(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).follow(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get inbox info for a conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversation(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).getConversation(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get ids of agents following the room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowers(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).getFollowers(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get guest profile for a conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfileByRoom(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).getGuestProfileByRoom(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Search for a guest profiles by lead query.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfilesByQuery(query, options) {
            return (0, exports.RoomsApiFp)(configuration).getGuestProfilesByQuery(query, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get ids of agents not following the room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotFollowers(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).getNotFollowers(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set the assignee for room
         * @param {SetAssignee} body
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAssignee(body, roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).setAssignee(body, roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set conversation status
         * @param {ConversationStatusForm} body
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setConversationStatus(body, roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).setConversationStatus(body, roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Snooze conversation
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snooze(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).snooze(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Unfollow room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollow(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).unfollow(roomId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Unsnooze room
         * @param {string} roomId The ID of the room of the conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsnooze(roomId, options) {
            return (0, exports.RoomsApiFp)(configuration).unsnooze(roomId, options)(fetch, basePath);
        },
    };
};
exports.RoomsApiFactory = RoomsApiFactory;
/**
 * RoomsApi - object-oriented interface
 * @export
 * @class RoomsApi
 * @extends {BaseAPI}
 */
class RoomsApi extends BaseAPI {
    /**
     *
     * @summary Add follower to the room
     * @param {Follower} body
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    addFollower(body, roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).addFollower(body, roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Assign conversation
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    assignConversation(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).assignConversation(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Auto assign conversation
     * @param {AutoAssign} body
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    autoAssignConversation(body, roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).autoAssignConversation(body, roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send external message to the given room
     * @param {ExternalMessageForm} body
     * @param {string} roomId Id of room that message should be sent to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    createExternalMessage(body, roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).createExternalMessage(body, roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Follow room
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    follow(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).follow(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get inbox info for a conversation
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    getConversation(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).getConversation(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get ids of agents following the room
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    getFollowers(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).getFollowers(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get guest profile for a conversation
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    getGuestProfileByRoom(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).getGuestProfileByRoom(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Search for a guest profiles by lead query.
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    getGuestProfilesByQuery(query, options) {
        return (0, exports.RoomsApiFp)(this.configuration).getGuestProfilesByQuery(query, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get ids of agents not following the room
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    getNotFollowers(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).getNotFollowers(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set the assignee for room
     * @param {SetAssignee} body
     * @param {string} roomId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    setAssignee(body, roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).setAssignee(body, roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set conversation status
     * @param {ConversationStatusForm} body
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    setConversationStatus(body, roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).setConversationStatus(body, roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Snooze conversation
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    snooze(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).snooze(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Unfollow room
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    unfollow(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).unfollow(roomId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Unsnooze room
     * @param {string} roomId The ID of the room of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    unsnooze(roomId, options) {
        return (0, exports.RoomsApiFp)(this.configuration).unsnooze(roomId, options)(this.fetch, this.basePath);
    }
}
exports.RoomsApi = RoomsApi;
/**
 * SessionApi - fetch parameter creator
 * @export
 */
const SessionApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Change password with token
         * @param {PasswordChangeWithTokenForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordWithToken(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling changePasswordWithToken.');
            }
            const localVarPath = `/session/password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PasswordChangeWithTokenForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Confirm email change
         * @param {EmailChangeConfirm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailChange(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling confirmEmailChange.');
            }
            const localVarPath = `/session/confirmEmailChange`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EmailChangeConfirm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve user and apiKey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(options = {}) {
            const localVarPath = `/session`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("ratel-spinner")
                    : configuration.apiKey;
                localVarQueryParameter["ratel-spinner"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Login user. Create session.
         * @param {LoginCredentialsOrTokenForm} body Valid parameters are either token or credentials (email and password). Unless provided in mentioned form, Bad Request will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling login.');
            }
            const localVarPath = `/session`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LoginCredentialsOrTokenForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Logout user. Delete session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options = {}) {
            const localVarPath = `/session`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send a magic login link
         * @param {MagicLinkForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magiclink(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling magiclink.');
            }
            const localVarPath = `/session/magiclink`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MagicLinkForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send a password reset link
         * @param {PasswordResetForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/session/passwordreset`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PasswordResetForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SessionApiFetchParamCreator = SessionApiFetchParamCreator;
/**
 * SessionApi - functional programming interface
 * @export
 */
const SessionApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Change password with token
         * @param {PasswordChangeWithTokenForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordWithToken(body, options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).changePasswordWithToken(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Confirm email change
         * @param {EmailChangeConfirm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailChange(body, options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).confirmEmailChange(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieve user and apiKey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).getSession(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Login user. Create session.
         * @param {LoginCredentialsOrTokenForm} body Valid parameters are either token or credentials (email and password). Unless provided in mentioned form, Bad Request will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(body, options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).login(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Logout user. Delete session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).logout(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send a magic login link
         * @param {MagicLinkForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magiclink(body, options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).magiclink(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send a password reset link
         * @param {PasswordResetForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body, options) {
            const localVarFetchArgs = (0, exports.SessionApiFetchParamCreator)(configuration).resetPassword(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.SessionApiFp = SessionApiFp;
/**
 * SessionApi - factory interface
 * @export
 */
const SessionApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Change password with token
         * @param {PasswordChangeWithTokenForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordWithToken(body, options) {
            return (0, exports.SessionApiFp)(configuration).changePasswordWithToken(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Confirm email change
         * @param {EmailChangeConfirm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailChange(body, options) {
            return (0, exports.SessionApiFp)(configuration).confirmEmailChange(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieve user and apiKey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(options) {
            return (0, exports.SessionApiFp)(configuration).getSession(options)(fetch, basePath);
        },
        /**
         *
         * @summary Login user. Create session.
         * @param {LoginCredentialsOrTokenForm} body Valid parameters are either token or credentials (email and password). Unless provided in mentioned form, Bad Request will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(body, options) {
            return (0, exports.SessionApiFp)(configuration).login(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Logout user. Delete session.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return (0, exports.SessionApiFp)(configuration).logout(options)(fetch, basePath);
        },
        /**
         *
         * @summary Send a magic login link
         * @param {MagicLinkForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magiclink(body, options) {
            return (0, exports.SessionApiFp)(configuration).magiclink(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send a password reset link
         * @param {PasswordResetForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body, options) {
            return (0, exports.SessionApiFp)(configuration).resetPassword(body, options)(fetch, basePath);
        },
    };
};
exports.SessionApiFactory = SessionApiFactory;
/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
class SessionApi extends BaseAPI {
    /**
     *
     * @summary Change password with token
     * @param {PasswordChangeWithTokenForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    changePasswordWithToken(body, options) {
        return (0, exports.SessionApiFp)(this.configuration).changePasswordWithToken(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Confirm email change
     * @param {EmailChangeConfirm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    confirmEmailChange(body, options) {
        return (0, exports.SessionApiFp)(this.configuration).confirmEmailChange(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieve user and apiKey.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    getSession(options) {
        return (0, exports.SessionApiFp)(this.configuration).getSession(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Login user. Create session.
     * @param {LoginCredentialsOrTokenForm} body Valid parameters are either token or credentials (email and password). Unless provided in mentioned form, Bad Request will be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    login(body, options) {
        return (0, exports.SessionApiFp)(this.configuration).login(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Logout user. Delete session.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    logout(options) {
        return (0, exports.SessionApiFp)(this.configuration).logout(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send a magic login link
     * @param {MagicLinkForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    magiclink(body, options) {
        return (0, exports.SessionApiFp)(this.configuration).magiclink(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send a password reset link
     * @param {PasswordResetForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    resetPassword(body, options) {
        return (0, exports.SessionApiFp)(this.configuration).resetPassword(body, options)(this.fetch, this.basePath);
    }
}
exports.SessionApi = SessionApi;
/**
 * StatusApi - fetch parameter creator
 * @export
 */
const StatusApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary spinner status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusGet(options = {}) {
            const localVarPath = `/status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StatusApiFetchParamCreator = StatusApiFetchParamCreator;
/**
 * StatusApi - functional programming interface
 * @export
 */
const StatusApiFp = function (configuration) {
    return {
        /**
         *
         * @summary spinner status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusGet(options) {
            const localVarFetchArgs = (0, exports.StatusApiFetchParamCreator)(configuration).statusGet(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StatusApiFp = StatusApiFp;
/**
 * StatusApi - factory interface
 * @export
 */
const StatusApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary spinner status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusGet(options) {
            return (0, exports.StatusApiFp)(configuration).statusGet(options)(fetch, basePath);
        },
    };
};
exports.StatusApiFactory = StatusApiFactory;
/**
 * StatusApi - object-oriented interface
 * @export
 * @class StatusApi
 * @extends {BaseAPI}
 */
class StatusApi extends BaseAPI {
    /**
     *
     * @summary spinner status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    statusGet(options) {
        return (0, exports.StatusApiFp)(this.configuration).statusGet(options)(this.fetch, this.basePath);
    }
}
exports.StatusApi = StatusApi;
/**
 * TagGroupTransfersApi - fetch parameter creator
 * @export
 */
const TagGroupTransfersApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create tag groups transfer rules
         * @param {TransferRuleDto} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagGroupTransfers(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTagGroupTransfers.');
            }
            const localVarPath = `/tag-groups-transfers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TransferRuleDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag group transfers
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagGroupTransfers(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTagGroupTransfers.');
            }
            const localVarPath = `/tag-groups-transfers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag groups transfer rules
         * @param {string} id primary key of record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfer(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTagGroupTransfer.');
            }
            const localVarPath = `/tag-groups-transfers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag groups transfer rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfers(options = {}) {
            const localVarPath = `/tag-groups-transfers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to patch tag groups transfer rules
         * @param {TransferRulePatchForm} body
         * @param {string} id primary key of record which should be patched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagGroupTransfers(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchTagGroupTransfers.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchTagGroupTransfers.');
            }
            const localVarPath = `/tag-groups-transfers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TransferRulePatchForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TagGroupTransfersApiFetchParamCreator = TagGroupTransfersApiFetchParamCreator;
/**
 * TagGroupTransfersApi - functional programming interface
 * @export
 */
const TagGroupTransfersApiFp = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create tag groups transfer rules
         * @param {TransferRuleDto} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagGroupTransfers(body, options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersApiFetchParamCreator)(configuration).createTagGroupTransfers(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag group transfers
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagGroupTransfers(id, options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersApiFetchParamCreator)(configuration).deleteTagGroupTransfers(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag groups transfer rules
         * @param {string} id primary key of record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfer(id, options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersApiFetchParamCreator)(configuration).getTagGroupTransfer(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag groups transfer rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfers(options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersApiFetchParamCreator)(configuration).getTagGroupTransfers(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to patch tag groups transfer rules
         * @param {TransferRulePatchForm} body
         * @param {string} id primary key of record which should be patched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagGroupTransfers(body, id, options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersApiFetchParamCreator)(configuration).patchTagGroupTransfers(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TagGroupTransfersApiFp = TagGroupTransfersApiFp;
/**
 * TagGroupTransfersApi - factory interface
 * @export
 */
const TagGroupTransfersApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary endpoint to create tag groups transfer rules
         * @param {TransferRuleDto} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagGroupTransfers(body, options) {
            return (0, exports.TagGroupTransfersApiFp)(configuration).createTagGroupTransfers(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to delete tag group transfers
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagGroupTransfers(id, options) {
            return (0, exports.TagGroupTransfersApiFp)(configuration).deleteTagGroupTransfers(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to retrieve tag groups transfer rules
         * @param {string} id primary key of record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfer(id, options) {
            return (0, exports.TagGroupTransfersApiFp)(configuration).getTagGroupTransfer(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to retrieve tag groups transfer rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfers(options) {
            return (0, exports.TagGroupTransfersApiFp)(configuration).getTagGroupTransfers(options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to patch tag groups transfer rules
         * @param {TransferRulePatchForm} body
         * @param {string} id primary key of record which should be patched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagGroupTransfers(body, id, options) {
            return (0, exports.TagGroupTransfersApiFp)(configuration).patchTagGroupTransfers(body, id, options)(fetch, basePath);
        },
    };
};
exports.TagGroupTransfersApiFactory = TagGroupTransfersApiFactory;
/**
 * TagGroupTransfersApi - object-oriented interface
 * @export
 * @class TagGroupTransfersApi
 * @extends {BaseAPI}
 */
class TagGroupTransfersApi extends BaseAPI {
    /**
     *
     * @summary endpoint to create tag groups transfer rules
     * @param {TransferRuleDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersApi
     */
    createTagGroupTransfers(body, options) {
        return (0, exports.TagGroupTransfersApiFp)(this.configuration).createTagGroupTransfers(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to delete tag group transfers
     * @param {string} id primary key of record which should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersApi
     */
    deleteTagGroupTransfers(id, options) {
        return (0, exports.TagGroupTransfersApiFp)(this.configuration).deleteTagGroupTransfers(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to retrieve tag groups transfer rules
     * @param {string} id primary key of record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersApi
     */
    getTagGroupTransfer(id, options) {
        return (0, exports.TagGroupTransfersApiFp)(this.configuration).getTagGroupTransfer(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to retrieve tag groups transfer rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersApi
     */
    getTagGroupTransfers(options) {
        return (0, exports.TagGroupTransfersApiFp)(this.configuration).getTagGroupTransfers(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to patch tag groups transfer rules
     * @param {TransferRulePatchForm} body
     * @param {string} id primary key of record which should be patched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersApi
     */
    patchTagGroupTransfers(body, id, options) {
        return (0, exports.TagGroupTransfersApiFp)(this.configuration).patchTagGroupTransfers(body, id, options)(this.fetch, this.basePath);
    }
}
exports.TagGroupTransfersApi = TagGroupTransfersApi;
/**
 * TagGroupTransfersParametersApi - fetch parameter creator
 * @export
 */
const TagGroupTransfersParametersApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to retrieve tag groups transfer parameteres
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfersParameters(options = {}) {
            const localVarPath = `/tag-groups-transfers-parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to patch tag groups transfer parameteres
         * @param {TransferParametersDto} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagGroupTransfersParameters(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchTagGroupTransfersParameters.');
            }
            const localVarPath = `/tag-groups-transfers-parameters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TransferParametersDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TagGroupTransfersParametersApiFetchParamCreator = TagGroupTransfersParametersApiFetchParamCreator;
/**
 * TagGroupTransfersParametersApi - functional programming interface
 * @export
 */
const TagGroupTransfersParametersApiFp = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to retrieve tag groups transfer parameteres
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfersParameters(options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersParametersApiFetchParamCreator)(configuration).getTagGroupTransfersParameters(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to patch tag groups transfer parameteres
         * @param {TransferParametersDto} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagGroupTransfersParameters(body, options) {
            const localVarFetchArgs = (0, exports.TagGroupTransfersParametersApiFetchParamCreator)(configuration).patchTagGroupTransfersParameters(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TagGroupTransfersParametersApiFp = TagGroupTransfersParametersApiFp;
/**
 * TagGroupTransfersParametersApi - factory interface
 * @export
 */
const TagGroupTransfersParametersApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary endpoint to retrieve tag groups transfer parameteres
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroupTransfersParameters(options) {
            return (0, exports.TagGroupTransfersParametersApiFp)(configuration).getTagGroupTransfersParameters(options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to patch tag groups transfer parameteres
         * @param {TransferParametersDto} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagGroupTransfersParameters(body, options) {
            return (0, exports.TagGroupTransfersParametersApiFp)(configuration).patchTagGroupTransfersParameters(body, options)(fetch, basePath);
        },
    };
};
exports.TagGroupTransfersParametersApiFactory = TagGroupTransfersParametersApiFactory;
/**
 * TagGroupTransfersParametersApi - object-oriented interface
 * @export
 * @class TagGroupTransfersParametersApi
 * @extends {BaseAPI}
 */
class TagGroupTransfersParametersApi extends BaseAPI {
    /**
     *
     * @summary endpoint to retrieve tag groups transfer parameteres
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersParametersApi
     */
    getTagGroupTransfersParameters(options) {
        return (0, exports.TagGroupTransfersParametersApiFp)(this.configuration).getTagGroupTransfersParameters(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to patch tag groups transfer parameteres
     * @param {TransferParametersDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupTransfersParametersApi
     */
    patchTagGroupTransfersParameters(body, options) {
        return (0, exports.TagGroupTransfersParametersApiFp)(this.configuration).patchTagGroupTransfersParameters(body, options)(this.fetch, this.basePath);
    }
}
exports.TagGroupTransfersParametersApi = TagGroupTransfersParametersApi;
/**
 * TagGroupsApi - fetch parameter creator
 * @export
 */
const TagGroupsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create tag group
         * @param {CreateTagGroupForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagGroup(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTagGroup.');
            }
            const localVarPath = `/tag-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateTagGroupForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag group
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagGroup(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTagGroup.');
            }
            const localVarPath = `/tag-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag group
         * @param {string} id primary key of record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroup(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTagGroup.');
            }
            const localVarPath = `/tag-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag groups
         * @param {boolean} [active]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroups(active, options = {}) {
            const localVarPath = `/tag-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to update tag group
         * @param {UpdateTagGroupForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagGroup(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTagGroup.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTagGroup.');
            }
            const localVarPath = `/tag-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateTagGroupForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to batch update tag groups
         * @param {Array<TagGroupDto>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagGroups(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTagGroups.');
            }
            const localVarPath = `/tag-groups`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Array&lt;TagGroupDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TagGroupsApiFetchParamCreator = TagGroupsApiFetchParamCreator;
/**
 * TagGroupsApi - functional programming interface
 * @export
 */
const TagGroupsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create tag group
         * @param {CreateTagGroupForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagGroup(body, options) {
            const localVarFetchArgs = (0, exports.TagGroupsApiFetchParamCreator)(configuration).createTagGroup(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag group
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagGroup(id, options) {
            const localVarFetchArgs = (0, exports.TagGroupsApiFetchParamCreator)(configuration).deleteTagGroup(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag group
         * @param {string} id primary key of record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroup(id, options) {
            const localVarFetchArgs = (0, exports.TagGroupsApiFetchParamCreator)(configuration).getTagGroup(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to retrieve tag groups
         * @param {boolean} [active]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroups(active, options) {
            const localVarFetchArgs = (0, exports.TagGroupsApiFetchParamCreator)(configuration).getTagGroups(active, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to update tag group
         * @param {UpdateTagGroupForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagGroup(body, id, options) {
            const localVarFetchArgs = (0, exports.TagGroupsApiFetchParamCreator)(configuration).updateTagGroup(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to batch update tag groups
         * @param {Array<TagGroupDto>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagGroups(body, options) {
            const localVarFetchArgs = (0, exports.TagGroupsApiFetchParamCreator)(configuration).updateTagGroups(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TagGroupsApiFp = TagGroupsApiFp;
/**
 * TagGroupsApi - factory interface
 * @export
 */
const TagGroupsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary endpoint to create tag group
         * @param {CreateTagGroupForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagGroup(body, options) {
            return (0, exports.TagGroupsApiFp)(configuration).createTagGroup(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to delete tag group
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagGroup(id, options) {
            return (0, exports.TagGroupsApiFp)(configuration).deleteTagGroup(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to retrieve tag group
         * @param {string} id primary key of record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroup(id, options) {
            return (0, exports.TagGroupsApiFp)(configuration).getTagGroup(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to retrieve tag groups
         * @param {boolean} [active]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagGroups(active, options) {
            return (0, exports.TagGroupsApiFp)(configuration).getTagGroups(active, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to update tag group
         * @param {UpdateTagGroupForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagGroup(body, id, options) {
            return (0, exports.TagGroupsApiFp)(configuration).updateTagGroup(body, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to batch update tag groups
         * @param {Array<TagGroupDto>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagGroups(body, options) {
            return (0, exports.TagGroupsApiFp)(configuration).updateTagGroups(body, options)(fetch, basePath);
        },
    };
};
exports.TagGroupsApiFactory = TagGroupsApiFactory;
/**
 * TagGroupsApi - object-oriented interface
 * @export
 * @class TagGroupsApi
 * @extends {BaseAPI}
 */
class TagGroupsApi extends BaseAPI {
    /**
     *
     * @summary endpoint to create tag group
     * @param {CreateTagGroupForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupsApi
     */
    createTagGroup(body, options) {
        return (0, exports.TagGroupsApiFp)(this.configuration).createTagGroup(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to delete tag group
     * @param {string} id primary key of record which should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupsApi
     */
    deleteTagGroup(id, options) {
        return (0, exports.TagGroupsApiFp)(this.configuration).deleteTagGroup(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to retrieve tag group
     * @param {string} id primary key of record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupsApi
     */
    getTagGroup(id, options) {
        return (0, exports.TagGroupsApiFp)(this.configuration).getTagGroup(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to retrieve tag groups
     * @param {boolean} [active]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupsApi
     */
    getTagGroups(active, options) {
        return (0, exports.TagGroupsApiFp)(this.configuration).getTagGroups(active, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to update tag group
     * @param {UpdateTagGroupForm} body
     * @param {string} id primary key of record which should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupsApi
     */
    updateTagGroup(body, id, options) {
        return (0, exports.TagGroupsApiFp)(this.configuration).updateTagGroup(body, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to batch update tag groups
     * @param {Array<TagGroupDto>} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagGroupsApi
     */
    updateTagGroups(body, options) {
        return (0, exports.TagGroupsApiFp)(this.configuration).updateTagGroups(body, options)(this.fetch, this.basePath);
    }
}
exports.TagGroupsApi = TagGroupsApi;
/**
 * TagMappingsApi - fetch parameter creator
 * @export
 */
const TagMappingsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary authorized endpoint to create tag mapping
         * @param {CreateTagMappingForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagMapping(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTagMapping.');
            }
            const localVarPath = `/tag-mappings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateTagMappingForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag mapping
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagMapping(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTagMapping.');
            }
            const localVarPath = `/tag-mappings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary secured endpoint to retrieve data about url-tag mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagMappings(options = {}) {
            const localVarPath = `/tag-mappings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to update tag mapping
         * @param {UpdateTagMappingForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagMapping(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTagMapping.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTagMapping.');
            }
            const localVarPath = `/tag-mappings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateTagMappingForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TagMappingsApiFetchParamCreator = TagMappingsApiFetchParamCreator;
/**
 * TagMappingsApi - functional programming interface
 * @export
 */
const TagMappingsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary authorized endpoint to create tag mapping
         * @param {CreateTagMappingForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagMapping(body, options) {
            const localVarFetchArgs = (0, exports.TagMappingsApiFetchParamCreator)(configuration).createTagMapping(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag mapping
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagMapping(id, options) {
            const localVarFetchArgs = (0, exports.TagMappingsApiFetchParamCreator)(configuration).deleteTagMapping(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary secured endpoint to retrieve data about url-tag mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagMappings(options) {
            const localVarFetchArgs = (0, exports.TagMappingsApiFetchParamCreator)(configuration).getTagMappings(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to update tag mapping
         * @param {UpdateTagMappingForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagMapping(body, id, options) {
            const localVarFetchArgs = (0, exports.TagMappingsApiFetchParamCreator)(configuration).updateTagMapping(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TagMappingsApiFp = TagMappingsApiFp;
/**
 * TagMappingsApi - factory interface
 * @export
 */
const TagMappingsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary authorized endpoint to create tag mapping
         * @param {CreateTagMappingForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTagMapping(body, options) {
            return (0, exports.TagMappingsApiFp)(configuration).createTagMapping(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to delete tag mapping
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagMapping(id, options) {
            return (0, exports.TagMappingsApiFp)(configuration).deleteTagMapping(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary secured endpoint to retrieve data about url-tag mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagMappings(options) {
            return (0, exports.TagMappingsApiFp)(configuration).getTagMappings(options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to update tag mapping
         * @param {UpdateTagMappingForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagMapping(body, id, options) {
            return (0, exports.TagMappingsApiFp)(configuration).updateTagMapping(body, id, options)(fetch, basePath);
        },
    };
};
exports.TagMappingsApiFactory = TagMappingsApiFactory;
/**
 * TagMappingsApi - object-oriented interface
 * @export
 * @class TagMappingsApi
 * @extends {BaseAPI}
 */
class TagMappingsApi extends BaseAPI {
    /**
     *
     * @summary authorized endpoint to create tag mapping
     * @param {CreateTagMappingForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagMappingsApi
     */
    createTagMapping(body, options) {
        return (0, exports.TagMappingsApiFp)(this.configuration).createTagMapping(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to delete tag mapping
     * @param {string} id primary key of record which should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagMappingsApi
     */
    deleteTagMapping(id, options) {
        return (0, exports.TagMappingsApiFp)(this.configuration).deleteTagMapping(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary secured endpoint to retrieve data about url-tag mappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagMappingsApi
     */
    getTagMappings(options) {
        return (0, exports.TagMappingsApiFp)(this.configuration).getTagMappings(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to update tag mapping
     * @param {UpdateTagMappingForm} body
     * @param {string} id primary key of record which should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagMappingsApi
     */
    updateTagMapping(body, id, options) {
        return (0, exports.TagMappingsApiFp)(this.configuration).updateTagMapping(body, id, options)(this.fetch, this.basePath);
    }
}
exports.TagMappingsApi = TagMappingsApi;
/**
 * TagsApi - fetch parameter creator
 * @export
 */
const TagsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary authorized endpoint to create tag
         * @param {CreateTagForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTag.');
            }
            const localVarPath = `/tags`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateTagForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTag.');
            }
            const localVarPath = `/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary secured endpoint to retrieve tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options = {}) {
            const localVarPath = `/tags`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to update tag
         * @param {UpdateTagForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTag.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTag.');
            }
            const localVarPath = `/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UpdateTagForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TagsApiFetchParamCreator = TagsApiFetchParamCreator;
/**
 * TagsApi - functional programming interface
 * @export
 */
const TagsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary authorized endpoint to create tag
         * @param {CreateTagForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(body, options) {
            const localVarFetchArgs = (0, exports.TagsApiFetchParamCreator)(configuration).createTag(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to delete tag
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(id, options) {
            const localVarFetchArgs = (0, exports.TagsApiFetchParamCreator)(configuration).deleteTag(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary secured endpoint to retrieve tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options) {
            const localVarFetchArgs = (0, exports.TagsApiFetchParamCreator)(configuration).getTags(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to update tag
         * @param {UpdateTagForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(body, id, options) {
            const localVarFetchArgs = (0, exports.TagsApiFetchParamCreator)(configuration).updateTag(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TagsApiFp = TagsApiFp;
/**
 * TagsApi - factory interface
 * @export
 */
const TagsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary authorized endpoint to create tag
         * @param {CreateTagForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(body, options) {
            return (0, exports.TagsApiFp)(configuration).createTag(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to delete tag
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(id, options) {
            return (0, exports.TagsApiFp)(configuration).deleteTag(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary secured endpoint to retrieve tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options) {
            return (0, exports.TagsApiFp)(configuration).getTags(options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to update tag
         * @param {UpdateTagForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(body, id, options) {
            return (0, exports.TagsApiFp)(configuration).updateTag(body, id, options)(fetch, basePath);
        },
    };
};
exports.TagsApiFactory = TagsApiFactory;
/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
class TagsApi extends BaseAPI {
    /**
     *
     * @summary authorized endpoint to create tag
     * @param {CreateTagForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    createTag(body, options) {
        return (0, exports.TagsApiFp)(this.configuration).createTag(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to delete tag
     * @param {string} id primary key of record which should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    deleteTag(id, options) {
        return (0, exports.TagsApiFp)(this.configuration).deleteTag(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary secured endpoint to retrieve tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    getTags(options) {
        return (0, exports.TagsApiFp)(this.configuration).getTags(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to update tag
     * @param {UpdateTagForm} body
     * @param {string} id primary key of record which should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    updateTag(body, id, options) {
        return (0, exports.TagsApiFp)(this.configuration).updateTag(body, id, options)(this.fetch, this.basePath);
    }
}
exports.TagsApi = TagsApi;
/**
 * TopicsApi - fetch parameter creator
 * @export
 */
const TopicsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create topic
         * @param {TopicForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTopic.');
            }
            const localVarPath = `/topics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TopicForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary authorized endpoint to delete topics
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTopic.');
            }
            const localVarPath = `/topics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to get topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics(options = {}) {
            const localVarPath = `/topics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary endpoint to update topic
         * @param {TopicForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTopic.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTopic.');
            }
            const localVarPath = `/topics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TopicForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TopicsApiFetchParamCreator = TopicsApiFetchParamCreator;
/**
 * TopicsApi - functional programming interface
 * @export
 */
const TopicsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary endpoint to create topic
         * @param {TopicForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(body, options) {
            const localVarFetchArgs = (0, exports.TopicsApiFetchParamCreator)(configuration).createTopic(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary authorized endpoint to delete topics
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(id, options) {
            const localVarFetchArgs = (0, exports.TopicsApiFetchParamCreator)(configuration).deleteTopic(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to get topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics(options) {
            const localVarFetchArgs = (0, exports.TopicsApiFetchParamCreator)(configuration).getTopics(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary endpoint to update topic
         * @param {TopicForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(body, id, options) {
            const localVarFetchArgs = (0, exports.TopicsApiFetchParamCreator)(configuration).updateTopic(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TopicsApiFp = TopicsApiFp;
/**
 * TopicsApi - factory interface
 * @export
 */
const TopicsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary endpoint to create topic
         * @param {TopicForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(body, options) {
            return (0, exports.TopicsApiFp)(configuration).createTopic(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary authorized endpoint to delete topics
         * @param {string} id primary key of record which should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(id, options) {
            return (0, exports.TopicsApiFp)(configuration).deleteTopic(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to get topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics(options) {
            return (0, exports.TopicsApiFp)(configuration).getTopics(options)(fetch, basePath);
        },
        /**
         *
         * @summary endpoint to update topic
         * @param {TopicForm} body
         * @param {string} id primary key of record which should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(body, id, options) {
            return (0, exports.TopicsApiFp)(configuration).updateTopic(body, id, options)(fetch, basePath);
        },
    };
};
exports.TopicsApiFactory = TopicsApiFactory;
/**
 * TopicsApi - object-oriented interface
 * @export
 * @class TopicsApi
 * @extends {BaseAPI}
 */
class TopicsApi extends BaseAPI {
    /**
     *
     * @summary endpoint to create topic
     * @param {TopicForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    createTopic(body, options) {
        return (0, exports.TopicsApiFp)(this.configuration).createTopic(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary authorized endpoint to delete topics
     * @param {string} id primary key of record which should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    deleteTopic(id, options) {
        return (0, exports.TopicsApiFp)(this.configuration).deleteTopic(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to get topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    getTopics(options) {
        return (0, exports.TopicsApiFp)(this.configuration).getTopics(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary endpoint to update topic
     * @param {TopicForm} body
     * @param {string} id primary key of record which should be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    updateTopic(body, id, options) {
        return (0, exports.TopicsApiFp)(this.configuration).updateTopic(body, id, options)(this.fetch, this.basePath);
    }
}
exports.TopicsApi = TopicsApi;
/**
 * UnreadApi - fetch parameter creator
 * @export
 */
const UnreadApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get unread counters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCounters(options = {}) {
            const localVarPath = `/unread`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UnreadApiFetchParamCreator = UnreadApiFetchParamCreator;
/**
 * UnreadApi - functional programming interface
 * @export
 */
const UnreadApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get unread counters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCounters(options) {
            const localVarFetchArgs = (0, exports.UnreadApiFetchParamCreator)(configuration).getUnreadCounters(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.UnreadApiFp = UnreadApiFp;
/**
 * UnreadApi - factory interface
 * @export
 */
const UnreadApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Get unread counters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCounters(options) {
            return (0, exports.UnreadApiFp)(configuration).getUnreadCounters(options)(fetch, basePath);
        },
    };
};
exports.UnreadApiFactory = UnreadApiFactory;
/**
 * UnreadApi - object-oriented interface
 * @export
 * @class UnreadApi
 * @extends {BaseAPI}
 */
class UnreadApi extends BaseAPI {
    /**
     *
     * @summary Get unread counters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnreadApi
     */
    getUnreadCounters(options) {
        return (0, exports.UnreadApiFp)(this.configuration).getUnreadCounters(options)(this.fetch, this.basePath);
    }
}
exports.UnreadApi = UnreadApi;
/**
 * UrlTagMappingsApi - fetch parameter creator
 * @export
 */
const UrlTagMappingsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary unauthorized endpoint to retrieve data about url-tag mappings for given orgId
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlTagMappingsUnauthorized(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getUrlTagMappingsUnauthorized.');
            }
            const localVarPath = `/url-tag-mappings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UrlTagMappingsApiFetchParamCreator = UrlTagMappingsApiFetchParamCreator;
/**
 * UrlTagMappingsApi - functional programming interface
 * @export
 */
const UrlTagMappingsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary unauthorized endpoint to retrieve data about url-tag mappings for given orgId
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlTagMappingsUnauthorized(orgId, options) {
            const localVarFetchArgs = (0, exports.UrlTagMappingsApiFetchParamCreator)(configuration).getUrlTagMappingsUnauthorized(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.UrlTagMappingsApiFp = UrlTagMappingsApiFp;
/**
 * UrlTagMappingsApi - factory interface
 * @export
 */
const UrlTagMappingsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary unauthorized endpoint to retrieve data about url-tag mappings for given orgId
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlTagMappingsUnauthorized(orgId, options) {
            return (0, exports.UrlTagMappingsApiFp)(configuration).getUrlTagMappingsUnauthorized(orgId, options)(fetch, basePath);
        },
    };
};
exports.UrlTagMappingsApiFactory = UrlTagMappingsApiFactory;
/**
 * UrlTagMappingsApi - object-oriented interface
 * @export
 * @class UrlTagMappingsApi
 * @extends {BaseAPI}
 */
class UrlTagMappingsApi extends BaseAPI {
    /**
     *
     * @summary unauthorized endpoint to retrieve data about url-tag mappings for given orgId
     * @param {string} orgId orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrlTagMappingsApi
     */
    getUrlTagMappingsUnauthorized(orgId, options) {
        return (0, exports.UrlTagMappingsApiFp)(this.configuration).getUrlTagMappingsUnauthorized(orgId, options)(this.fetch, this.basePath);
    }
}
exports.UrlTagMappingsApi = UrlTagMappingsApi;
/**
 * UsersApi - fetch parameter creator
 * @export
 */
const UsersApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Cancel meeting using token
         * @param {GuestMeetingToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeetingToken(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling cancelMeetingToken.');
            }
            const localVarPath = `/users/guest/cancelMeeting`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("GuestMeetingToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Change password
         * @param {PasswordChangeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling changePassword.');
            }
            const localVarPath = `/users/password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PasswordChangeForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Authenticate token to continue conversation
         * @param {ConversationToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueConversation(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling continueConversation.');
            }
            const localVarPath = `/users/guest/conversation/continue`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ConversationToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send continue conversation link
         * @param {LeadContinueConversation} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueConversationLink(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling continueConversationLink.');
            }
            const localVarPath = `/users/conversation/link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("LeadContinueConversation" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create agent avatar handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAvatarHandle(options = {}) {
            const localVarPath = `/users/agent/avatar`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a Lekta user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLekta(options = {}) {
            const localVarPath = `/users/lekta`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication orgAuth required
            // http basic authentication required
            if (configuration && (configuration.username || configuration.password)) {
                localVarHeaderParameter["Authorization"] = "Basic " + btoa(configuration.username + ":" + configuration.password);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deactivate adviser account
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAdviser(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deactivateAdviser.');
            }
            const localVarPath = `/users/agents/{id}/remove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore org-level limit for a number of auto-assigned conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAutoAssignedLimit(options = {}) {
            const localVarPath = `/users/agent/limit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary delete avatar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAvatar(options = {}) {
            const localVarPath = `/users/agent/avatar`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Anonymize customer profile
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(customerId, options = {}) {
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling deleteCustomer.');
            }
            const localVarPath = `/users/guest/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get agent preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentPreferences(options = {}) {
            const localVarPath = `/users/agent/preferences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get agent profile.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getAgentProfile.');
            }
            const localVarPath = `/users/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get agents profiles within org.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsProfiles(options = {}) {
            const localVarPath = `/users/agents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get agent's metrics (average agent's time of response for the first message from client)
         * @param {number} assignedFrom beginning of time section to search in (timestamp/long number)
         * @param {number} assignedTo end of time section to search in (timestamp/long number)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageResponseTime(assignedFrom, assignedTo, options = {}) {
            // verify required parameter 'assignedFrom' is not null or undefined
            if (assignedFrom === null || assignedFrom === undefined) {
                throw new RequiredError('assignedFrom', 'Required parameter assignedFrom was null or undefined when calling getAverageResponseTime.');
            }
            // verify required parameter 'assignedTo' is not null or undefined
            if (assignedTo === null || assignedTo === undefined) {
                throw new RequiredError('assignedTo', 'Required parameter assignedTo was null or undefined when calling getAverageResponseTime.');
            }
            const localVarPath = `/agents/metrics/{assignedFrom}/{assignedTo}`
                .replace(`{${"assignedFrom"}}`, encodeURIComponent(String(assignedFrom)))
                .replace(`{${"assignedTo"}}`, encodeURIComponent(String(assignedTo)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get bot profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotAgentProfile(options = {}) {
            const localVarPath = `/users/bot`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get adviser's cobrowse jwt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCobrowseJwt(options = {}) {
            const localVarPath = `/users/agent/cobrowse-jwt`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get deactivated advisers profiles within org.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeactivatedAdvisers(options = {}) {
            const localVarPath = `/users/agents/inactive`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get adviser assigned to guest room
         * @param {string} orgId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestAssignee(orgId, id, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getGuestAssignee.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getGuestAssignee.');
            }
            const localVarPath = `/users/guest/{id}/assignee/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get guest profile.
         * @param {string} orgId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfile(orgId, id, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getGuestProfile.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getGuestProfile.');
            }
            const localVarPath = `/users/guest/{id}/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get guest profile by apiKey
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfileByApiKey(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getGuestProfileByApiKey.');
            }
            const localVarPath = `/users/guest/profile/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get limited adviser profile.
         * @param {string} adviserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimitedAgentProfile(adviserId, options = {}) {
            // verify required parameter 'adviserId' is not null or undefined
            if (adviserId === null || adviserId === undefined) {
                throw new RequiredError('adviserId', 'Required parameter adviserId was null or undefined when calling getLimitedAgentProfile.');
            }
            const localVarPath = `/users/agents/{adviserId}/customer`
                .replace(`{${"adviserId"}}`, encodeURIComponent(String(adviserId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get limited advisers profiles within org.
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimitedAgentsProfiles(orgId, options = {}) {
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getLimitedAgentsProfiles.');
            }
            const localVarPath = `/users/agents/customer/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get own agent context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnAgentContext(options = {}) {
            const localVarPath = `/users/agent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Authenticate guest token to join meeting
         * @param {GuestMeetingToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling joinMeeting.');
            }
            const localVarPath = `/users/guest/joinMeeting`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("GuestMeetingToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary update adviser
         * @param {AdviserPatchForm} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdviser(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAdviser.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchAdviser.');
            }
            const localVarPath = `/advisers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AdviserPatchForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Batch update advisers
         * @param {Array<AdviserBatchPatchForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvisers(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAdvisers.');
            }
            const localVarPath = `/advisers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Array&lt;AdviserBatchPatchForm&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Partially update the preferences
         * @param {PreferencesForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentPreferences(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAgentPreferences.');
            }
            const localVarPath = `/users/agent/preferences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PreferencesForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Partialy update guest profile.
         * @param {GuestProfileFormPatch} body
         * @param {string} orgId
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGuestProfile(body, orgId, customerId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchGuestProfile.');
            }
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling patchGuestProfile.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling patchGuestProfile.');
            }
            const localVarPath = `/agents/customer/{customerId}/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("GuestProfileFormPatch" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Replace or fully update preferences
         * @param {AgentPreferences} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAgentPreferences(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling putAgentPreferences.');
            }
            const localVarPath = `/users/agent/preferences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgentPreferences" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reinit customer
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinitCustomer(customerId, options = {}) {
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling reinitCustomer.');
            }
            const localVarPath = `/users/guest/{customerId}/reinit`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            // authentication secondaryApiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Secondary-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Secondary-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore deactivated adviser account
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAdviser(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling restoreAdviser.');
            }
            const localVarPath = `/users/agents/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search advisers
         * @param {SearchAdviserForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdvisers(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling searchAdvisers.');
            }
            const localVarPath = `/users/advisers/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SearchAdviserForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search for an agent.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgent(query, options = {}) {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query', 'Required parameter query was null or undefined when calling searchAgent.');
            }
            const localVarPath = `/users/agent/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search for a guest.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGuest(query, options = {}) {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query', 'Required parameter query was null or undefined when calling searchGuest.');
            }
            const localVarPath = `/users/guest/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Override org limit for a number of auto-assigned conversations.
         * @param {AgentAutoAssignedLimit} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentAutoAssignedLimit(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAgentAutoAssignedLimit.');
            }
            const localVarPath = `/users/agent/limit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgentAutoAssignedLimit" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set agent pending email and send an email with confirmation link
         * @param {AgentPendingEmail} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentPendingEmail(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAgentPendingEmail.');
            }
            const localVarPath = `/users/agent/email`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgentPendingEmail" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set presence of an agent.
         * @param {AgentPresence} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentPresence(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAgentPresence.');
            }
            const localVarPath = `/users/agent/presence`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgentPresence" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update agent's profile.
         * @param {AgentProfileForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentProfile(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAgentProfile.');
            }
            const localVarPath = `/users/agent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgentProfileForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set agreement with timestamp
         * @param {AgreementForm} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgreement(body, id, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAgreement.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling setAgreement.');
            }
            const localVarPath = `/users/guest/{id}/agreement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AgreementForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Authorize guest with oauth login hint token
         * @param {OauthSignInRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithOAuth(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling signInWithOAuth.');
            }
            const localVarPath = `/oauth/token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("OauthSignInRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sign up as a guest.
         * @param {SignUpGuest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpGuest(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling signUpGuest.');
            }
            const localVarPath = `/users/guest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SignUpGuest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the guest profile.
         * @param {GuestProfileFormPatch} body
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnGuestProfile(body, orgId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateOwnGuestProfile.');
            }
            // verify required parameter 'orgId' is not null or undefined
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling updateOwnGuestProfile.');
            }
            const localVarPath = `/users/guest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("GuestProfileFormPatch" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Validate phone number
         * @param {RawPhone} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePhone(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling validatePhone.');
            }
            const localVarPath = `/users/validatePhone`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RawPhone" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UsersApiFetchParamCreator = UsersApiFetchParamCreator;
/**
 * UsersApi - functional programming interface
 * @export
 */
const UsersApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Cancel meeting using token
         * @param {GuestMeetingToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeetingToken(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).cancelMeetingToken(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Change password
         * @param {PasswordChangeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).changePassword(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Authenticate token to continue conversation
         * @param {ConversationToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueConversation(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).continueConversation(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Send continue conversation link
         * @param {LeadContinueConversation} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueConversationLink(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).continueConversationLink(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create agent avatar handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAvatarHandle(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).createAgentAvatarHandle(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create a Lekta user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLekta(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).createLekta(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Deactivate adviser account
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAdviser(id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).deactivateAdviser(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Restore org-level limit for a number of auto-assigned conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAutoAssignedLimit(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).deleteAgentAutoAssignedLimit(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary delete avatar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAvatar(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).deleteAgentAvatar(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Anonymize customer profile
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(customerId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).deleteCustomer(customerId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get agent preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentPreferences(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getAgentPreferences(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get agent profile.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile(id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getAgentProfile(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get agents profiles within org.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsProfiles(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getAgentsProfiles(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get agent's metrics (average agent's time of response for the first message from client)
         * @param {number} assignedFrom beginning of time section to search in (timestamp/long number)
         * @param {number} assignedTo end of time section to search in (timestamp/long number)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageResponseTime(assignedFrom, assignedTo, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getAverageResponseTime(assignedFrom, assignedTo, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get bot profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotAgentProfile(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getBotAgentProfile(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get adviser's cobrowse jwt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCobrowseJwt(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getCobrowseJwt(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get deactivated advisers profiles within org.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeactivatedAdvisers(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getDeactivatedAdvisers(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get adviser assigned to guest room
         * @param {string} orgId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestAssignee(orgId, id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getGuestAssignee(orgId, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get guest profile.
         * @param {string} orgId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfile(orgId, id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getGuestProfile(orgId, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get guest profile by apiKey
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfileByApiKey(orgId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getGuestProfileByApiKey(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get limited adviser profile.
         * @param {string} adviserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimitedAgentProfile(adviserId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getLimitedAgentProfile(adviserId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get limited advisers profiles within org.
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimitedAgentsProfiles(orgId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getLimitedAgentsProfiles(orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get own agent context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnAgentContext(options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getOwnAgentContext(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Authenticate guest token to join meeting
         * @param {GuestMeetingToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).joinMeeting(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary update adviser
         * @param {AdviserPatchForm} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdviser(body, id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).patchAdviser(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Batch update advisers
         * @param {Array<AdviserBatchPatchForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvisers(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).patchAdvisers(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Partially update the preferences
         * @param {PreferencesForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentPreferences(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).patchAgentPreferences(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Partialy update guest profile.
         * @param {GuestProfileFormPatch} body
         * @param {string} orgId
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGuestProfile(body, orgId, customerId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).patchGuestProfile(body, orgId, customerId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Replace or fully update preferences
         * @param {AgentPreferences} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAgentPreferences(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).putAgentPreferences(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Reinit customer
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinitCustomer(customerId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).reinitCustomer(customerId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Restore deactivated adviser account
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAdviser(id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).restoreAdviser(id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Search advisers
         * @param {SearchAdviserForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdvisers(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).searchAdvisers(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Search for an agent.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgent(query, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).searchAgent(query, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Search for a guest.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGuest(query, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).searchGuest(query, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Override org limit for a number of auto-assigned conversations.
         * @param {AgentAutoAssignedLimit} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentAutoAssignedLimit(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setAgentAutoAssignedLimit(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set agent pending email and send an email with confirmation link
         * @param {AgentPendingEmail} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentPendingEmail(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setAgentPendingEmail(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set presence of an agent.
         * @param {AgentPresence} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentPresence(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setAgentPresence(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update agent's profile.
         * @param {AgentProfileForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentProfile(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setAgentProfile(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Set agreement with timestamp
         * @param {AgreementForm} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgreement(body, id, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setAgreement(body, id, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Authorize guest with oauth login hint token
         * @param {OauthSignInRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithOAuth(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).signInWithOAuth(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Sign up as a guest.
         * @param {SignUpGuest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpGuest(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).signUpGuest(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Update the guest profile.
         * @param {GuestProfileFormPatch} body
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnGuestProfile(body, orgId, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).updateOwnGuestProfile(body, orgId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Validate phone number
         * @param {RawPhone} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePhone(body, options) {
            const localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).validatePhone(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 * @export
 */
const UsersApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Cancel meeting using token
         * @param {GuestMeetingToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMeetingToken(body, options) {
            return (0, exports.UsersApiFp)(configuration).cancelMeetingToken(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Change password
         * @param {PasswordChangeForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(body, options) {
            return (0, exports.UsersApiFp)(configuration).changePassword(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Authenticate token to continue conversation
         * @param {ConversationToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueConversation(body, options) {
            return (0, exports.UsersApiFp)(configuration).continueConversation(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Send continue conversation link
         * @param {LeadContinueConversation} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueConversationLink(body, options) {
            return (0, exports.UsersApiFp)(configuration).continueConversationLink(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create agent avatar handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAvatarHandle(options) {
            return (0, exports.UsersApiFp)(configuration).createAgentAvatarHandle(options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a Lekta user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLekta(options) {
            return (0, exports.UsersApiFp)(configuration).createLekta(options)(fetch, basePath);
        },
        /**
         *
         * @summary Deactivate adviser account
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateAdviser(id, options) {
            return (0, exports.UsersApiFp)(configuration).deactivateAdviser(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Restore org-level limit for a number of auto-assigned conversations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAutoAssignedLimit(options) {
            return (0, exports.UsersApiFp)(configuration).deleteAgentAutoAssignedLimit(options)(fetch, basePath);
        },
        /**
         *
         * @summary delete avatar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAvatar(options) {
            return (0, exports.UsersApiFp)(configuration).deleteAgentAvatar(options)(fetch, basePath);
        },
        /**
         *
         * @summary Anonymize customer profile
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(customerId, options) {
            return (0, exports.UsersApiFp)(configuration).deleteCustomer(customerId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get agent preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentPreferences(options) {
            return (0, exports.UsersApiFp)(configuration).getAgentPreferences(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get agent profile.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile(id, options) {
            return (0, exports.UsersApiFp)(configuration).getAgentProfile(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get agents profiles within org.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsProfiles(options) {
            return (0, exports.UsersApiFp)(configuration).getAgentsProfiles(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get agent's metrics (average agent's time of response for the first message from client)
         * @param {number} assignedFrom beginning of time section to search in (timestamp/long number)
         * @param {number} assignedTo end of time section to search in (timestamp/long number)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageResponseTime(assignedFrom, assignedTo, options) {
            return (0, exports.UsersApiFp)(configuration).getAverageResponseTime(assignedFrom, assignedTo, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get bot profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotAgentProfile(options) {
            return (0, exports.UsersApiFp)(configuration).getBotAgentProfile(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get adviser's cobrowse jwt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCobrowseJwt(options) {
            return (0, exports.UsersApiFp)(configuration).getCobrowseJwt(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get deactivated advisers profiles within org.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeactivatedAdvisers(options) {
            return (0, exports.UsersApiFp)(configuration).getDeactivatedAdvisers(options)(fetch, basePath);
        },
        /**
         *
         * @summary Get adviser assigned to guest room
         * @param {string} orgId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestAssignee(orgId, id, options) {
            return (0, exports.UsersApiFp)(configuration).getGuestAssignee(orgId, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get guest profile.
         * @param {string} orgId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfile(orgId, id, options) {
            return (0, exports.UsersApiFp)(configuration).getGuestProfile(orgId, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get guest profile by apiKey
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuestProfileByApiKey(orgId, options) {
            return (0, exports.UsersApiFp)(configuration).getGuestProfileByApiKey(orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get limited adviser profile.
         * @param {string} adviserId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimitedAgentProfile(adviserId, options) {
            return (0, exports.UsersApiFp)(configuration).getLimitedAgentProfile(adviserId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get limited advisers profiles within org.
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLimitedAgentsProfiles(orgId, options) {
            return (0, exports.UsersApiFp)(configuration).getLimitedAgentsProfiles(orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get own agent context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnAgentContext(options) {
            return (0, exports.UsersApiFp)(configuration).getOwnAgentContext(options)(fetch, basePath);
        },
        /**
         *
         * @summary Authenticate guest token to join meeting
         * @param {GuestMeetingToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting(body, options) {
            return (0, exports.UsersApiFp)(configuration).joinMeeting(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary update adviser
         * @param {AdviserPatchForm} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdviser(body, id, options) {
            return (0, exports.UsersApiFp)(configuration).patchAdviser(body, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Batch update advisers
         * @param {Array<AdviserBatchPatchForm>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvisers(body, options) {
            return (0, exports.UsersApiFp)(configuration).patchAdvisers(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Partially update the preferences
         * @param {PreferencesForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAgentPreferences(body, options) {
            return (0, exports.UsersApiFp)(configuration).patchAgentPreferences(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Partialy update guest profile.
         * @param {GuestProfileFormPatch} body
         * @param {string} orgId
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGuestProfile(body, orgId, customerId, options) {
            return (0, exports.UsersApiFp)(configuration).patchGuestProfile(body, orgId, customerId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Replace or fully update preferences
         * @param {AgentPreferences} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAgentPreferences(body, options) {
            return (0, exports.UsersApiFp)(configuration).putAgentPreferences(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Reinit customer
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reinitCustomer(customerId, options) {
            return (0, exports.UsersApiFp)(configuration).reinitCustomer(customerId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Restore deactivated adviser account
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreAdviser(id, options) {
            return (0, exports.UsersApiFp)(configuration).restoreAdviser(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Search advisers
         * @param {SearchAdviserForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdvisers(body, options) {
            return (0, exports.UsersApiFp)(configuration).searchAdvisers(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Search for an agent.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgent(query, options) {
            return (0, exports.UsersApiFp)(configuration).searchAgent(query, options)(fetch, basePath);
        },
        /**
         *
         * @summary Search for a guest.
         * @param {string} query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGuest(query, options) {
            return (0, exports.UsersApiFp)(configuration).searchGuest(query, options)(fetch, basePath);
        },
        /**
         *
         * @summary Override org limit for a number of auto-assigned conversations.
         * @param {AgentAutoAssignedLimit} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentAutoAssignedLimit(body, options) {
            return (0, exports.UsersApiFp)(configuration).setAgentAutoAssignedLimit(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set agent pending email and send an email with confirmation link
         * @param {AgentPendingEmail} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentPendingEmail(body, options) {
            return (0, exports.UsersApiFp)(configuration).setAgentPendingEmail(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set presence of an agent.
         * @param {AgentPresence} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentPresence(body, options) {
            return (0, exports.UsersApiFp)(configuration).setAgentPresence(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update agent's profile.
         * @param {AgentProfileForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgentProfile(body, options) {
            return (0, exports.UsersApiFp)(configuration).setAgentProfile(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Set agreement with timestamp
         * @param {AgreementForm} body
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAgreement(body, id, options) {
            return (0, exports.UsersApiFp)(configuration).setAgreement(body, id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Authorize guest with oauth login hint token
         * @param {OauthSignInRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithOAuth(body, options) {
            return (0, exports.UsersApiFp)(configuration).signInWithOAuth(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Sign up as a guest.
         * @param {SignUpGuest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpGuest(body, options) {
            return (0, exports.UsersApiFp)(configuration).signUpGuest(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary Update the guest profile.
         * @param {GuestProfileFormPatch} body
         * @param {string} orgId orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnGuestProfile(body, orgId, options) {
            return (0, exports.UsersApiFp)(configuration).updateOwnGuestProfile(body, orgId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Validate phone number
         * @param {RawPhone} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePhone(body, options) {
            return (0, exports.UsersApiFp)(configuration).validatePhone(body, options)(fetch, basePath);
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
class UsersApi extends BaseAPI {
    /**
     *
     * @summary Cancel meeting using token
     * @param {GuestMeetingToken} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    cancelMeetingToken(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).cancelMeetingToken(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Change password
     * @param {PasswordChangeForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    changePassword(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).changePassword(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Authenticate token to continue conversation
     * @param {ConversationToken} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    continueConversation(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).continueConversation(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Send continue conversation link
     * @param {LeadContinueConversation} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    continueConversationLink(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).continueConversationLink(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create agent avatar handle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createAgentAvatarHandle(options) {
        return (0, exports.UsersApiFp)(this.configuration).createAgentAvatarHandle(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create a Lekta user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createLekta(options) {
        return (0, exports.UsersApiFp)(this.configuration).createLekta(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Deactivate adviser account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deactivateAdviser(id, options) {
        return (0, exports.UsersApiFp)(this.configuration).deactivateAdviser(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Restore org-level limit for a number of auto-assigned conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteAgentAutoAssignedLimit(options) {
        return (0, exports.UsersApiFp)(this.configuration).deleteAgentAutoAssignedLimit(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary delete avatar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteAgentAvatar(options) {
        return (0, exports.UsersApiFp)(this.configuration).deleteAgentAvatar(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Anonymize customer profile
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteCustomer(customerId, options) {
        return (0, exports.UsersApiFp)(this.configuration).deleteCustomer(customerId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get agent preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAgentPreferences(options) {
        return (0, exports.UsersApiFp)(this.configuration).getAgentPreferences(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get agent profile.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAgentProfile(id, options) {
        return (0, exports.UsersApiFp)(this.configuration).getAgentProfile(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get agents profiles within org.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAgentsProfiles(options) {
        return (0, exports.UsersApiFp)(this.configuration).getAgentsProfiles(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get agent's metrics (average agent's time of response for the first message from client)
     * @param {number} assignedFrom beginning of time section to search in (timestamp/long number)
     * @param {number} assignedTo end of time section to search in (timestamp/long number)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAverageResponseTime(assignedFrom, assignedTo, options) {
        return (0, exports.UsersApiFp)(this.configuration).getAverageResponseTime(assignedFrom, assignedTo, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get bot profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getBotAgentProfile(options) {
        return (0, exports.UsersApiFp)(this.configuration).getBotAgentProfile(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get adviser's cobrowse jwt.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getCobrowseJwt(options) {
        return (0, exports.UsersApiFp)(this.configuration).getCobrowseJwt(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get deactivated advisers profiles within org.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getDeactivatedAdvisers(options) {
        return (0, exports.UsersApiFp)(this.configuration).getDeactivatedAdvisers(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get adviser assigned to guest room
     * @param {string} orgId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getGuestAssignee(orgId, id, options) {
        return (0, exports.UsersApiFp)(this.configuration).getGuestAssignee(orgId, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get guest profile.
     * @param {string} orgId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getGuestProfile(orgId, id, options) {
        return (0, exports.UsersApiFp)(this.configuration).getGuestProfile(orgId, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get guest profile by apiKey
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getGuestProfileByApiKey(orgId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getGuestProfileByApiKey(orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get limited adviser profile.
     * @param {string} adviserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getLimitedAgentProfile(adviserId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getLimitedAgentProfile(adviserId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get limited advisers profiles within org.
     * @param {string} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getLimitedAgentsProfiles(orgId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getLimitedAgentsProfiles(orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get own agent context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getOwnAgentContext(options) {
        return (0, exports.UsersApiFp)(this.configuration).getOwnAgentContext(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Authenticate guest token to join meeting
     * @param {GuestMeetingToken} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    joinMeeting(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).joinMeeting(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary update adviser
     * @param {AdviserPatchForm} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    patchAdviser(body, id, options) {
        return (0, exports.UsersApiFp)(this.configuration).patchAdviser(body, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Batch update advisers
     * @param {Array<AdviserBatchPatchForm>} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    patchAdvisers(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).patchAdvisers(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Partially update the preferences
     * @param {PreferencesForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    patchAgentPreferences(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).patchAgentPreferences(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Partialy update guest profile.
     * @param {GuestProfileFormPatch} body
     * @param {string} orgId
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    patchGuestProfile(body, orgId, customerId, options) {
        return (0, exports.UsersApiFp)(this.configuration).patchGuestProfile(body, orgId, customerId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Replace or fully update preferences
     * @param {AgentPreferences} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    putAgentPreferences(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).putAgentPreferences(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Reinit customer
     * @param {string} customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    reinitCustomer(customerId, options) {
        return (0, exports.UsersApiFp)(this.configuration).reinitCustomer(customerId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Restore deactivated adviser account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    restoreAdviser(id, options) {
        return (0, exports.UsersApiFp)(this.configuration).restoreAdviser(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Search advisers
     * @param {SearchAdviserForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    searchAdvisers(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).searchAdvisers(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Search for an agent.
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    searchAgent(query, options) {
        return (0, exports.UsersApiFp)(this.configuration).searchAgent(query, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Search for a guest.
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    searchGuest(query, options) {
        return (0, exports.UsersApiFp)(this.configuration).searchGuest(query, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Override org limit for a number of auto-assigned conversations.
     * @param {AgentAutoAssignedLimit} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAgentAutoAssignedLimit(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).setAgentAutoAssignedLimit(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set agent pending email and send an email with confirmation link
     * @param {AgentPendingEmail} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAgentPendingEmail(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).setAgentPendingEmail(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set presence of an agent.
     * @param {AgentPresence} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAgentPresence(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).setAgentPresence(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update agent's profile.
     * @param {AgentProfileForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAgentProfile(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).setAgentProfile(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Set agreement with timestamp
     * @param {AgreementForm} body
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setAgreement(body, id, options) {
        return (0, exports.UsersApiFp)(this.configuration).setAgreement(body, id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Authorize guest with oauth login hint token
     * @param {OauthSignInRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    signInWithOAuth(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).signInWithOAuth(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Sign up as a guest.
     * @param {SignUpGuest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    signUpGuest(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).signUpGuest(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Update the guest profile.
     * @param {GuestProfileFormPatch} body
     * @param {string} orgId orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateOwnGuestProfile(body, orgId, options) {
        return (0, exports.UsersApiFp)(this.configuration).updateOwnGuestProfile(body, orgId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Validate phone number
     * @param {RawPhone} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    validatePhone(body, options) {
        return (0, exports.UsersApiFp)(this.configuration).validatePhone(body, options)(this.fetch, this.basePath);
    }
}
exports.UsersApi = UsersApi;
/**
 * WebhooksApi - fetch parameter creator
 * @export
 */
const WebhooksApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get webhooks config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhooks(options = {}) {
            const localVarPath = `/webhooks`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary put webhooks config
         * @param {WebhooksDTO} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhooks(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateWebhooks.');
            }
            const localVarPath = `/webhooks`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("WebhooksDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WebhooksApiFetchParamCreator = WebhooksApiFetchParamCreator;
/**
 * WebhooksApi - functional programming interface
 * @export
 */
const WebhooksApiFp = function (configuration) {
    return {
        /**
         *
         * @summary get webhooks config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhooks(options) {
            const localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).getWebhooks(options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary put webhooks config
         * @param {WebhooksDTO} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhooks(body, options) {
            const localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).updateWebhooks(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WebhooksApiFp = WebhooksApiFp;
/**
 * WebhooksApi - factory interface
 * @export
 */
const WebhooksApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary get webhooks config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhooks(options) {
            return (0, exports.WebhooksApiFp)(configuration).getWebhooks(options)(fetch, basePath);
        },
        /**
         *
         * @summary put webhooks config
         * @param {WebhooksDTO} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhooks(body, options) {
            return (0, exports.WebhooksApiFp)(configuration).updateWebhooks(body, options)(fetch, basePath);
        },
    };
};
exports.WebhooksApiFactory = WebhooksApiFactory;
/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
class WebhooksApi extends BaseAPI {
    /**
     *
     * @summary get webhooks config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    getWebhooks(options) {
        return (0, exports.WebhooksApiFp)(this.configuration).getWebhooks(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary put webhooks config
     * @param {WebhooksDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    updateWebhooks(body, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).updateWebhooks(body, options)(this.fetch, this.basePath);
    }
}
exports.WebhooksApi = WebhooksApi;
/**
 * WidgetsFormsSubmissionsApi - fetch parameter creator
 * @export
 */
const WidgetsFormsSubmissionsApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary create form for room
         * @param {AddWidgetForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetFormForRoomId(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createWidgetFormForRoomId.');
            }
            const localVarPath = `/widgets-forms-submissions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AddWidgetForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary get form with widget
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetFormByFormId(formId, options = {}) {
            // verify required parameter 'formId' is not null or undefined
            if (formId === null || formId === undefined) {
                throw new RequiredError('formId', 'Required parameter formId was null or undefined when calling getWidgetFormByFormId.');
            }
            const localVarPath = `/widgets-forms-submissions/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary submit form
         * @param {SubmitWidgetForm} body
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWidgetForm(body, formId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling submitWidgetForm.');
            }
            // verify required parameter 'formId' is not null or undefined
            if (formId === null || formId === undefined) {
                throw new RequiredError('formId', 'Required parameter formId was null or undefined when calling submitWidgetForm.');
            }
            const localVarPath = `/widgets-forms-submissions/{formId}/submit`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Api-Key")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Api-Key"] = localVarApiKeyValue;
            }
            // authentication fingerprintAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-Fingerprint")
                    : configuration.apiKey;
                localVarHeaderParameter["X-Fingerprint"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SubmitWidgetForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WidgetsFormsSubmissionsApiFetchParamCreator = WidgetsFormsSubmissionsApiFetchParamCreator;
/**
 * WidgetsFormsSubmissionsApi - functional programming interface
 * @export
 */
const WidgetsFormsSubmissionsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary create form for room
         * @param {AddWidgetForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetFormForRoomId(body, options) {
            const localVarFetchArgs = (0, exports.WidgetsFormsSubmissionsApiFetchParamCreator)(configuration).createWidgetFormForRoomId(body, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary get form with widget
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetFormByFormId(formId, options) {
            const localVarFetchArgs = (0, exports.WidgetsFormsSubmissionsApiFetchParamCreator)(configuration).getWidgetFormByFormId(formId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary submit form
         * @param {SubmitWidgetForm} body
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWidgetForm(body, formId, options) {
            const localVarFetchArgs = (0, exports.WidgetsFormsSubmissionsApiFetchParamCreator)(configuration).submitWidgetForm(body, formId, options);
            return (fetch = isomorphicFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WidgetsFormsSubmissionsApiFp = WidgetsFormsSubmissionsApiFp;
/**
 * WidgetsFormsSubmissionsApi - factory interface
 * @export
 */
const WidgetsFormsSubmissionsApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary create form for room
         * @param {AddWidgetForm} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidgetFormForRoomId(body, options) {
            return (0, exports.WidgetsFormsSubmissionsApiFp)(configuration).createWidgetFormForRoomId(body, options)(fetch, basePath);
        },
        /**
         *
         * @summary get form with widget
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetFormByFormId(formId, options) {
            return (0, exports.WidgetsFormsSubmissionsApiFp)(configuration).getWidgetFormByFormId(formId, options)(fetch, basePath);
        },
        /**
         *
         * @summary submit form
         * @param {SubmitWidgetForm} body
         * @param {string} formId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWidgetForm(body, formId, options) {
            return (0, exports.WidgetsFormsSubmissionsApiFp)(configuration).submitWidgetForm(body, formId, options)(fetch, basePath);
        },
    };
};
exports.WidgetsFormsSubmissionsApiFactory = WidgetsFormsSubmissionsApiFactory;
/**
 * WidgetsFormsSubmissionsApi - object-oriented interface
 * @export
 * @class WidgetsFormsSubmissionsApi
 * @extends {BaseAPI}
 */
class WidgetsFormsSubmissionsApi extends BaseAPI {
    /**
     *
     * @summary create form for room
     * @param {AddWidgetForm} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsFormsSubmissionsApi
     */
    createWidgetFormForRoomId(body, options) {
        return (0, exports.WidgetsFormsSubmissionsApiFp)(this.configuration).createWidgetFormForRoomId(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary get form with widget
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsFormsSubmissionsApi
     */
    getWidgetFormByFormId(formId, options) {
        return (0, exports.WidgetsFormsSubmissionsApiFp)(this.configuration).getWidgetFormByFormId(formId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary submit form
     * @param {SubmitWidgetForm} body
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsFormsSubmissionsApi
     */
    submitWidgetForm(body, formId, options) {
        return (0, exports.WidgetsFormsSubmissionsApiFp)(this.configuration).submitWidgetForm(body, formId, options)(this.fetch, this.basePath);
    }
}
exports.WidgetsFormsSubmissionsApi = WidgetsFormsSubmissionsApi;
